/*
 * SupportV2 Messages
 *
 * The labels of the /supportv2 contact form. Questions, options and answers are keyed from their
 * ids by messageKey (taxonomy.ts); the answers along the way by help.ts.
 */

import { defineMessages } from 'react-intl';

export const supportV2Scope = 'app.containers.SupportV2';

export const supportV2Messages = {
  pageTitle: {
    id: `${supportV2Scope}.pageTitle`,
    defaultMessage: 'Contacter le support',
    en: 'Contact support',
    it: "Contattare l'assistenza",
    es: 'Contactar con el soporte',
    de: 'Support kontaktieren',
    nl: 'Contact opnemen met support',
  },
  next: {
    id: `${supportV2Scope}.next`,
    defaultMessage: 'Continuer',
    en: 'Continue',
    it: 'Continua',
    es: 'Continuar',
    de: 'Weiter',
    nl: 'Doorgaan',
  },
  back: {
    id: `${supportV2Scope}.back`,
    defaultMessage: 'Retour',
    en: 'Back',
    it: 'Indietro',
    es: 'Volver',
    de: 'Zurück',
    nl: 'Terug',
  },
  contactTitle: {
    id: `${supportV2Scope}.contactTitle`,
    defaultMessage: 'Vos coordonnées et votre demande',
    en: 'Your details and your request',
    it: 'I tuoi dati e la tua richiesta',
    es: 'Tus datos y tu solicitud',
    de: 'Ihre Kontaktdaten und Ihre Anfrage',
    nl: 'Uw gegevens en uw verzoek',
  },
  email: {
    id: `${supportV2Scope}.email`,
    defaultMessage: 'Email pour vous répondre',
    en: 'Email we should reply to',
    it: 'Email per risponderti',
    es: 'Correo electrónico para responderte',
    de: 'E-Mail-Adresse für unsere Antwort',
    nl: 'E-mailadres voor ons antwoord',
  },
  description: {
    id: `${supportV2Scope}.description`,
    defaultMessage: 'Décrivez votre demande',
    en: 'Describe your request',
    it: 'Descrivi la tua richiesta',
    es: 'Describe tu solicitud',
    de: 'Beschreiben Sie Ihre Anfrage',
    nl: 'Beschrijf uw verzoek',
  },
  tripTitle: {
    id: `${supportV2Scope}.tripTitle`,
    defaultMessage: 'Votre voyage',
    en: 'Your trip',
    it: 'Il tuo viaggio',
    es: 'Tu viaje',
    de: 'Ihre Reise',
    nl: 'Uw reis',
  },
  tripHint: {
    id: `${supportV2Scope}.tripHint`,
    defaultMessage:
      "Renseignez ce que vous savez : aucun de ces champs n'est obligatoire.",
    en: 'Fill in what you know: none of these fields is required.',
    it: 'Compila ciò che sai: nessuno di questi campi è obbligatorio.',
    es: 'Rellena lo que sepas: ninguno de estos campos es obligatorio.',
    de: 'Geben Sie an, was Sie wissen: Keines dieser Felder ist Pflicht.',
    nl: 'Vul in wat u weet: geen van deze velden is verplicht.',
  },
  orderId: {
    id: `${supportV2Scope}.orderId`,
    defaultMessage: 'Numéro de commande',
    en: 'Order number',
    it: "Numero d'ordine",
    es: 'Número de pedido',
    de: 'Bestellnummer',
    nl: 'Bestelnummer',
  },
  orderIdHint: {
    id: `${supportV2Scope}.orderIdHint`,
    defaultMessage: "Il figure dans l'email de confirmation de votre achat.",
    en: 'You will find it in your purchase confirmation email.',
    it: "Si trova nell'email di conferma dell'acquisto.",
    es: 'Aparece en el correo de confirmación de tu compra.',
    de: 'Sie finden sie in der Bestätigungs-E-Mail Ihres Kaufs.',
    nl: 'U vindt het in de bevestigingsmail van uw aankoop.',
  },
  declaredOrigin: {
    id: `${supportV2Scope}.declaredOrigin`,
    defaultMessage: 'Départ',
    en: 'From',
    it: 'Partenza',
    es: 'Salida',
    de: 'Abfahrt',
    nl: 'Vertrek',
  },
  declaredDestination: {
    id: `${supportV2Scope}.declaredDestination`,
    defaultMessage: 'Arrivée',
    en: 'To',
    it: 'Arrivo',
    es: 'Llegada',
    de: 'Ankunft',
    nl: 'Aankomst',
  },
  declaredDate: {
    id: `${supportV2Scope}.declaredDate`,
    defaultMessage: 'Date du voyage',
    en: 'Travel date',
    it: 'Data del viaggio',
    es: 'Fecha del viaje',
    de: 'Reisedatum',
    nl: 'Reisdatum',
  },
  declaredSeller: {
    id: `${supportV2Scope}.declaredSeller`,
    defaultMessage: 'Où avez-vous acheté ce billet ?',
    en: 'Where did you buy this ticket?',
    it: 'Dove hai acquistato questo biglietto?',
    es: '¿Dónde compraste este billete?',
    de: 'Wo haben Sie dieses Ticket gekauft?',
    nl: 'Waar heeft u dit ticket gekocht?',
  },
  sellerTictactrip: {
    id: `${supportV2Scope}.sellerTictactrip`,
    defaultMessage: 'Sur Tictactrip',
    en: 'On Tictactrip',
    it: 'Su Tictactrip',
    es: 'En Tictactrip',
    de: 'Bei Tictactrip',
    nl: 'Bij Tictactrip',
  },
  sellerOther: {
    id: `${supportV2Scope}.sellerOther`,
    defaultMessage: 'Sur un autre site ou en gare',
    en: 'On another website or at the station',
    it: 'Su un altro sito o in stazione',
    es: 'En otra web o en la estación',
    de: 'Auf einer anderen Website oder am Bahnhof',
    nl: 'Op een andere website of op het station',
  },
  sellerUnknown: {
    id: `${supportV2Scope}.sellerUnknown`,
    defaultMessage: 'Je ne sais pas',
    en: "I don't know",
    it: 'Non lo so',
    es: 'No lo sé',
    de: 'Ich weiß es nicht',
    nl: 'Ik weet het niet',
  },
  detailsTitle: {
    id: `${supportV2Scope}.detailsTitle`,
    defaultMessage: 'Précisions utiles (facultatif)',
    en: 'Useful details (optional)',
    it: 'Dettagli utili (facoltativo)',
    es: 'Detalles útiles (opcional)',
    de: 'Nützliche Angaben (optional)',
    nl: 'Nuttige details (optioneel)',
  },
  filesHint: {
    id: `${supportV2Scope}.filesHint`,
    defaultMessage:
      'Images ou PDF, {maxFiles} fichiers de {maxSize} Mo au plus.',
    en: 'Images or PDF, up to {maxFiles} files of {maxSize} MB each.',
    it: 'Immagini o PDF, al massimo {maxFiles} file da {maxSize} MB.',
    es: 'Imágenes o PDF, hasta {maxFiles} archivos de {maxSize} MB.',
    de: 'Bilder oder PDF, höchstens {maxFiles} Dateien mit je {maxSize} MB.',
    nl: 'Afbeeldingen of pdf, maximaal {maxFiles} bestanden van {maxSize} MB.',
  },
  filesRejected: {
    id: `${supportV2Scope}.filesRejected`,
    defaultMessage:
      "Certains fichiers n'ont pas été ajoutés : seuls les images et PDF de {maxSize} Mo au plus sont acceptés, {maxFiles} au maximum.",
    en: 'Some files were not added: only images and PDFs of up to {maxSize} MB are accepted, {maxFiles} at most.',
    it: 'Alcuni file non sono stati aggiunti: sono accettati solo immagini e PDF fino a {maxSize} MB, al massimo {maxFiles}.',
    es: 'Algunos archivos no se han añadido: solo se aceptan imágenes y PDF de hasta {maxSize} MB, {maxFiles} como máximo.',
    de: 'Einige Dateien wurden nicht hinzugefügt: Nur Bilder und PDFs bis {maxSize} MB werden akzeptiert, höchstens {maxFiles}.',
    nl: "Sommige bestanden zijn niet toegevoegd: alleen afbeeldingen en pdf's tot {maxSize} MB worden geaccepteerd, maximaal {maxFiles}.",
  },
  review: {
    id: `${supportV2Scope}.review`,
    defaultMessage: 'Vérifier ma demande',
    en: 'Review my request',
    it: 'Verifica la mia richiesta',
    es: 'Revisar mi solicitud',
    de: 'Anfrage prüfen',
    nl: 'Mijn verzoek controleren',
  },
  summaryTitle: {
    id: `${supportV2Scope}.summaryTitle`,
    defaultMessage: 'Récapitulatif',
    en: 'Summary',
    it: 'Riepilogo',
    es: 'Resumen',
    de: 'Zusammenfassung',
    nl: 'Samenvatting',
  },
  edit: {
    id: `${supportV2Scope}.edit`,
    defaultMessage: 'Modifier',
    en: 'Edit',
    it: 'Modifica',
    es: 'Modificar',
    de: 'Bearbeiten',
    nl: 'Wijzigen',
  },
  send: {
    id: `${supportV2Scope}.send`,
    defaultMessage: 'Envoyer ma demande',
    en: 'Send my request',
    it: 'Invia la mia richiesta',
    es: 'Enviar mi solicitud',
    de: 'Anfrage senden',
    nl: 'Mijn verzoek versturen',
  },
  sending: {
    id: `${supportV2Scope}.sending`,
    defaultMessage: 'Envoi en cours…',
    en: 'Sending…',
    it: 'Invio in corso…',
    es: 'Enviando…',
    de: 'Wird gesendet…',
    nl: 'Bezig met versturen…',
  },
  sendError: {
    id: `${supportV2Scope}.sendError`,
    defaultMessage:
      "Votre demande n'a pas pu être envoyée. Vos informations sont conservées : vous pouvez réessayer.",
    en: 'Your request could not be sent. Your details are kept: you can try again.',
    it: 'Non è stato possibile inviare la tua richiesta. I tuoi dati sono conservati: puoi riprovare.',
    es: 'No se ha podido enviar tu solicitud. Tus datos se conservan: puedes volver a intentarlo.',
    de: 'Ihre Anfrage konnte nicht gesendet werden. Ihre Angaben bleiben erhalten: Sie können es erneut versuchen.',
    nl: 'Uw verzoek kon niet worden verstuurd. Uw gegevens blijven bewaard: u kunt het opnieuw proberen.',
  },
  sendPending: {
    id: `${supportV2Scope}.sendPending`,
    defaultMessage:
      "Votre demande est déjà en cours d'envoi. Patientez quelques secondes avant de réessayer.",
    en: 'Your request is already being sent. Please wait a few seconds before trying again.',
    it: 'La tua richiesta è già in fase di invio. Attendi qualche secondo prima di riprovare.',
    es: 'Tu solicitud ya se está enviando. Espera unos segundos antes de volver a intentarlo.',
    de: 'Ihre Anfrage wird bereits gesendet. Bitte warten Sie einige Sekunden, bevor Sie es erneut versuchen.',
    nl: 'Uw verzoek wordt al verstuurd. Wacht enkele seconden voordat u het opnieuw probeert.',
  },
  sendInvalid: {
    id: `${supportV2Scope}.sendInvalid`,
    defaultMessage:
      "Certaines informations n'ont pas été acceptées. Vérifiez-les avant de réessayer.",
    en: 'Some details were not accepted. Please check them before trying again.',
    it: 'Alcune informazioni non sono state accettate. Verificale prima di riprovare.',
    es: 'Algunos datos no se han aceptado. Revísalos antes de volver a intentarlo.',
    de: 'Einige Angaben wurden nicht akzeptiert. Bitte prüfen Sie sie, bevor Sie es erneut versuchen.',
    nl: 'Sommige gegevens zijn niet geaccepteerd. Controleer ze voordat u het opnieuw probeert.',
  },
  previewTitle: {
    id: `${supportV2Scope}.previewTitle`,
    defaultMessage: "Mode test : aucune demande n'a été envoyée",
    en: 'Test mode: no request was sent',
    it: 'Modalità test: nessuna richiesta è stata inviata',
    es: 'Modo de prueba: no se ha enviado ninguna solicitud',
    de: 'Testmodus: Es wurde keine Anfrage gesendet',
    nl: 'Testmodus: er is geen verzoek verstuurd',
  },
  previewDescription: {
    id: `${supportV2Scope}.previewDescription`,
    defaultMessage: 'Voici le ticket que recevrait notre équipe support.',
    en: 'This is the ticket our support team would receive.',
    it: 'Ecco il ticket che riceverebbe il nostro team di assistenza.',
    es: 'Este es el ticket que recibiría nuestro equipo de soporte.',
    de: 'Dieses Ticket würde unser Support-Team erhalten.',
    nl: 'Dit is het ticket dat ons supportteam zou ontvangen.',
  },
  previewSubject: {
    id: `${supportV2Scope}.previewSubject`,
    defaultMessage: 'Objet',
    en: 'Subject',
    it: 'Oggetto',
    es: 'Asunto',
    de: 'Betreff',
    nl: 'Onderwerp',
  },
  previewCategory: {
    id: `${supportV2Scope}.previewCategory`,
    defaultMessage: 'Catégorie',
    en: 'Category',
    it: 'Categoria',
    es: 'Categoría',
    de: 'Kategorie',
    nl: 'Categorie',
  },
  previewTags: {
    id: `${supportV2Scope}.previewTags`,
    defaultMessage: 'Tags',
    en: 'Tags',
    it: 'Tag',
    es: 'Etiquetas',
    de: 'Tags',
    nl: 'Tags',
  },
  sentTitle: {
    id: `${supportV2Scope}.sentTitle`,
    defaultMessage: 'Votre demande a bien été envoyée',
    en: 'Your request has been sent',
    it: 'La tua richiesta è stata inviata',
    es: 'Tu solicitud se ha enviado',
    de: 'Ihre Anfrage wurde gesendet',
    nl: 'Uw verzoek is verstuurd',
  },
  sentReference: {
    id: `${supportV2Scope}.sentReference`,
    defaultMessage:
      'Référence de votre demande : {reference}. Notre équipe vous répondra par email.',
    en: 'Your request reference: {reference}. Our team will reply by email.',
    it: 'Riferimento della tua richiesta: {reference}. Il nostro team ti risponderà via email.',
    es: 'Referencia de tu solicitud: {reference}. Nuestro equipo te responderá por correo electrónico.',
    de: 'Referenz Ihrer Anfrage: {reference}. Unser Team antwortet Ihnen per E-Mail.',
    nl: 'Referentie van uw verzoek: {reference}. Ons team antwoordt u per e-mail.',
  },
  backHome: {
    id: `${supportV2Scope}.backHome`,
    defaultMessage: "Retour à l'accueil",
    en: 'Back to the home page',
    it: 'Torna alla home',
    es: 'Volver al inicio',
    de: 'Zurück zur Startseite',
    nl: 'Terug naar de startpagina',
  },
  intro: {
    id: `${supportV2Scope}.intro`,
    defaultMessage:
      'Quelques questions rapides pour transmettre votre demande à la bonne personne.',
    en: 'A few quick questions to pass your request on to the right person.',
    it: 'Alcune domande rapide per inoltrare la tua richiesta alla persona giusta.',
    es: 'Algunas preguntas rápidas para hacer llegar tu solicitud a la persona adecuada.',
    de: 'Ein paar kurze Fragen, damit Ihre Anfrage bei der richtigen Person ankommt.',
    nl: 'Een paar korte vragen om uw verzoek bij de juiste persoon te krijgen.',
  },
  orderQuestion: {
    id: `${supportV2Scope}.orderQuestion`,
    defaultMessage: 'Avez-vous un numéro de commande ?',
    en: 'Do you have an order number?',
    it: "Hai un numero d'ordine?",
    es: '¿Tienes un número de pedido?',
    de: 'Haben Sie eine Bestellnummer?',
    nl: 'Heeft u een bestelnummer?',
  },
  noOrderNumber: {
    id: `${supportV2Scope}.noOrderNumber`,
    defaultMessage: "Je n'ai pas mon numéro",
    en: "I don't have my number",
    it: 'Non ho il numero',
    es: 'No tengo mi número',
    de: 'Ich habe meine Nummer nicht',
    nl: 'Ik heb mijn nummer niet',
  },
  notAboutOrder: {
    id: `${supportV2Scope}.notAboutOrder`,
    defaultMessage: 'Ma demande ne concerne pas une commande',
    en: "My request isn't about an order",
    it: 'La mia richiesta non riguarda un ordine',
    es: 'Mi solicitud no se refiere a un pedido',
    de: 'Meine Anfrage betrifft keine Bestellung',
    nl: 'Mijn verzoek gaat niet over een bestelling',
  },
  orderNotFound: {
    id: `${supportV2Scope}.orderNotFound`,
    defaultMessage:
      "Nous ne trouvons pas cette commande. Vérifiez qu'il s'agit bien du numéro Tictactrip de 16 caractères, et non de la référence du transporteur, ou continuez sans.",
    en: "We can't find this order. Check it is the 16-character Tictactrip number, not the carrier's reference, or continue without it.",
    it: 'Non troviamo questo ordine. Verifica che sia il numero Tictactrip di 16 caratteri e non il riferimento del vettore, oppure continua senza.',
    es: 'No encontramos este pedido. Comprueba que sea el número de Tictactrip de 16 caracteres, y no la referencia del transportista, o continúa sin él.',
    de: 'Wir finden diese Bestellung nicht. Prüfen Sie, ob es die 16-stellige Tictactrip-Nummer ist und nicht die Referenz des Verkehrsunternehmens, oder fahren Sie ohne fort.',
    nl: 'We vinden deze bestelling niet. Controleer of het het Tictactrip-nummer van 16 tekens is en niet de referentie van de vervoerder, of ga zonder verder.',
  },
  orderLoadError: {
    id: `${supportV2Scope}.orderLoadError`,
    defaultMessage:
      "La commande n'a pas pu être chargée. Réessayez, ou continuez sans numéro.",
    en: 'The order could not be loaded. Try again, or continue without a number.',
    it: "Non è stato possibile caricare l'ordine. Riprova o continua senza numero.",
    es: 'No se ha podido cargar el pedido. Vuelve a intentarlo o continúa sin número.',
    de: 'Die Bestellung konnte nicht geladen werden. Versuchen Sie es erneut oder fahren Sie ohne Nummer fort.',
    nl: 'De bestelling kon niet worden geladen. Probeer het opnieuw of ga verder zonder nummer.',
  },
  lostNumberHint: {
    id: `${supportV2Scope}.lostNumberHint`,
    defaultMessage:
      "Votre numéro de commande figure dans l'email de confirmation reçu après l'achat. Il compte 16 caractères. Vous pouvez aussi retrouver vos commandes dans votre espace, avec l'adresse email de l'achat.",
    en: 'Your order number is in the confirmation email you received after your purchase. It has 16 characters. You can also find your orders in your account, with the email address used for the purchase.',
    it: "Il numero d'ordine si trova nell'email di conferma ricevuta dopo l'acquisto. È composto da 16 caratteri. Puoi anche ritrovare i tuoi ordini nel tuo account, con l'indirizzo email dell'acquisto.",
    es: 'Tu número de pedido aparece en el correo de confirmación que recibiste tras la compra. Tiene 16 caracteres. También puedes encontrar tus pedidos en tu cuenta, con la dirección de correo de la compra.',
    de: 'Ihre Bestellnummer steht in der Bestätigungs-E-Mail nach Ihrem Kauf. Sie hat 16 Zeichen. Sie finden Ihre Bestellungen auch in Ihrem Kundenkonto, mit der beim Kauf verwendeten E-Mail-Adresse.',
    nl: 'Uw bestelnummer staat in de bevestigingsmail die u na uw aankoop ontving. Het telt 16 tekens. U vindt uw bestellingen ook in uw account, met het e-mailadres van de aankoop.',
  },
  lostNumberFaq: {
    id: `${supportV2Scope}.lostNumberFaq`,
    defaultMessage: 'Comment retrouver mon numéro de commande',
    en: 'How to find my order number',
    it: "Come ritrovare il numero d'ordine",
    es: 'Cómo encontrar mi número de pedido',
    de: 'So finden Sie Ihre Bestellnummer',
    nl: 'Zo vindt u uw bestelnummer',
  },
  continueWithoutNumber: {
    id: `${supportV2Scope}.continueWithoutNumber`,
    defaultMessage: 'Continuer sans numéro',
    en: 'Continue without a number',
    it: 'Continua senza numero',
    es: 'Continuar sin número',
    de: 'Ohne Nummer fortfahren',
    nl: 'Doorgaan zonder nummer',
  },
  orderCardTitle: {
    id: `${supportV2Scope}.orderCardTitle`,
    defaultMessage: 'Commande {orderId}',
    en: 'Order {orderId}',
    it: 'Ordine {orderId}',
    es: 'Pedido {orderId}',
    de: 'Bestellung {orderId}',
    nl: 'Bestelling {orderId}',
  },
  orderCardReference: {
    id: `${supportV2Scope}.orderCardReference`,
    defaultMessage: 'Numéro de réservation {companies} : {reference}',
    en: '{companies} booking number: {reference}',
    it: 'Numero di prenotazione {companies}: {reference}',
    es: 'Número de reserva de {companies}: {reference}',
    de: 'Buchungsnummer {companies}: {reference}',
    nl: 'Boekingsnummer {companies}: {reference}',
  },
  changeOrder: {
    id: `${supportV2Scope}.changeOrder`,
    defaultMessage: 'Changer de commande',
    en: 'Change order',
    it: 'Cambia ordine',
    es: 'Cambiar de pedido',
    de: 'Andere Bestellung',
    nl: 'Andere bestelling',
  },
  tripOutbound: {
    id: `${supportV2Scope}.tripOutbound`,
    defaultMessage: 'Aller',
    en: 'Outbound',
    it: 'Andata',
    es: 'Ida',
    de: 'Hinfahrt',
    nl: 'Heenreis',
  },
  tripReturn: {
    id: `${supportV2Scope}.tripReturn`,
    defaultMessage: 'Retour',
    en: 'Return',
    it: 'Ritorno',
    es: 'Vuelta',
    de: 'Rückfahrt',
    nl: 'Terugreis',
  },
  otherChoice: {
    id: `${supportV2Scope}.otherChoice`,
    defaultMessage: 'Autre chose',
    en: 'Something else',
    it: 'Altro',
    es: 'Otra cosa',
    de: 'Etwas anderes',
    nl: 'Iets anders',
  },
  selectionTitle: {
    id: `${supportV2Scope}.selectionTitle`,
    defaultMessage: "Qu'est-ce qui est concerné ?",
    en: 'What does it concern?',
    it: 'Cosa riguarda?',
    es: '¿A qué afecta?',
    de: 'Was ist betroffen?',
    nl: 'Waar gaat het om?',
  },
  segmentsQuestion: {
    id: `${supportV2Scope}.segmentsQuestion`,
    defaultMessage: 'Quels trajets ?',
    en: 'Which trips?',
    it: 'Quali tratte?',
    es: '¿Qué trayectos?',
    de: 'Welche Fahrten?',
    nl: 'Welke ritten?',
  },
  passengersQuestion: {
    id: `${supportV2Scope}.passengersQuestion`,
    defaultMessage: 'Quels voyageurs ?',
    en: 'Which travellers?',
    it: 'Quali viaggiatori?',
    es: '¿Qué viajeros?',
    de: 'Welche Reisenden?',
    nl: 'Welke reizigers?',
  },
  selectAtLeastOne: {
    id: `${supportV2Scope}.selectAtLeastOne`,
    defaultMessage: 'Cochez au moins une case.',
    en: 'Tick at least one box.',
    it: 'Seleziona almeno una casella.',
    es: 'Marca al menos una casilla.',
    de: 'Kreuzen Sie mindestens ein Kästchen an.',
    nl: 'Vink minstens één vakje aan.',
  },
  yourAnswers: {
    id: `${supportV2Scope}.yourAnswers`,
    defaultMessage: 'Vos réponses',
    en: 'Your answers',
    it: 'Le tue risposte',
    es: 'Tus respuestas',
    de: 'Ihre Antworten',
    nl: 'Uw antwoorden',
  },
  moreDetails: {
    id: `${supportV2Scope}.moreDetails`,
    defaultMessage: 'Ajouter un téléphone ou des pièces jointes',
    en: 'Add a phone number or attachments',
    it: 'Aggiungi un telefono o degli allegati',
    es: 'Añadir un teléfono o archivos adjuntos',
    de: 'Telefonnummer oder Anhänge hinzufügen',
    nl: 'Een telefoonnummer of bijlagen toevoegen',
  },
  phone: {
    id: `${supportV2Scope}.phone`,
    defaultMessage: 'Téléphone',
    en: 'Phone',
    it: 'Telefono',
    es: 'Teléfono',
    de: 'Telefon',
    nl: 'Telefoon',
  },
  filesTitle: {
    id: `${supportV2Scope}.filesTitle`,
    defaultMessage: 'Pièces jointes',
    en: 'Attachments',
    it: 'Allegati',
    es: 'Archivos adjuntos',
    de: 'Anhänge',
    nl: 'Bijlagen',
  },
  urgentLabel: {
    id: `${supportV2Scope}.urgentLabel`,
    defaultMessage: 'Urgence',
    en: 'Urgency',
    it: 'Urgenza',
    es: 'Urgencia',
    de: 'Dringlichkeit',
    nl: 'Urgentie',
  },
  urgentSummary: {
    id: `${supportV2Scope}.urgentSummary`,
    defaultMessage: "Voyage imminent : nous le signalons à l'équipe support",
    en: 'Imminent trip: we flag it to the support team',
    it: 'Viaggio imminente: lo segnaliamo al team di assistenza',
    es: 'Viaje inminente: se lo indicamos al equipo de soporte',
    de: 'Bevorstehende Reise: Wir weisen das Support-Team darauf hin',
    nl: 'Reis binnenkort: we melden dit aan het supportteam',
  },
  helpTitle: {
    id: `${supportV2Scope}.helpTitle`,
    defaultMessage: 'Voici ce que nous pouvons vous dire',
    en: "Here's what we can tell you",
    it: 'Ecco cosa possiamo dirti',
    es: 'Esto es lo que podemos decirte',
    de: 'Das können wir Ihnen sagen',
    nl: 'Dit kunnen we u vertellen',
  },
  helpResolved: {
    id: `${supportV2Scope}.helpResolved`,
    defaultMessage: 'Cela répond à ma question',
    en: 'That answers my question',
    it: 'Questo risponde alla mia domanda',
    es: 'Esto responde a mi pregunta',
    de: 'Das beantwortet meine Frage',
    nl: 'Dit beantwoordt mijn vraag',
  },
  helpMore: {
    id: `${supportV2Scope}.helpMore`,
    defaultMessage: "J'ai encore besoin d'aide",
    en: 'I still need help',
    it: 'Ho ancora bisogno di aiuto',
    es: 'Todavía necesito ayuda',
    de: 'Ich brauche noch Hilfe',
    nl: 'Ik heb nog hulp nodig',
  },
  resolvedTitle: {
    id: `${supportV2Scope}.resolvedTitle`,
    defaultMessage: "Ravi d'avoir pu vous aider",
    en: 'Glad we could help',
    it: 'Siamo felici di averti aiutato',
    es: 'Nos alegra haberte ayudado',
    de: 'Schön, dass wir helfen konnten',
    nl: 'Fijn dat we konden helpen',
  },
  resolvedText: {
    id: `${supportV2Scope}.resolvedText`,
    defaultMessage:
      'Bon voyage avec Tictactrip ! Si besoin, vous pouvez toujours reprendre votre demande.',
    en: 'Have a good trip with Tictactrip! If needed, you can always pick up your request again.',
    it: 'Buon viaggio con Tictactrip! Se serve, puoi sempre riprendere la tua richiesta.',
    es: '¡Buen viaje con Tictactrip! Si lo necesitas, siempre puedes retomar tu solicitud.',
    de: 'Gute Reise mit Tictactrip! Bei Bedarf können Sie Ihre Anfrage jederzeit fortsetzen.',
    nl: 'Goede reis met Tictactrip! Indien nodig kunt u uw verzoek altijd hervatten.',
  },
  resolvedMore: {
    id: `${supportV2Scope}.resolvedMore`,
    defaultMessage: "Finalement, j'ai encore besoin d'aide",
    en: 'Actually, I still need help',
    it: 'In realtà, ho ancora bisogno di aiuto',
    es: 'En realidad, todavía necesito ayuda',
    de: 'Ich brauche doch noch Hilfe',
    nl: 'Ik heb toch nog hulp nodig',
  },
  lastHelp: {
    id: `${supportV2Scope}.lastHelp`,
    defaultMessage: 'Réponse déjà proposée',
    en: 'Answer already given',
    it: 'Risposta già proposta',
    es: 'Respuesta ya propuesta',
    de: 'Bereits gegebene Antwort',
    nl: 'Eerder gegeven antwoord',
  },
  helpGuide: {
    id: `${supportV2Scope}.helpGuide`,
    defaultMessage: "Guide {name} de notre centre d'aide",
    en: '{name} guide in our help centre (in French)',
    it: 'Guida {name} del nostro centro assistenza (in francese)',
    es: 'Guía {name} de nuestro centro de ayuda (en francés)',
    de: 'Leitfaden {name} in unserem Hilfe-Center (auf Französisch)',
    nl: 'Gids {name} in ons helpcentrum (in het Frans)',
  },
  helpArticle: {
    id: `${supportV2Scope}.helpArticle`,
    defaultMessage: 'Notre article « {name} »',
    en: 'Our article “{name}” (in French)',
    it: 'Il nostro articolo «{name}» (in francese)',
    es: 'Nuestro artículo «{name}» (en francés)',
    de: 'Unser Artikel „{name}“ (auf Französisch)',
    nl: 'Ons artikel ‘{name}’ (in het Frans)',
  },
  actionDownload: {
    id: `${supportV2Scope}.actionDownload`,
    defaultMessage: 'Télécharger mes billets',
    en: 'Download my tickets',
    it: 'Scarica i miei biglietti',
    es: 'Descargar mis billetes',
    de: 'Meine Tickets herunterladen',
    nl: 'Mijn tickets downloaden',
  },
  actionCancelOnline: {
    id: `${supportV2Scope}.actionCancelOnline`,
    defaultMessage: 'Annuler depuis mon espace',
    en: 'Cancel from my account',
    it: 'Annulla dal mio account',
    es: 'Cancelar desde mi cuenta',
    de: 'Im Kundenkonto stornieren',
    nl: 'Annuleren via mijn account',
  },
  actionAccount: {
    id: `${supportV2Scope}.actionAccount`,
    defaultMessage: 'Ouvrir mon espace Tictactrip',
    en: 'Open my Tictactrip account',
    it: 'Apri il mio account Tictactrip',
    es: 'Abrir mi cuenta de Tictactrip',
    de: 'Mein Tictactrip-Konto öffnen',
    nl: 'Mijn Tictactrip-account openen',
  },
  actionFindOrder: {
    id: `${supportV2Scope}.actionFindOrder`,
    defaultMessage: 'Retrouver ma réservation',
    en: 'Find my booking',
    it: 'Ritrova la mia prenotazione',
    es: 'Encontrar mi reserva',
    de: 'Meine Buchung finden',
    nl: 'Mijn boeking terugvinden',
  },
  actionMap: {
    id: `${supportV2Scope}.actionMap`,
    defaultMessage: 'Voir sur la carte',
    en: 'See on the map',
    it: 'Vedi sulla mappa',
    es: 'Ver en el mapa',
    de: 'Auf der Karte ansehen',
    nl: 'Bekijken op de kaart',
  },
  factIssued: {
    id: `${supportV2Scope}.factIssued`,
    defaultMessage: 'Billet émis',
    en: 'Ticket issued',
    it: 'Biglietto emesso',
    es: 'Billete emitido',
    de: 'Ticket ausgestellt',
    nl: 'Ticket uitgegeven',
  },
  factPresold: {
    id: `${supportV2Scope}.factPresold`,
    defaultMessage: "En prévente : billet émis à l'ouverture des ventes",
    en: 'Pre-sale: ticket issued when sales open',
    it: "In prevendita: biglietto emesso all'apertura delle vendite",
    es: 'En preventa: billete emitido al abrirse la venta',
    de: 'Im Vorverkauf: Ticket wird bei Verkaufsstart ausgestellt',
    nl: 'Voorverkoop: ticket uitgegeven bij de start van de verkoop',
  },
  factFailed: {
    id: `${supportV2Scope}.factFailed`,
    defaultMessage: 'Émission en échec',
    en: 'Issuing failed',
    it: 'Emissione non riuscita',
    es: 'Emisión fallida',
    de: 'Ausstellung fehlgeschlagen',
    nl: 'Uitgifte mislukt',
  },
  factCarrierSite: {
    id: `${supportV2Scope}.factCarrierSite`,
    defaultMessage: 'Réservé sur le site du transporteur',
    en: "Booked on the carrier's website",
    it: 'Prenotato sul sito del vettore',
    es: 'Reservado en la web del transportista',
    de: 'Auf der Website des Verkehrsunternehmens gebucht',
    nl: 'Geboekt op de website van de vervoerder',
  },
  factCancelled: {
    id: `${supportV2Scope}.factCancelled`,
    defaultMessage: 'Annulé',
    en: 'Cancelled',
    it: 'Annullato',
    es: 'Cancelado',
    de: 'Storniert',
    nl: 'Geannuleerd',
  },
  factCancelling: {
    id: `${supportV2Scope}.factCancelling`,
    defaultMessage: 'Annulation en cours de traitement',
    en: 'Cancellation being processed',
    it: 'Annullamento in corso',
    es: 'Cancelación en curso',
    de: 'Stornierung wird bearbeitet',
    nl: 'Annulering wordt verwerkt',
  },
  factCancelAccepted: {
    id: `${supportV2Scope}.factCancelAccepted`,
    defaultMessage: 'Annulation acceptée, remboursement en cours',
    en: 'Cancellation accepted, refund in progress',
    it: 'Annullamento accettato, rimborso in corso',
    es: 'Cancelación aceptada, reembolso en curso',
    de: 'Stornierung angenommen, Erstattung läuft',
    nl: 'Annulering geaccepteerd, terugbetaling bezig',
  },
  factCancelFailed: {
    id: `${supportV2Scope}.factCancelFailed`,
    defaultMessage: "L'annulation n'a pas abouti",
    en: 'The cancellation did not go through',
    it: "L'annullamento non è andato a buon fine",
    es: 'La cancelación no se completó',
    de: 'Die Stornierung ist nicht durchgegangen',
    nl: 'De annulering is niet gelukt',
  },
  factRefunded: {
    id: `${supportV2Scope}.factRefunded`,
    defaultMessage:
      "Remboursement de {amount} confirmé : il apparaîtra sur votre compte d'ici quelques jours",
    en: 'Refund of {amount} confirmed: it will show on your account within a few days',
    it: 'Rimborso di {amount} confermato: comparirà sul tuo conto entro qualche giorno',
    es: 'Reembolso de {amount} confirmado: aparecerá en tu cuenta en unos días',
    de: 'Erstattung von {amount} bestätigt: Sie erscheint in einigen Tagen auf Ihrem Konto',
    nl: 'Terugbetaling van {amount} bevestigd: binnen enkele dagen zichtbaar op uw rekening',
  },
  factRefundedNoAmount: {
    id: `${supportV2Scope}.factRefundedNoAmount`,
    defaultMessage:
      "Remboursement confirmé : il apparaîtra sur votre compte d'ici quelques jours",
    en: 'Refund confirmed: it will show on your account within a few days',
    it: 'Rimborso confermato: comparirà sul tuo conto entro qualche giorno',
    es: 'Reembolso confirmado: aparecerá en tu cuenta en unos días',
    de: 'Erstattung bestätigt: Sie erscheint in einigen Tagen auf Ihrem Konto',
    nl: 'Terugbetaling bevestigd: binnen enkele dagen zichtbaar op uw rekening',
  },
  factVoucher: {
    id: `${supportV2Scope}.factVoucher`,
    defaultMessage:
      "Bon d'achat de {amount} à utiliser sur {company} jusqu'au {date} : {code}",
    en: 'Voucher of {amount} to use with {company} until {date}: {code}',
    it: 'Buono di {amount} da usare su {company} fino al {date}: {code}',
    es: 'Bono de {amount} para usar en {company} hasta el {date}: {code}',
    de: 'Gutschein über {amount}, einlösbar bei {company} bis {date}: {code}',
    nl: 'Tegoedbon van {amount} te gebruiken bij {company} tot {date}: {code}',
  },
  factConditions: {
    id: `${supportV2Scope}.factConditions`,
    defaultMessage: 'Conditions du billet : {conditions}',
    en: 'Ticket conditions: {conditions}',
    it: 'Condizioni del biglietto: {conditions}',
    es: 'Condiciones del billete: {conditions}',
    de: 'Ticketbedingungen: {conditions}',
    nl: 'Ticketvoorwaarden: {conditions}',
  },
  factStations: {
    id: `${supportV2Scope}.factStations`,
    defaultMessage: 'Départ : {origin} · Arrivée : {destination}',
    en: 'Departure: {origin} · Arrival: {destination}',
    it: 'Partenza: {origin} · Arrivo: {destination}',
    es: 'Salida: {origin} · Llegada: {destination}',
    de: 'Abfahrt: {origin} · Ankunft: {destination}',
    nl: 'Vertrek: {origin} · Aankomst: {destination}',
  },
  factTransfer: {
    id: `${supportV2Scope}.factTransfer`,
    defaultMessage:
      'Vous arrivez à {from} et repartez de {to} : votre commande ne comprend pas de billet entre ces deux gares.',
    en: 'You arrive at {from} and leave from {to}: your order has no ticket between these two stations.',
    it: 'Arrivi a {from} e riparti da {to}: il tuo ordine non comprende un biglietto tra queste due stazioni.',
    es: 'Llegas a {from} y sales de {to}: tu pedido no incluye billete entre estas dos estaciones.',
    de: 'Sie kommen in {from} an und fahren von {to} ab: Ihre Bestellung enthält kein Ticket zwischen diesen beiden Bahnhöfen.',
    nl: 'U komt aan in {from} en vertrekt vanaf {to}: uw bestelling bevat geen ticket tussen deze twee stations.',
  },
  factNoTransfer: {
    id: `${supportV2Scope}.factNoTransfer`,
    defaultMessage:
      'Dans votre commande, chaque trajet repart de la gare où arrive le précédent.',
    en: 'In your order, each leg leaves from the station where the previous one arrives.',
    it: 'Nel tuo ordine, ogni tratta parte dalla stazione in cui arriva la precedente.',
    es: 'En tu pedido, cada trayecto sale de la estación donde llega el anterior.',
    de: 'In Ihrer Bestellung beginnt jede Fahrt an dem Bahnhof, an dem die vorherige ankommt.',
    nl: 'In uw bestelling vertrekt elke rit vanaf het station waar de vorige aankomt.',
  },
  factFees: {
    id: `${supportV2Scope}.factFees`,
    defaultMessage:
      'Billets : {tickets} · Frais : {fees} · Total payé : {total}',
    en: 'Tickets: {tickets} · Fees: {fees} · Total paid: {total}',
    it: 'Biglietti: {tickets} · Commissioni: {fees} · Totale pagato: {total}',
    es: 'Billetes: {tickets} · Gastos: {fees} · Total pagado: {total}',
    de: 'Tickets: {tickets} · Gebühren: {fees} · Gezahlt: {total}',
    nl: 'Tickets: {tickets} · Kosten: {fees} · Totaal betaald: {total}',
  },
  helpFailed: {
    id: `${supportV2Scope}.helpFailed`,
    defaultMessage:
      "Votre réservation n'a pas pu aboutir : le trajet était peut-être complet, supprimé par la compagnie, ou son prix a changé pendant la réservation. Dans ce cas, le remboursement est automatique : comptez quelques jours pour le voir sur votre compte. Pour voyager, il suffit de réserver à nouveau.",
    en: 'Your booking could not be completed: the trip may have been full, cancelled by the carrier, or its price changed during booking. In that case, the refund is automatic: allow a few days to see it on your account. To travel, simply book again.',
    it: 'La tua prenotazione non è andata a buon fine: il viaggio poteva essere al completo, soppresso dalla compagnia, oppure il prezzo è cambiato durante la prenotazione. In questo caso il rimborso è automatico: calcola qualche giorno per vederlo sul tuo conto. Per viaggiare, basta prenotare di nuovo.',
    es: 'Tu reserva no se pudo completar: puede que el trayecto estuviera completo, que la compañía lo cancelara o que su precio cambiara durante la reserva. En ese caso, el reembolso es automático: cuenta unos días para verlo en tu cuenta. Para viajar, basta con reservar de nuevo.',
    de: 'Ihre Buchung konnte nicht abgeschlossen werden: Die Verbindung war vielleicht ausgebucht, wurde vom Verkehrsunternehmen gestrichen, oder der Preis hat sich während der Buchung geändert. In diesem Fall erfolgt die Erstattung automatisch: Rechnen Sie mit einigen Tagen, bis sie auf Ihrem Konto erscheint. Um zu reisen, buchen Sie einfach erneut.',
    nl: 'Uw boeking kon niet worden afgerond: de rit was misschien vol, door de vervoerder geschrapt, of de prijs veranderde tijdens het boeken. In dat geval gaat de terugbetaling automatisch: reken op enkele dagen voordat u die op uw rekening ziet. Om te reizen, boekt u gewoon opnieuw.',
  },
  helpPartialFailure: {
    id: `${supportV2Scope}.helpPartialFailure`,
    defaultMessage:
      "L'émission d'un de vos billets a échoué. Notre équipe s'en occupe et vous l'enverra par email au plus vite : ne rachetez pas ce trajet, pour ne pas payer deux fois. Si vous partez dans les prochaines heures, entre 18 h 30 et 9 h 30, rachetez uniquement ce trajet.",
    en: "One of your tickets failed to be issued. Our team is on it and will email it to you as soon as possible: don't buy this trip again, so you don't pay twice. If you leave within the next few hours, between 6:30 pm and 9:30 am, buy this trip only.",
    it: "L'emissione di uno dei tuoi biglietti non è riuscita. Il nostro team se ne occupa e te lo invierà via email al più presto: non riacquistare questa tratta, per non pagare due volte. Se parti nelle prossime ore, tra le 18:30 e le 9:30, riacquista solo questa tratta.",
    es: 'La emisión de uno de tus billetes ha fallado. Nuestro equipo se ocupa y te lo enviará por correo lo antes posible: no vuelvas a comprar este trayecto, para no pagar dos veces. Si sales en las próximas horas, entre las 18:30 y las 9:30, compra solo este trayecto.',
    de: 'Eines Ihrer Tickets konnte nicht ausgestellt werden. Unser Team kümmert sich darum und schickt es Ihnen so schnell wie möglich per E-Mail: Kaufen Sie diese Fahrt nicht noch einmal, um nicht doppelt zu zahlen. Wenn Sie in den nächsten Stunden zwischen 18:30 und 9:30 Uhr abfahren, kaufen Sie nur diese Fahrt neu.',
    nl: 'De uitgifte van een van uw tickets is mislukt. Ons team regelt het en mailt het u zo snel mogelijk: koop deze rit niet opnieuw, zodat u niet dubbel betaalt. Vertrekt u in de komende uren, tussen 18.30 en 9.30 uur, koop dan alleen deze rit opnieuw.',
  },
  helpCancelled: {
    id: `${supportV2Scope}.helpCancelled`,
    defaultMessage:
      'Voici où en sont les annulations et remboursements de votre commande.',
    en: 'Here is where the cancellations and refunds of your order stand.',
    it: 'Ecco a che punto sono gli annullamenti e i rimborsi del tuo ordine.',
    es: 'Este es el estado de las cancelaciones y reembolsos de tu pedido.',
    de: 'So ist der Stand der Stornierungen und Erstattungen Ihrer Bestellung.',
    nl: 'Zo staan de annuleringen en terugbetalingen van uw bestelling ervoor.',
  },
  helpPartner: {
    id: `${supportV2Scope}.helpPartner`,
    defaultMessage:
      "Votre réservation a été faite via {partner}. Le plus simple est de vous adresser à son service client : c'est la plateforme où vous avez acheté votre billet.",
    en: "Your booking was made through {partner}. The simplest is to contact their customer service: it's the platform where you bought your ticket.",
    it: 'La tua prenotazione è stata effettuata tramite {partner}. La cosa più semplice è rivolgerti al suo servizio clienti: è la piattaforma dove hai acquistato il biglietto.',
    es: 'Tu reserva se hizo a través de {partner}. Lo más sencillo es dirigirte a su servicio de atención al cliente: es la plataforma donde compraste tu billete.',
    de: 'Ihre Buchung wurde über {partner} vorgenommen. Am einfachsten wenden Sie sich an dessen Kundenservice: Das ist die Plattform, auf der Sie Ihr Ticket gekauft haben.',
    nl: 'Uw boeking is gedaan via {partner}. Het eenvoudigst is contact op te nemen met hun klantenservice: dat is het platform waar u uw ticket hebt gekocht.',
  },
  helpPartnerUnnamed: {
    id: `${supportV2Scope}.helpPartnerUnnamed`,
    defaultMessage:
      "Votre réservation a été faite via l'un de nos partenaires. Le plus simple est de vous adresser au service client de la plateforme où vous avez acheté votre billet.",
    en: 'Your booking was made through one of our partners. The simplest is to contact the customer service of the platform where you bought your ticket.',
    it: 'La tua prenotazione è stata effettuata tramite uno dei nostri partner. La cosa più semplice è rivolgerti al servizio clienti della piattaforma dove hai acquistato il biglietto.',
    es: 'Tu reserva se hizo a través de uno de nuestros socios. Lo más sencillo es dirigirte al servicio de atención al cliente de la plataforma donde compraste tu billete.',
    de: 'Ihre Buchung wurde über einen unserer Partner vorgenommen. Am einfachsten wenden Sie sich an den Kundenservice der Plattform, auf der Sie Ihr Ticket gekauft haben.',
    nl: 'Uw boeking is gedaan via een van onze partners. Het eenvoudigst is contact op te nemen met de klantenservice van het platform waar u uw ticket hebt gekocht.',
  },
  helpPresold: {
    id: `${supportV2Scope}.helpPresold`,
    defaultMessage:
      "Votre billet est en prévente : vous avez réservé avant l'ouverture des ventes du transporteur. Il sera émis automatiquement à l'ouverture des ventes et vous le recevrez par email ; il sera aussi disponible dans votre espace Tictactrip. Vous n'avez rien à faire.",
    en: "Your ticket is in pre-sale: you booked before the carrier opened sales. It will be issued automatically when sales open and emailed to you; it will also be in your Tictactrip account. There's nothing you need to do.",
    it: "Il tuo biglietto è in prevendita: hai prenotato prima dell'apertura delle vendite del vettore. Sarà emesso automaticamente all'apertura delle vendite e lo riceverai via email; sarà disponibile anche nel tuo account Tictactrip. Non devi fare nulla.",
    es: 'Tu billete está en preventa: reservaste antes de que el transportista abriera la venta. Se emitirá automáticamente al abrirse la venta y lo recibirás por correo; también estará en tu cuenta de Tictactrip. No tienes que hacer nada.',
    de: 'Ihr Ticket ist im Vorverkauf: Sie haben vor dem Verkaufsstart des Verkehrsunternehmens gebucht. Es wird bei Verkaufsstart automatisch ausgestellt und Ihnen per E-Mail geschickt; außerdem finden Sie es in Ihrem Tictactrip-Konto. Sie müssen nichts tun.',
    nl: 'Uw ticket is in voorverkoop: u boekte vóór de verkoopstart van de vervoerder. Het wordt bij de start van de verkoop automatisch uitgegeven en per e-mail naar u gestuurd; het staat dan ook in uw Tictactrip-account. U hoeft niets te doen.',
  },
  helpMissingPart: {
    id: `${supportV2Scope}.helpMissingPart`,
    defaultMessage:
      "Les billets des différents trajets peuvent arriver séparément. Voici l'état de chacun.",
    en: 'Tickets for different legs can arrive separately. Here is the status of each one.',
    it: 'I biglietti delle diverse tratte possono arrivare separatamente. Ecco lo stato di ciascuno.',
    es: 'Los billetes de los distintos trayectos pueden llegar por separado. Este es el estado de cada uno.',
    de: 'Die Tickets für die einzelnen Fahrten können getrennt ankommen. Hier ist der Stand für jede.',
    nl: 'Tickets voor verschillende ritten kunnen apart aankomen. Dit is de status van elk ticket.',
  },
  helpTicketsNotReceived: {
    id: `${supportV2Scope}.helpTicketsNotReceived`,
    defaultMessage:
      "Vos billets sont envoyés à l'adresse email utilisée lors de l'achat : pensez à vérifier vos courriers indésirables. Ils sont aussi disponibles dans votre espace Tictactrip.",
    en: 'Your tickets are sent to the email address used for the purchase: remember to check your spam folder. They are also available in your Tictactrip account.',
    it: "I tuoi biglietti vengono inviati all'indirizzo email usato per l'acquisto: controlla anche la posta indesiderata. Sono disponibili anche nel tuo account Tictactrip.",
    es: 'Tus billetes se envían a la dirección de correo usada en la compra: revisa también la carpeta de correo no deseado. También están disponibles en tu cuenta de Tictactrip.',
    de: 'Ihre Tickets werden an die beim Kauf verwendete E-Mail-Adresse geschickt: Prüfen Sie auch Ihren Spam-Ordner. Sie finden sie außerdem in Ihrem Tictactrip-Konto.',
    nl: 'Uw tickets worden verstuurd naar het e-mailadres dat u bij de aankoop gebruikte: kijk ook in uw spammap. Ze staan ook in uw Tictactrip-account.',
  },
  helpTicketsOuigoSoon: {
    id: `${supportV2Scope}.helpTicketsOuigoSoon`,
    defaultMessage:
      "Votre réservation est bien validée. OUIGO envoie lui-même ses billets, 4 jours avant le départ, à l'adresse email de la réservation : les vôtres arriveront à partir du {date}.",
    en: 'Your booking is confirmed. OUIGO sends its tickets itself, 4 days before departure, to the booking email address: yours will arrive from {date}.',
    it: "La tua prenotazione è confermata. OUIGO invia direttamente i biglietti, 4 giorni prima della partenza, all'indirizzo email della prenotazione: i tuoi arriveranno a partire dal {date}.",
    es: 'Tu reserva está confirmada. OUIGO envía él mismo sus billetes, 4 días antes de la salida, a la dirección de correo de la reserva: los tuyos llegarán a partir del {date}.',
    de: 'Ihre Buchung ist bestätigt. OUIGO verschickt seine Tickets selbst, 4 Tage vor Abfahrt, an die E-Mail-Adresse der Buchung: Ihre kommen ab dem {date}.',
    nl: 'Uw boeking is bevestigd. OUIGO verstuurt zijn tickets zelf, 4 dagen voor vertrek, naar het e-mailadres van de boeking: die van u komen vanaf {date}.',
  },
  helpTicketsOuigoLate: {
    id: `${supportV2Scope}.helpTicketsOuigoLate`,
    defaultMessage:
      "OUIGO envoie lui-même ses billets, 4 jours avant le départ, à l'adresse email de la réservation : vous auriez déjà dû les recevoir. Vérifiez vos courriers indésirables ; sinon, dites-le-nous.",
    en: 'OUIGO sends its tickets itself, 4 days before departure, to the booking email address: you should already have received them. Check your spam folder; otherwise, let us know.',
    it: "OUIGO invia direttamente i biglietti, 4 giorni prima della partenza, all'indirizzo email della prenotazione: dovresti già averli ricevuti. Controlla la posta indesiderata; altrimenti, faccelo sapere.",
    es: 'OUIGO envía él mismo sus billetes, 4 días antes de la salida, a la dirección de correo de la reserva: ya deberías haberlos recibido. Revisa el correo no deseado; si no, avísanos.',
    de: 'OUIGO verschickt seine Tickets selbst, 4 Tage vor Abfahrt, an die E-Mail-Adresse der Buchung: Sie sollten sie schon erhalten haben. Prüfen Sie Ihren Spam-Ordner; andernfalls sagen Sie uns Bescheid.',
    nl: 'OUIGO verstuurt zijn tickets zelf, 4 dagen voor vertrek, naar het e-mailadres van de boeking: u had ze al moeten ontvangen. Kijk in uw spammap; laat het ons anders weten.',
  },
  helpTicketsEurostar: {
    id: `${supportV2Scope}.helpTicketsEurostar`,
    defaultMessage:
      "Pour certains trajets, Eurostar demande de compléter vos informations de passeport sur son site avant d'envoyer le billet : le guide Eurostar explique comment faire.",
    en: 'For some trips, Eurostar asks you to complete your passport details on its website before sending the ticket: the Eurostar guide explains how.',
    it: 'Per alcuni viaggi, Eurostar chiede di completare i dati del passaporto sul suo sito prima di inviare il biglietto: la guida Eurostar spiega come fare.',
    es: 'Para algunos trayectos, Eurostar pide completar los datos del pasaporte en su web antes de enviar el billete: la guía de Eurostar explica cómo hacerlo.',
    de: 'Bei manchen Fahrten verlangt Eurostar, dass Sie Ihre Passdaten auf seiner Website ergänzen, bevor das Ticket verschickt wird: Der Eurostar-Leitfaden erklärt, wie das geht.',
    nl: 'Voor sommige ritten vraagt Eurostar om uw paspoortgegevens op zijn website aan te vullen voordat het ticket wordt verstuurd: de Eurostar-gids legt uit hoe.',
  },
  helpReceiptOnly: {
    id: `${supportV2Scope}.helpReceiptOnly`,
    defaultMessage:
      'Le reçu de paiement ne remplace pas le billet à présenter pour voyager : téléchargez vos billets, ou retrouvez-les dans votre espace Tictactrip.',
    en: "The payment receipt doesn't replace the ticket you show when travelling: download your tickets, or find them in your Tictactrip account.",
    it: 'La ricevuta di pagamento non sostituisce il biglietto da mostrare in viaggio: scarica i tuoi biglietti o ritrovali nel tuo account Tictactrip.',
    es: 'El recibo de pago no sustituye al billete que hay que presentar para viajar: descarga tus billetes o encuéntralos en tu cuenta de Tictactrip.',
    de: 'Die Zahlungsbestätigung ersetzt nicht das Ticket, das Sie auf der Reise vorzeigen: Laden Sie Ihre Tickets herunter oder finden Sie sie in Ihrem Tictactrip-Konto.',
    nl: 'Het betalingsbewijs vervangt niet het ticket dat u tijdens de reis toont: download uw tickets of vind ze in uw Tictactrip-account.',
  },
  helpBookingUnsure: {
    id: `${supportV2Scope}.helpBookingUnsure`,
    defaultMessage: "Voici l'état de chacun des trajets de votre commande.",
    en: 'Here is the status of each leg of your order.',
    it: 'Ecco lo stato di ciascuna tratta del tuo ordine.',
    es: 'Este es el estado de cada trayecto de tu pedido.',
    de: 'Hier ist der Stand jeder Fahrt Ihrer Bestellung.',
    nl: 'Dit is de status van elke rit van uw bestelling.',
  },
  helpWrongEmail: {
    id: `${supportV2Scope}.helpWrongEmail`,
    defaultMessage:
      "Vos billets restent accessibles avec votre numéro de commande : téléchargez-les ici. Pour corriger l'adresse de la réservation, dites-le-nous en indiquant celle saisie lors de l'achat si vous la connaissez.",
    en: 'Your tickets remain accessible with your order number: download them here. To correct the booking address, let us know, giving the one entered at purchase if you know it.',
    it: "I tuoi biglietti restano accessibili con il numero d'ordine: scaricali qui. Per correggere l'indirizzo della prenotazione, faccelo sapere indicando quello inserito all'acquisto, se lo conosci.",
    es: 'Tus billetes siguen accesibles con tu número de pedido: descárgalos aquí. Para corregir la dirección de la reserva, avísanos e indica la que introdujiste al comprar, si la conoces.',
    de: 'Ihre Tickets bleiben mit Ihrer Bestellnummer zugänglich: Laden Sie sie hier herunter. Um die Adresse der Buchung zu korrigieren, sagen Sie uns Bescheid und nennen Sie, falls bekannt, die beim Kauf eingegebene Adresse.',
    nl: 'Uw tickets blijven toegankelijk met uw bestelnummer: download ze hier. Om het adres van de boeking te corrigeren, laat het ons weten en geef het adres dat u bij de aankoop invoerde, als u het weet.',
  },
  helpCannotDownload: {
    id: `${supportV2Scope}.helpCannotDownload`,
    defaultMessage:
      'Voici le lien direct vers vos billets. Les instructions pour les présenter, sur téléphone ou imprimés, figurent sur chaque billet. Si le fichier reste inaccessible, dites-le-nous en précisant le message affiché.',
    en: "Here is the direct link to your tickets. How to show them, on a phone or printed, is written on each ticket. If the file still won't open, let us know and tell us the message shown.",
    it: 'Ecco il link diretto ai tuoi biglietti. Le istruzioni per presentarli, su telefono o stampati, sono riportate su ogni biglietto. Se il file resta inaccessibile, faccelo sapere indicando il messaggio visualizzato.',
    es: 'Este es el enlace directo a tus billetes. Las instrucciones para presentarlos, en el móvil o impresos, figuran en cada billete. Si el archivo sigue sin abrirse, avísanos indicando el mensaje que aparece.',
    de: 'Hier ist der direkte Link zu Ihren Tickets. Wie Sie sie vorzeigen, auf dem Handy oder ausgedruckt, steht auf jedem Ticket. Wenn sich die Datei weiterhin nicht öffnen lässt, sagen Sie uns Bescheid und nennen Sie die angezeigte Meldung.',
    nl: 'Hier is de directe link naar uw tickets. Hoe u ze toont, op de telefoon of geprint, staat op elk ticket. Blijft het bestand onbereikbaar, laat het ons dan weten met de getoonde melding.',
  },
  helpScheduleChanged: {
    id: `${supportV2Scope}.helpScheduleChanged`,
    defaultMessage:
      "Si le transporteur a modifié l'horaire, un billet actualisé peut être disponible : téléchargez à nouveau vos billets pour le vérifier. Si l'ancien horaire reste affiché, transmettez-nous le message de modification reçu.",
    en: 'If the carrier changed the time, an updated ticket may be available: download your tickets again to check. If the old time is still shown, send us the change notice you received.',
    it: "Se il vettore ha modificato l'orario, potrebbe essere disponibile un biglietto aggiornato: scarica di nuovo i biglietti per verificarlo. Se resta l'orario vecchio, inviaci il messaggio di modifica ricevuto.",
    es: 'Si el transportista cambió el horario, puede haber un billete actualizado: vuelve a descargar tus billetes para comprobarlo. Si sigue apareciendo el horario antiguo, envíanos el aviso de cambio que recibiste.',
    de: 'Wenn das Verkehrsunternehmen die Uhrzeit geändert hat, gibt es vielleicht ein aktualisiertes Ticket: Laden Sie Ihre Tickets erneut herunter, um das zu prüfen. Steht noch die alte Uhrzeit darauf, schicken Sie uns die erhaltene Änderungsmitteilung.',
    nl: 'Als de vervoerder de tijd heeft gewijzigd, is er mogelijk een bijgewerkt ticket: download uw tickets opnieuw om dat te controleren. Staat de oude tijd er nog, stuur ons dan het wijzigingsbericht dat u ontving.',
  },
  helpCancel: {
    id: `${supportV2Scope}.helpCancel`,
    defaultMessage:
      "Vérifiez d'abord les conditions de votre billet. S'il est annulable, annulez-le vous-même depuis votre espace Tictactrip : le montant remboursé et les éventuels frais s'affichent avant de confirmer. Une annulation n'est plus possible après le départ.",
    en: "First check your ticket's conditions. If it can be cancelled, cancel it yourself from your Tictactrip account: the refund amount and any fees are shown before you confirm. A trip can no longer be cancelled after departure.",
    it: "Verifica prima le condizioni del tuo biglietto. Se è annullabile, annullalo tu stesso dal tuo account Tictactrip: l'importo rimborsato e le eventuali commissioni vengono mostrati prima della conferma. Dopo la partenza non è più possibile annullare.",
    es: 'Comprueba primero las condiciones de tu billete. Si se puede cancelar, cancélalo tú mismo desde tu cuenta de Tictactrip: el importe reembolsado y los posibles gastos se muestran antes de confirmar. Después de la salida ya no se puede cancelar.',
    de: 'Prüfen Sie zuerst die Bedingungen Ihres Tickets. Ist es stornierbar, stornieren Sie es selbst in Ihrem Tictactrip-Konto: Erstattungsbetrag und eventuelle Gebühren werden vor der Bestätigung angezeigt. Nach der Abfahrt ist keine Stornierung mehr möglich.',
    nl: 'Controleer eerst de voorwaarden van uw ticket. Is het annuleerbaar, annuleer het dan zelf via uw Tictactrip-account: het terugbetaalde bedrag en eventuele kosten worden getoond voordat u bevestigt. Na vertrek kan niet meer worden geannuleerd.',
  },
  helpCancelOuigo: {
    id: `${supportV2Scope}.helpCancelOuigo`,
    defaultMessage:
      'Les billets OUIGO ne sont pas remboursables. Vous pouvez les échanger sur le site OUIGO, ou les revendre avec OUIGOswap. Pour vous connecter sur OUIGO, il faut votre numéro de réservation OUIGO : {reference}.',
    en: 'OUIGO tickets are not refundable. You can exchange them on the OUIGO website, or resell them with OUIGOswap. To log in on OUIGO, you need your OUIGO booking number: {reference}.',
    it: 'I biglietti OUIGO non sono rimborsabili. Puoi cambiarli sul sito OUIGO o rivenderli con OUIGOswap. Per accedere a OUIGO serve il numero di prenotazione OUIGO: {reference}.',
    es: 'Los billetes de OUIGO no son reembolsables. Puedes cambiarlos en la web de OUIGO o revenderlos con OUIGOswap. Para acceder a OUIGO necesitas tu número de reserva de OUIGO: {reference}.',
    de: 'OUIGO-Tickets sind nicht erstattungsfähig. Sie können sie auf der OUIGO-Website umtauschen oder mit OUIGOswap weiterverkaufen. Zum Anmelden bei OUIGO brauchen Sie Ihre OUIGO-Buchungsnummer: {reference}.',
    nl: 'OUIGO-tickets worden niet terugbetaald. U kunt ze omruilen op de OUIGO-website of doorverkopen met OUIGOswap. Om in te loggen bij OUIGO hebt u uw OUIGO-boekingsnummer nodig: {reference}.',
  },
  helpCancelEurostar: {
    id: `${supportV2Scope}.helpCancelEurostar`,
    defaultMessage:
      "Une réservation Eurostar s'annule directement sur le site d'Eurostar, avec la référence de réservation et le nom figurant sur le billet. Ses conditions indiquent si c'est possible.",
    en: "A Eurostar booking is cancelled directly on the Eurostar website, with the booking reference and the name on the ticket. Its conditions say whether that's possible.",
    it: 'Una prenotazione Eurostar si annulla direttamente sul sito di Eurostar, con il riferimento della prenotazione e il nome indicato sul biglietto. Le sue condizioni indicano se è possibile.',
    es: 'Una reserva de Eurostar se cancela directamente en la web de Eurostar, con la referencia de reserva y el nombre que figura en el billete. Sus condiciones indican si es posible.',
    de: 'Eine Eurostar-Buchung wird direkt auf der Eurostar-Website storniert, mit der Buchungsreferenz und dem Namen auf dem Ticket. Die Bedingungen zeigen, ob das möglich ist.',
    nl: 'Een Eurostar-boeking annuleert u rechtstreeks op de website van Eurostar, met de boekingsreferentie en de naam op het ticket. De voorwaarden geven aan of dat kan.',
  },
  helpCancelFlixbus: {
    id: `${supportV2Scope}.helpCancelFlixbus`,
    defaultMessage:
      "Un billet FlixBus s'annule depuis votre espace Tictactrip. Le remboursement se fait en bon d'achat, à utiliser sur le site de FlixBus.",
    en: 'A FlixBus ticket is cancelled from your Tictactrip account. The refund is made as a voucher, to use on the FlixBus website.',
    it: 'Un biglietto FlixBus si annulla dal tuo account Tictactrip. Il rimborso avviene con un buono da usare sul sito di FlixBus.',
    es: 'Un billete de FlixBus se cancela desde tu cuenta de Tictactrip. El reembolso se hace en forma de bono, para usar en la web de FlixBus.',
    de: 'Ein FlixBus-Ticket stornieren Sie in Ihrem Tictactrip-Konto. Die Erstattung erfolgt als Gutschein, einlösbar auf der Website von FlixBus.',
    nl: 'Een FlixBus-ticket annuleert u via uw Tictactrip-account. De terugbetaling gebeurt met een tegoedbon, te gebruiken op de website van FlixBus.',
  },
  helpCancelBlablacar: {
    id: `${supportV2Scope}.helpCancelBlablacar`,
    defaultMessage:
      "Un billet BlaBlaCar Bus s'annule depuis votre espace Tictactrip. Le remboursement se fait en bon d'achat, à utiliser sur le site de BlaBlaCar Bus.",
    en: 'A BlaBlaCar Bus ticket is cancelled from your Tictactrip account. The refund is made as a voucher, to use on the BlaBlaCar Bus website.',
    it: 'Un biglietto BlaBlaCar Bus si annulla dal tuo account Tictactrip. Il rimborso avviene con un buono da usare sul sito di BlaBlaCar Bus.',
    es: 'Un billete de BlaBlaCar Bus se cancela desde tu cuenta de Tictactrip. El reembolso se hace en forma de bono, para usar en la web de BlaBlaCar Bus.',
    de: 'Ein BlaBlaCar Bus-Ticket stornieren Sie in Ihrem Tictactrip-Konto. Die Erstattung erfolgt als Gutschein, einlösbar auf der Website von BlaBlaCar Bus.',
    nl: 'Een BlaBlaCar Bus-ticket annuleert u via uw Tictactrip-account. De terugbetaling gebeurt met een tegoedbon, te gebruiken op de website van BlaBlaCar Bus.',
  },
  helpExchange: {
    id: `${supportV2Scope}.helpExchange`,
    defaultMessage:
      "Vérifiez d'abord les conditions d'échange de votre billet. Si c'est possible, indiquez-nous le trajet, la date et l'horaire souhaités : les frais et l'éventuelle différence de prix vous seront indiqués avant tout changement. Modifier un trajet ne modifie pas les autres billets de votre commande.",
    en: "First check your ticket's exchange conditions. If it's possible, tell us the route, date and time you want: any fees and price difference will be shown to you before anything changes. Changing one leg doesn't change the other tickets of your order.",
    it: "Verifica prima le condizioni di cambio del tuo biglietto. Se è possibile, indicaci la tratta, la data e l'orario desiderati: le commissioni e l'eventuale differenza di prezzo ti saranno indicate prima di qualsiasi modifica. Modificare una tratta non modifica gli altri biglietti del tuo ordine.",
    es: 'Comprueba primero las condiciones de cambio de tu billete. Si es posible, indícanos el trayecto, la fecha y la hora que quieres: los gastos y la posible diferencia de precio se te indicarán antes de cualquier cambio. Modificar un trayecto no modifica los demás billetes de tu pedido.',
    de: 'Prüfen Sie zuerst die Umtauschbedingungen Ihres Tickets. Wenn es möglich ist, nennen Sie uns die gewünschte Strecke, das Datum und die Uhrzeit: Gebühren und eine eventuelle Preisdifferenz werden Ihnen vor jeder Änderung mitgeteilt. Eine geänderte Fahrt ändert nicht die anderen Tickets Ihrer Bestellung.',
    nl: 'Controleer eerst de omruilvoorwaarden van uw ticket. Als het kan, geef ons dan de gewenste route, datum en tijd door: kosten en een eventueel prijsverschil worden u vóór elke wijziging meegedeeld. Een gewijzigde rit verandert de andere tickets van uw bestelling niet.',
  },
  helpExchangeOuigo: {
    id: `${supportV2Scope}.helpExchangeOuigo`,
    defaultMessage:
      "Un billet OUIGO s'échange sur le site OUIGO, avec votre numéro de réservation OUIGO : {reference}. La compagnie facture des frais d'échange.",
    en: 'An OUIGO ticket is exchanged on the OUIGO website, with your OUIGO booking number: {reference}. The carrier charges an exchange fee.',
    it: 'Un biglietto OUIGO si cambia sul sito OUIGO, con il numero di prenotazione OUIGO: {reference}. La compagnia applica una commissione di cambio.',
    es: 'Un billete de OUIGO se cambia en la web de OUIGO, con tu número de reserva de OUIGO: {reference}. La compañía cobra gastos de cambio.',
    de: 'Ein OUIGO-Ticket tauschen Sie auf der OUIGO-Website um, mit Ihrer OUIGO-Buchungsnummer: {reference}. Das Unternehmen berechnet eine Umtauschgebühr.',
    nl: 'Een OUIGO-ticket ruilt u om op de OUIGO-website, met uw OUIGO-boekingsnummer: {reference}. De vervoerder rekent omruilkosten.',
  },
  helpExchangeEurostar: {
    id: `${supportV2Scope}.helpExchangeEurostar`,
    defaultMessage:
      "Un billet Eurostar s'échange directement sur le site d'Eurostar (« Gérer ma réservation »), avec la référence de réservation et le nom figurant sur le billet.",
    en: 'A Eurostar ticket is exchanged directly on the Eurostar website (“Manage my booking”), with the booking reference and the name on the ticket.',
    it: 'Un biglietto Eurostar si cambia direttamente sul sito di Eurostar («Gestisci prenotazione»), con il riferimento della prenotazione e il nome indicato sul biglietto.',
    es: 'Un billete de Eurostar se cambia directamente en la web de Eurostar («Gestionar mi reserva»), con la referencia de reserva y el nombre que figura en el billete.',
    de: 'Ein Eurostar-Ticket tauschen Sie direkt auf der Eurostar-Website um („Buchung verwalten“), mit der Buchungsreferenz und dem Namen auf dem Ticket.',
    nl: 'Een Eurostar-ticket ruilt u rechtstreeks om op de website van Eurostar (‘Mijn boeking beheren’), met de boekingsreferentie en de naam op het ticket.',
  },
  helpExchangeFlixbus: {
    id: `${supportV2Scope}.helpExchangeFlixbus`,
    defaultMessage:
      "Un billet FlixBus se modifie sur le site de FlixBus (« modifier la date et l'heure »), avec votre numéro de réservation FlixBus : {reference}. Une différence de prix peut s'appliquer.",
    en: 'A FlixBus ticket is changed on the FlixBus website (“change date and time”), with your FlixBus booking number: {reference}. A price difference may apply.',
    it: 'Un biglietto FlixBus si modifica sul sito di FlixBus («modifica data e ora»), con il numero di prenotazione FlixBus: {reference}. Può applicarsi una differenza di prezzo.',
    es: 'Un billete de FlixBus se modifica en la web de FlixBus («cambiar fecha y hora»), con tu número de reserva de FlixBus: {reference}. Puede aplicarse una diferencia de precio.',
    de: 'Ein FlixBus-Ticket ändern Sie auf der FlixBus-Website („Datum und Uhrzeit ändern“), mit Ihrer FlixBus-Buchungsnummer: {reference}. Eine Preisdifferenz kann anfallen.',
    nl: 'Een FlixBus-ticket wijzigt u op de website van FlixBus (‘datum en tijd wijzigen’), met uw FlixBus-boekingsnummer: {reference}. Er kan een prijsverschil gelden.',
  },
  helpExchangeBlablacar: {
    id: `${supportV2Scope}.helpExchangeBlablacar`,
    defaultMessage:
      "Un billet BlaBlaCar Bus s'échange sur le site de BlaBlaCar Bus, avec votre numéro de réservation BlaBlaCar Bus : {reference}. La compagnie facture des frais, et une différence de prix peut s'appliquer.",
    en: 'A BlaBlaCar Bus ticket is exchanged on the BlaBlaCar Bus website, with your BlaBlaCar Bus booking number: {reference}. The carrier charges a fee, and a price difference may apply.',
    it: 'Un biglietto BlaBlaCar Bus si cambia sul sito di BlaBlaCar Bus, con il numero di prenotazione BlaBlaCar Bus: {reference}. La compagnia applica una commissione e può esserci una differenza di prezzo.',
    es: 'Un billete de BlaBlaCar Bus se cambia en la web de BlaBlaCar Bus, con tu número de reserva de BlaBlaCar Bus: {reference}. La compañía cobra gastos y puede aplicarse una diferencia de precio.',
    de: 'Ein BlaBlaCar-Bus-Ticket tauschen Sie auf der Website von BlaBlaCar Bus um, mit Ihrer BlaBlaCar-Bus-Buchungsnummer: {reference}. Das Unternehmen berechnet eine Gebühr, und eine Preisdifferenz kann anfallen.',
    nl: 'Een BlaBlaCar Bus-ticket ruilt u om op de website van BlaBlaCar Bus, met uw BlaBlaCar Bus-boekingsnummer: {reference}. De vervoerder rekent kosten en er kan een prijsverschil gelden.',
  },
  helpExchangeTer: {
    id: `${supportV2Scope}.helpExchangeTer`,
    defaultMessage:
      "Certains billets TER sont valables sur tout autre train ou car TER du même jour, sur le même trajet : il est alors inutile de les échanger. Les conditions de votre billet l'indiquent.",
    en: "Some TER tickets are valid on any other TER train or coach the same day, on the same route: then there's no need to exchange them. Your ticket's conditions say so.",
    it: 'Alcuni biglietti TER sono validi su qualsiasi altro treno o pullman TER dello stesso giorno, sulla stessa tratta: in quel caso non serve cambiarli. Le condizioni del tuo biglietto lo indicano.',
    es: 'Algunos billetes TER son válidos en cualquier otro tren o autocar TER del mismo día, en el mismo trayecto: entonces no hace falta cambiarlos. Las condiciones de tu billete lo indican.',
    de: 'Manche TER-Tickets gelten am selben Tag auf derselben Strecke in jedem anderen TER-Zug oder -Bus: Dann müssen Sie sie nicht umtauschen. Die Bedingungen Ihres Tickets geben das an.',
    nl: 'Sommige TER-tickets zijn dezelfde dag geldig in elke andere TER-trein of -bus op hetzelfde traject: dan hoeft u ze niet om te ruilen. De voorwaarden van uw ticket vermelden dat.',
  },
  helpChangeStations: {
    id: `${supportV2Scope}.helpChangeStations`,
    defaultMessage:
      "La gare de départ ou d'arrivée d'un billet ne peut pas être modifiée. Si ses conditions le permettent, annulez-le puis réservez le nouveau trajet.",
    en: "A ticket's departure or arrival station cannot be changed. If its conditions allow, cancel it and then book the new trip.",
    it: 'La stazione di partenza o di arrivo di un biglietto non può essere modificata. Se le condizioni lo consentono, annullalo e poi prenota il nuovo viaggio.',
    es: 'La estación de salida o de llegada de un billete no se puede modificar. Si sus condiciones lo permiten, cancélalo y reserva después el nuevo trayecto.',
    de: 'Abfahrts- oder Ankunftsbahnhof eines Tickets lassen sich nicht ändern. Wenn die Bedingungen es erlauben, stornieren Sie es und buchen Sie dann die neue Fahrt.',
    nl: 'Het vertrek- of aankomststation van een ticket kan niet worden gewijzigd. Als de voorwaarden het toestaan, annuleert u het en boekt u daarna de nieuwe rit.',
  },
  helpChangeStationsOuigo: {
    id: `${supportV2Scope}.helpChangeStationsOuigo`,
    defaultMessage:
      'Sur OUIGO, un changement de gare se fait sur le site OUIGO, comme un échange, avec votre numéro de réservation OUIGO : {reference}.',
    en: 'On OUIGO, a station change is made on the OUIGO website, like an exchange, with your OUIGO booking number: {reference}.',
    it: 'Su OUIGO, il cambio di stazione si fa sul sito OUIGO, come un cambio di biglietto, con il numero di prenotazione OUIGO: {reference}.',
    es: 'En OUIGO, el cambio de estación se hace en la web de OUIGO, como un cambio de billete, con tu número de reserva de OUIGO: {reference}.',
    de: 'Bei OUIGO ändern Sie den Bahnhof auf der OUIGO-Website wie bei einem Umtausch, mit Ihrer OUIGO-Buchungsnummer: {reference}.',
    nl: 'Bij OUIGO wijzigt u het station op de OUIGO-website, net als bij omruilen, met uw OUIGO-boekingsnummer: {reference}.',
  },
  helpAddTrip: {
    id: `${supportV2Scope}.helpAddTrip`,
    defaultMessage:
      'Un trajet ne peut pas être ajouté à une commande existante : réservez-le simplement à part. Pour remplacer un trajet, annulez-le si ses conditions le permettent, puis réservez le nouveau.',
    en: "A trip can't be added to an existing order: simply book it separately. To replace a trip, cancel it if its conditions allow, then book the new one.",
    it: 'Non si può aggiungere un viaggio a un ordine esistente: prenotalo semplicemente a parte. Per sostituire un viaggio, annullalo se le condizioni lo consentono, poi prenota quello nuovo.',
    es: 'No se puede añadir un trayecto a un pedido existente: resérvalo simplemente aparte. Para sustituir un trayecto, cancélalo si sus condiciones lo permiten y reserva el nuevo.',
    de: 'Eine Fahrt lässt sich keiner bestehenden Bestellung hinzufügen: Buchen Sie sie einfach separat. Um eine Fahrt zu ersetzen, stornieren Sie sie, wenn die Bedingungen es erlauben, und buchen Sie die neue.',
    nl: 'Een rit kan niet aan een bestaande bestelling worden toegevoegd: boek hem gewoon apart. Om een rit te vervangen, annuleert u hem als de voorwaarden het toestaan en boekt u de nieuwe.',
  },
  helpAddRemoveTraveller: {
    id: `${supportV2Scope}.helpAddRemoveTraveller`,
    defaultMessage:
      "Un voyageur ne peut pas être ajouté ni retiré d'une réservation existante. Pour un voyageur de plus, faites une nouvelle réservation : les prix peuvent différer et les places côte à côte ne sont pas garanties. Pour un voyageur de moins, ses billets peuvent être annulés selon leurs conditions.",
    en: "A traveller can't be added to or removed from an existing booking. For an extra traveller, make a new booking: prices may differ and seats together aren't guaranteed. For one traveller fewer, their tickets can be cancelled according to their conditions.",
    it: 'Non si può aggiungere né togliere un viaggiatore da una prenotazione esistente. Per un viaggiatore in più, fai una nuova prenotazione: i prezzi possono cambiare e i posti vicini non sono garantiti. Per un viaggiatore in meno, i suoi biglietti possono essere annullati secondo le loro condizioni.',
    es: 'No se puede añadir ni quitar un viajero de una reserva existente. Para un viajero más, haz una nueva reserva: los precios pueden variar y no se garantizan asientos juntos. Para un viajero menos, sus billetes pueden cancelarse según sus condiciones.',
    de: 'Einer bestehenden Buchung lassen sich keine Reisenden hinzufügen oder entfernen. Für einen zusätzlichen Reisenden buchen Sie neu: Die Preise können abweichen, und nebeneinanderliegende Plätze sind nicht garantiert. Für einen Reisenden weniger können dessen Tickets gemäß ihren Bedingungen storniert werden.',
    nl: 'Een reiziger kan niet aan een bestaande boeking worden toegevoegd of eruit worden gehaald. Voor een extra reiziger maakt u een nieuwe boeking: prijzen kunnen verschillen en plaatsen naast elkaar zijn niet gegarandeerd. Voor een reiziger minder kunnen diens tickets volgens hun voorwaarden worden geannuleerd.',
  },
  helpAddRemoveTravellerOuigo: {
    id: `${supportV2Scope}.helpAddRemoveTravellerOuigo`,
    defaultMessage:
      'Sur OUIGO, un enfant ou un animal peut être ajouté depuis le site OUIGO, avec votre numéro de réservation OUIGO : {reference}.',
    en: 'On OUIGO, a child or a pet can be added from the OUIGO website, with your OUIGO booking number: {reference}.',
    it: 'Su OUIGO, un bambino o un animale può essere aggiunto dal sito OUIGO, con il numero di prenotazione OUIGO: {reference}.',
    es: 'En OUIGO, se puede añadir un niño o un animal desde la web de OUIGO, con tu número de reserva de OUIGO: {reference}.',
    de: 'Bei OUIGO können Sie ein Kind oder ein Tier auf der OUIGO-Website hinzufügen, mit Ihrer OUIGO-Buchungsnummer: {reference}.',
    nl: 'Bij OUIGO kunt u een kind of een huisdier toevoegen via de OUIGO-website, met uw OUIGO-boekingsnummer: {reference}.',
  },
  helpNameTypo: {
    id: `${supportV2Scope}.helpNameTypo`,
    defaultMessage:
      "Les informations d'un billet ne peuvent plus être modifiées après la réservation. Une petite faute de frappe ou une inversion entre nom et prénom ne pose en général pas de problème, mais nous ne pouvons pas garantir que le billet sera accepté : en cas de doute, renseignez-vous auprès du transporteur, et voyagez avec votre pièce d'identité.",
    en: "A ticket's details can no longer be changed after booking. A small typo or swapped first and last names usually cause no problem, but we can't guarantee the ticket will be accepted: if in doubt, check with the carrier, and travel with your ID.",
    it: "I dati di un biglietto non possono più essere modificati dopo la prenotazione. Un piccolo errore di battitura o un'inversione tra nome e cognome di solito non crea problemi, ma non possiamo garantire che il biglietto sarà accettato: in caso di dubbio, informati presso il vettore e viaggia con un documento d'identità.",
    es: 'Los datos de un billete ya no se pueden modificar tras la reserva. Una pequeña errata o la inversión de nombre y apellido no suele causar problemas, pero no podemos garantizar que el billete sea aceptado: en caso de duda, consulta con el transportista y viaja con tu documento de identidad.',
    de: 'Die Angaben auf einem Ticket lassen sich nach der Buchung nicht mehr ändern. Ein kleiner Tippfehler oder vertauschte Vor- und Nachnamen sind meist kein Problem, aber wir können nicht garantieren, dass das Ticket akzeptiert wird: Fragen Sie im Zweifel beim Verkehrsunternehmen nach, und reisen Sie mit Ihrem Ausweis.',
    nl: 'De gegevens op een ticket kunnen na het boeken niet meer worden gewijzigd. Een kleine typefout of omgedraaide voor- en achternaam geeft meestal geen probleem, maar we kunnen niet garanderen dat het ticket wordt geaccepteerd: vraag het bij twijfel na bij de vervoerder, en reis met uw identiteitsbewijs.',
  },
  helpTravellersOuigo: {
    id: `${supportV2Scope}.helpTravellersOuigo`,
    defaultMessage:
      "Sur OUIGO, les informations des voyageurs se modifient sur le site OUIGO, avec votre numéro de réservation OUIGO : {reference}. Des frais peuvent s'appliquer.",
    en: 'On OUIGO, traveller details are changed on the OUIGO website, with your OUIGO booking number: {reference}. Fees may apply.',
    it: 'Su OUIGO, i dati dei viaggiatori si modificano sul sito OUIGO, con il numero di prenotazione OUIGO: {reference}. Possono applicarsi delle commissioni.',
    es: 'En OUIGO, los datos de los viajeros se modifican en la web de OUIGO, con tu número de reserva de OUIGO: {reference}. Pueden aplicarse gastos.',
    de: 'Bei OUIGO ändern Sie die Angaben der Reisenden auf der OUIGO-Website, mit Ihrer OUIGO-Buchungsnummer: {reference}. Es können Gebühren anfallen.',
    nl: 'Bij OUIGO wijzigt u de reizigersgegevens op de OUIGO-website, met uw OUIGO-boekingsnummer: {reference}. Er kunnen kosten gelden.',
  },
  helpSwapTraveller: {
    id: `${supportV2Scope}.helpSwapTraveller`,
    defaultMessage:
      "Remplacer un voyageur, ce n'est pas corriger une faute de frappe : un billet nominatif ne peut en général pas être utilisé par quelqu'un d'autre. Selon ses conditions, il peut être annulé, et un nouveau billet réservé au bon nom.",
    en: "Replacing a traveller isn't the same as fixing a typo: a named ticket generally can't be used by someone else. Depending on its conditions, it can be cancelled and a new ticket booked in the right name.",
    it: 'Sostituire un viaggiatore non è come correggere un errore di battitura: un biglietto nominativo di solito non può essere usato da qualcun altro. A seconda delle condizioni, può essere annullato e un nuovo biglietto prenotato al nome giusto.',
    es: 'Sustituir a un viajero no es corregir una errata: un billete nominativo, por lo general, no puede usarlo otra persona. Según sus condiciones, puede cancelarse y reservarse un nuevo billete a nombre correcto.',
    de: 'Einen Reisenden zu ersetzen ist etwas anderes, als einen Tippfehler zu korrigieren: Ein personalisiertes Ticket kann in der Regel nicht von jemand anderem genutzt werden. Je nach Bedingungen kann es storniert und ein neues Ticket auf den richtigen Namen gebucht werden.',
    nl: 'Een reiziger vervangen is niet hetzelfde als een typefout verbeteren: een ticket op naam kan meestal niet door iemand anders worden gebruikt. Afhankelijk van de voorwaarden kan het worden geannuleerd en een nieuw ticket op de juiste naam worden geboekt.',
  },
  helpStates: {
    id: `${supportV2Scope}.helpStates`,
    defaultMessage:
      "Voici l'état enregistré pour chacun des trajets de votre commande.",
    en: 'Here is the recorded status of each leg of your order.',
    it: 'Ecco lo stato registrato per ciascuna tratta del tuo ordine.',
    es: 'Este es el estado registrado de cada trayecto de tu pedido.',
    de: 'Hier ist der gespeicherte Stand jeder Fahrt Ihrer Bestellung.',
    nl: 'Dit is de geregistreerde status van elke rit van uw bestelling.',
  },
  helpRefunds: {
    id: `${supportV2Scope}.helpRefunds`,
    defaultMessage: 'Voici où en sont les remboursements de votre commande.',
    en: 'Here is where the refunds of your order stand.',
    it: 'Ecco a che punto sono i rimborsi del tuo ordine.',
    es: 'Este es el estado de los reembolsos de tu pedido.',
    de: 'So ist der Stand der Erstattungen Ihrer Bestellung.',
    nl: 'Zo staan de terugbetalingen van uw bestelling ervoor.',
  },
  helpRefundsFlixbus: {
    id: `${supportV2Scope}.helpRefundsFlixbus`,
    defaultMessage:
      "Chez FlixBus, le remboursement se fait en bon d'achat, à utiliser sur le site de FlixBus : il vous est envoyé au moment de l'annulation et figure dans votre espace Tictactrip.",
    en: 'With FlixBus, the refund is made as a voucher, to use on the FlixBus website: it is sent to you when you cancel and shows in your Tictactrip account.',
    it: "Con FlixBus, il rimborso avviene con un buono da usare sul sito di FlixBus: ti viene inviato al momento dell'annullamento ed è visibile nel tuo account Tictactrip.",
    es: 'Con FlixBus, el reembolso se hace en forma de bono, para usar en la web de FlixBus: se te envía al cancelar y aparece en tu cuenta de Tictactrip.',
    de: 'Bei FlixBus erfolgt die Erstattung als Gutschein, einlösbar auf der Website von FlixBus: Sie erhalten ihn bei der Stornierung, und er steht in Ihrem Tictactrip-Konto.',
    nl: 'Bij FlixBus gebeurt de terugbetaling met een tegoedbon, te gebruiken op de website van FlixBus: u ontvangt die bij de annulering en hij staat in uw Tictactrip-account.',
  },
  helpRefundsBlablacar: {
    id: `${supportV2Scope}.helpRefundsBlablacar`,
    defaultMessage:
      "Chez BlaBlaCar Bus, le remboursement se fait en bon d'achat, à utiliser sur le site de BlaBlaCar Bus : il vous est envoyé au moment de l'annulation et figure dans votre espace Tictactrip.",
    en: 'With BlaBlaCar Bus, the refund is made as a voucher, to use on the BlaBlaCar Bus website: it is sent to you when you cancel and shows in your Tictactrip account.',
    it: "Con BlaBlaCar Bus, il rimborso avviene con un buono da usare sul sito di BlaBlaCar Bus: ti viene inviato al momento dell'annullamento ed è visibile nel tuo account Tictactrip.",
    es: 'Con BlaBlaCar Bus, el reembolso se hace en forma de bono, para usar en la web de BlaBlaCar Bus: se te envía al cancelar y aparece en tu cuenta de Tictactrip.',
    de: 'Bei BlaBlaCar Bus erfolgt die Erstattung als Gutschein, einlösbar auf der Website von BlaBlaCar Bus: Sie erhalten ihn bei der Stornierung, und er steht in Ihrem Tictactrip-Konto.',
    nl: 'Bij BlaBlaCar Bus gebeurt de terugbetaling met een tegoedbon, te gebruiken op de website van BlaBlaCar Bus: u ontvangt die bij de annulering en hij staat in uw Tictactrip-account.',
  },
  helpRefundDisputed: {
    id: `${supportV2Scope}.helpRefundDisputed`,
    defaultMessage:
      'Voici le montant remboursé pour chaque trajet, et les conditions de chaque billet, qui fixent les éventuels frais. Si le montant ne correspond pas à ce qui vous a été annoncé, dites-le-nous en indiquant le montant attendu.',
    en: "Here is the amount refunded for each leg, and each ticket's conditions, which set any fees. If the amount doesn't match what you were told, let us know the amount you expected.",
    it: "Ecco l'importo rimborsato per ogni tratta e le condizioni di ogni biglietto, che stabiliscono le eventuali commissioni. Se l'importo non corrisponde a quanto ti è stato indicato, faccelo sapere indicando l'importo atteso.",
    es: 'Este es el importe reembolsado de cada trayecto y las condiciones de cada billete, que fijan los posibles gastos. Si el importe no coincide con lo que se te indicó, avísanos indicando el importe esperado.',
    de: 'Hier sehen Sie den erstatteten Betrag für jede Fahrt und die Bedingungen jedes Tickets, die eventuelle Gebühren festlegen. Wenn der Betrag nicht dem entspricht, was Ihnen angekündigt wurde, nennen Sie uns den erwarteten Betrag.',
    nl: 'Hier ziet u het terugbetaalde bedrag per rit en de voorwaarden van elk ticket, die eventuele kosten bepalen. Klopt het bedrag niet met wat u werd gemeld, laat ons dan het verwachte bedrag weten.',
  },
  helpVoucher: {
    id: `${supportV2Scope}.helpVoucher`,
    defaultMessage:
      "Voici le bon d'achat reçu pour votre annulation : il s'utilise sur le site de la compagnie indiquée, jusqu'à sa date de fin de validité.",
    en: "Here is the voucher you received for your cancellation: it's used on the website of the carrier shown, until its expiry date.",
    it: 'Ecco il buono ricevuto per il tuo annullamento: si usa sul sito della compagnia indicata, fino alla data di scadenza.',
    es: 'Este es el bono recibido por tu cancelación: se usa en la web de la compañía indicada, hasta su fecha de caducidad.',
    de: 'Hier ist der Gutschein, den Sie für Ihre Stornierung erhalten haben: Er wird auf der Website des angegebenen Unternehmens eingelöst, bis zu seinem Ablaufdatum.',
    nl: 'Dit is de tegoedbon die u voor uw annulering ontving: u gebruikt hem op de website van de vermelde vervoerder, tot de vervaldatum.',
  },
  helpFees: {
    id: `${supportV2Scope}.helpFees`,
    defaultMessage:
      "Voici le détail de votre commande. Les frais sont affichés avant le paiement, à côté du prix (ⓘ). Si l'écart que vous constatez est différent, dites-le-nous en indiquant les deux montants.",
    en: 'Here is the breakdown of your order. Fees are shown before payment, next to the price (ⓘ). If the difference you see is another one, let us know both amounts.',
    it: "Ecco il dettaglio del tuo ordine. Le commissioni sono mostrate prima del pagamento, accanto al prezzo (ⓘ). Se la differenza che noti è un'altra, faccelo sapere indicando i due importi.",
    es: 'Este es el detalle de tu pedido. Los gastos se muestran antes del pago, junto al precio (ⓘ). Si la diferencia que ves es otra, avísanos indicando los dos importes.',
    de: 'Hier ist die Aufstellung Ihrer Bestellung. Die Gebühren werden vor der Zahlung neben dem Preis angezeigt (ⓘ). Wenn Ihnen eine andere Differenz auffällt, nennen Sie uns beide Beträge.',
    nl: 'Hier ziet u het overzicht van uw bestelling. De kosten worden vóór de betaling naast de prijs getoond (ⓘ). Ziet u een ander verschil, laat ons dan beide bedragen weten.',
  },
  helpPaymentDeclined: {
    id: `${supportV2Scope}.helpPaymentDeclined`,
    defaultMessage:
      "Avant de recommencer l'achat, vérifiez que vous n'avez pas reçu de confirmation de réservation. Le paiement n'a peut-être pas été validé dans l'application de votre banque. Si votre banque affiche un débit alors que le site a annoncé un refus, dites-le-nous : nous vérifierons le paiement et la réservation.",
    en: "Before buying again, check you haven't received a booking confirmation. The payment may not have been approved in your banking app. If your bank shows a charge while the site said the payment was refused, let us know: we'll check the payment and the booking.",
    it: "Prima di ripetere l'acquisto, verifica di non aver ricevuto una conferma di prenotazione. Il pagamento forse non è stato convalidato nell'app della tua banca. Se la banca mostra un addebito mentre il sito ha indicato un rifiuto, faccelo sapere: verificheremo il pagamento e la prenotazione.",
    es: 'Antes de volver a comprar, comprueba que no has recibido una confirmación de reserva. Puede que el pago no se validara en la aplicación de tu banco. Si tu banco muestra un cargo mientras la web indicó un rechazo, avísanos: comprobaremos el pago y la reserva.',
    de: 'Prüfen Sie vor einem erneuten Kauf, dass Sie keine Buchungsbestätigung erhalten haben. Vielleicht wurde die Zahlung in der App Ihrer Bank nicht freigegeben. Wenn Ihre Bank eine Abbuchung anzeigt, die Website aber eine Ablehnung gemeldet hat, sagen Sie uns Bescheid: Wir prüfen Zahlung und Buchung.',
    nl: 'Controleer voordat u opnieuw koopt of u geen boekingsbevestiging hebt ontvangen. Misschien is de betaling niet goedgekeurd in de app van uw bank. Toont uw bank een afschrijving terwijl de site een weigering meldde, laat het ons dan weten: we controleren de betaling en de boeking.',
  },
  helpClaims: {
    id: `${supportV2Scope}.helpClaims`,
    defaultMessage:
      'Une indemnisation pour retard dépend du transporteur et du trajet, et se demande auprès de lui : le guide de votre transporteur explique la démarche.',
    en: "Compensation for a delay depends on the carrier and the trip, and is claimed from the carrier: your carrier's guide explains how.",
    it: 'Un indennizzo per ritardo dipende dal vettore e dal viaggio, e si chiede al vettore: la guida del tuo vettore spiega come fare.',
    es: 'Una indemnización por retraso depende del transportista y del trayecto, y se pide al transportista: la guía de tu transportista explica cómo hacerlo.',
    de: 'Eine Entschädigung für eine Verspätung hängt vom Verkehrsunternehmen und der Fahrt ab und wird bei ihm beantragt: Der Leitfaden Ihres Verkehrsunternehmens erklärt das Vorgehen.',
    nl: 'Een vergoeding voor vertraging hangt af van de vervoerder en de rit, en vraagt u aan bij de vervoerder: de gids van uw vervoerder legt uit hoe.',
  },
  helpClaimsTer: {
    id: `${supportV2Scope}.helpClaimsTer`,
    defaultMessage:
      'Pour un TER, la réclamation se fait sur le formulaire de la région indiquée sur votre billet : le guide TER donne le lien de chaque région.',
    en: "For a TER train, the claim is made on the form of the region shown on your ticket: the TER guide links to each region's form.",
    it: 'Per un TER, il reclamo si fa con il modulo della regione indicata sul biglietto: la guida TER riporta il link di ogni regione.',
    es: 'Para un TER, la reclamación se hace en el formulario de la región indicada en tu billete: la guía TER enlaza el de cada región.',
    de: 'Bei einem TER-Zug reichen Sie die Beschwerde über das Formular der auf Ihrem Ticket angegebenen Region ein: Der TER-Leitfaden verlinkt jede Region.',
    nl: 'Voor een TER-trein dient u de claim in via het formulier van de regio op uw ticket: de TER-gids linkt naar elke regio.',
  },
  helpClaimsSncf: {
    id: `${supportV2Scope}.helpClaimsSncf`,
    defaultMessage:
      "Pour un TGV INOUI, un Intercités ou un Lyria, la demande d'indemnisation se fait directement auprès de la SNCF : le guide explique la démarche.",
    en: 'For a TGV INOUI, Intercités or Lyria train, compensation is claimed directly from SNCF: the guide explains how.',
    it: 'Per un TGV INOUI, un Intercités o un Lyria, la richiesta di indennizzo si fa direttamente alla SNCF: la guida spiega come fare.',
    es: 'Para un TGV INOUI, un Intercités o un Lyria, la solicitud de indemnización se hace directamente ante la SNCF: la guía explica cómo hacerlo.',
    de: 'Bei einem TGV INOUI, Intercités oder Lyria beantragen Sie die Entschädigung direkt bei der SNCF: Der Leitfaden erklärt das Vorgehen.',
    nl: 'Voor een TGV INOUI, Intercités of Lyria vraagt u de vergoeding rechtstreeks aan bij SNCF: de gids legt uit hoe.',
  },
  helpClaimsOuigo: {
    id: `${supportV2Scope}.helpClaimsOuigo`,
    defaultMessage:
      "Chez OUIGO, la compensation d'un retard est automatique : elle vous est envoyée par email, en bon d'achat, selon la durée du retard.",
    en: "With OUIGO, delay compensation is automatic: it's emailed to you as a voucher, depending on the length of the delay.",
    it: "Con OUIGO, l'indennizzo per ritardo è automatico: ti viene inviato via email sotto forma di buono, in base alla durata del ritardo.",
    es: 'Con OUIGO, la compensación por retraso es automática: se te envía por correo en forma de bono, según la duración del retraso.',
    de: 'Bei OUIGO erfolgt die Entschädigung für eine Verspätung automatisch: Sie erhalten sie per E-Mail als Gutschein, je nach Dauer der Verspätung.',
    nl: 'Bij OUIGO gaat de vergoeding voor vertraging automatisch: u ontvangt die per e-mail als tegoedbon, afhankelijk van de duur van de vertraging.',
  },
  helpClaimsEurostar: {
    id: `${supportV2Scope}.helpClaimsEurostar`,
    defaultMessage:
      "Chez Eurostar, un retard important ouvre droit à une compensation, à demander sur le site d'Eurostar : le guide détaille les conditions et la démarche.",
    en: 'With Eurostar, a significant delay entitles you to compensation, to claim on the Eurostar website: the guide details the conditions and steps.',
    it: 'Con Eurostar, un ritardo importante dà diritto a un indennizzo, da chiedere sul sito di Eurostar: la guida dettaglia condizioni e procedura.',
    es: 'Con Eurostar, un retraso importante da derecho a una compensación, que se pide en la web de Eurostar: la guía detalla las condiciones y los pasos.',
    de: 'Bei Eurostar berechtigt eine erhebliche Verspätung zu einer Entschädigung, die Sie auf der Eurostar-Website beantragen: Der Leitfaden erläutert Bedingungen und Vorgehen.',
    nl: 'Bij Eurostar geeft een flinke vertraging recht op een vergoeding, aan te vragen op de website van Eurostar: de gids beschrijft de voorwaarden en stappen.',
  },
  helpClaimsFlixbus: {
    id: `${supportV2Scope}.helpClaimsFlixbus`,
    defaultMessage:
      'Chez FlixBus, la réclamation se fait directement auprès de la compagnie, avec votre numéro de réservation FlixBus : {reference}.',
    en: 'With FlixBus, you claim directly from the carrier, with your FlixBus booking number: {reference}.',
    it: 'Con FlixBus, il reclamo si fa direttamente presso la compagnia, con il numero di prenotazione FlixBus: {reference}.',
    es: 'Con FlixBus, la reclamación se hace directamente ante la compañía, con tu número de reserva de FlixBus: {reference}.',
    de: 'Bei FlixBus reichen Sie die Beschwerde direkt beim Unternehmen ein, mit Ihrer FlixBus-Buchungsnummer: {reference}.',
    nl: 'Bij FlixBus dient u de claim rechtstreeks in bij de vervoerder, met uw FlixBus-boekingsnummer: {reference}.',
  },
  helpClaimsBlablacar: {
    id: `${supportV2Scope}.helpClaimsBlablacar`,
    defaultMessage:
      'Chez BlaBlaCar Bus, la réclamation se fait directement auprès de la compagnie, avec votre numéro de réservation BlaBlaCar Bus : {reference}.',
    en: 'With BlaBlaCar Bus, you claim directly from the carrier, with your BlaBlaCar Bus booking number: {reference}.',
    it: 'Con BlaBlaCar Bus, il reclamo si fa direttamente presso la compagnia, con il numero di prenotazione BlaBlaCar Bus: {reference}.',
    es: 'Con BlaBlaCar Bus, la reclamación se hace directamente ante la compañía, con tu número de reserva de BlaBlaCar Bus: {reference}.',
    de: 'Bei BlaBlaCar Bus reichen Sie die Beschwerde direkt beim Unternehmen ein, mit Ihrer BlaBlaCar Bus-Buchungsnummer: {reference}.',
    nl: 'Bij BlaBlaCar Bus dient u de claim rechtstreeks in bij de vervoerder, met uw BlaBlaCar Bus-boekingsnummer: {reference}.',
  },
  helpDelayNow: {
    id: `${supportV2Scope}.helpDelayNow`,
    defaultMessage:
      "Pour l'information en temps réel, suivez l'application, le site ou les annonces du transporteur. Si ce retard vous fait manquer une correspondance, dites-le-nous en précisant les deux trajets.",
    en: "For real-time information, follow the carrier's app, website or announcements. If this delay makes you miss a connection, let us know, giving both legs.",
    it: "Per le informazioni in tempo reale, segui l'app, il sito o gli annunci del vettore. Se questo ritardo ti fa perdere una coincidenza, faccelo sapere indicando le due tratte.",
    es: 'Para información en tiempo real, sigue la aplicación, la web o los avisos del transportista. Si este retraso te hace perder una conexión, avísanos indicando los dos trayectos.',
    de: 'Echtzeitinformationen erhalten Sie über die App, die Website oder die Durchsagen des Verkehrsunternehmens. Wenn Sie durch die Verspätung einen Anschluss verpassen, sagen Sie uns Bescheid und nennen Sie beide Fahrten.',
    nl: 'Volg voor actuele informatie de app, de website of de omroepberichten van de vervoerder. Mist u door deze vertraging een overstap, laat het ons dan weten met beide ritten.',
  },
  helpMissedConnection: {
    id: `${supportV2Scope}.helpMissedConnection`,
    defaultMessage:
      'Si vous êtes en route, adressez-vous au personnel ou au service client du transporteur pour connaître les solutions possibles : ne supposez pas que votre billet sera accepté sur un autre départ sans son accord.',
    en: "If you're on your way, ask the carrier's staff or customer service about possible solutions: don't assume your ticket will be accepted on another departure without their agreement.",
    it: "Se sei in viaggio, rivolgiti al personale o al servizio clienti del vettore per conoscere le soluzioni possibili: non dare per scontato che il tuo biglietto sarà accettato su un'altra partenza senza il suo accordo.",
    es: 'Si estás en camino, dirígete al personal o al servicio de atención al cliente del transportista para conocer las soluciones posibles: no des por hecho que tu billete será aceptado en otra salida sin su acuerdo.',
    de: 'Wenn Sie unterwegs sind, wenden Sie sich an das Personal oder den Kundenservice des Verkehrsunternehmens, um mögliche Lösungen zu erfahren: Gehen Sie nicht davon aus, dass Ihr Ticket ohne dessen Zustimmung für eine andere Abfahrt gilt.',
    nl: 'Bent u onderweg, vraag dan het personeel of de klantenservice van de vervoerder naar mogelijke oplossingen: ga er niet van uit dat uw ticket zonder hun akkoord op een ander vertrek wordt geaccepteerd.',
  },
  helpDayValidityTer: {
    id: `${supportV2Scope}.helpDayValidityTer`,
    defaultMessage:
      "Pour un TER, les conditions de votre billet indiquent s'il est valable sur un autre train ou car TER du même jour.",
    en: "For a TER train, your ticket's conditions say whether it's valid on another TER train or coach the same day.",
    it: 'Per un TER, le condizioni del tuo biglietto indicano se è valido su un altro treno o pullman TER dello stesso giorno.',
    es: 'Para un TER, las condiciones de tu billete indican si es válido en otro tren o autocar TER del mismo día.',
    de: 'Bei einem TER-Zug geben die Bedingungen Ihres Tickets an, ob es am selben Tag in einem anderen TER-Zug oder -Bus gilt.',
    nl: 'Voor een TER-trein vermelden de voorwaarden van uw ticket of het dezelfde dag geldig is in een andere TER-trein of -bus.',
  },
  helpMissedConnectionFlixbus: {
    id: `${supportV2Scope}.helpMissedConnectionFlixbus`,
    defaultMessage:
      "FlixBus ne garantit pas les correspondances manquées à cause d'un retard. Vous pouvez modifier votre billet sur le site de FlixBus, avec votre numéro de réservation FlixBus.",
    en: "FlixBus doesn't guarantee connections missed because of a delay. You can change your ticket on the FlixBus website, with your FlixBus booking number.",
    it: 'FlixBus non garantisce le coincidenze perse a causa di un ritardo. Puoi modificare il biglietto sul sito di FlixBus, con il numero di prenotazione FlixBus.',
    es: 'FlixBus no garantiza las conexiones perdidas por un retraso. Puedes modificar tu billete en la web de FlixBus, con tu número de reserva de FlixBus.',
    de: 'FlixBus garantiert keine Anschlüsse, die wegen einer Verspätung verpasst wurden. Sie können Ihr Ticket auf der FlixBus-Website ändern, mit Ihrer FlixBus-Buchungsnummer.',
    nl: 'FlixBus garandeert geen overstappen die door vertraging zijn gemist. U kunt uw ticket wijzigen op de website van FlixBus, met uw FlixBus-boekingsnummer.',
  },
  helpMissedDeparture: {
    id: `${supportV2Scope}.helpMissedDeparture`,
    defaultMessage:
      "Un départ manqué n'est en général pas remboursé : les compagnies considèrent le trajet comme effectué. Les conditions de votre billet indiquent si un autre départ reste possible. Si une correspondance est en jeu, dites-le-nous vite.",
    en: "A missed departure is generally not refunded: carriers consider the trip as taken. Your ticket's conditions say whether another departure is still possible. If a connection is at stake, let us know quickly.",
    it: "Una partenza persa di solito non viene rimborsata: le compagnie considerano il viaggio come effettuato. Le condizioni del tuo biglietto indicano se è ancora possibile un'altra partenza. Se c'è di mezzo una coincidenza, faccelo sapere in fretta.",
    es: 'Una salida perdida, por lo general, no se reembolsa: las compañías consideran el trayecto como realizado. Las condiciones de tu billete indican si aún es posible otra salida. Si hay una conexión en juego, avísanos rápido.',
    de: 'Eine verpasste Abfahrt wird in der Regel nicht erstattet: Die Unternehmen betrachten die Fahrt als angetreten. Die Bedingungen Ihres Tickets geben an, ob eine andere Abfahrt noch möglich ist. Wenn ein Anschluss auf dem Spiel steht, sagen Sie uns schnell Bescheid.',
    nl: 'Een gemist vertrek wordt meestal niet terugbetaald: vervoerders beschouwen de rit als gemaakt. De voorwaarden van uw ticket vermelden of een ander vertrek nog mogelijk is. Staat er een overstap op het spel, laat het ons dan snel weten.',
  },
  helpCarrierCancellationEurostar: {
    id: `${supportV2Scope}.helpCarrierCancellationEurostar`,
    defaultMessage:
      "Si Eurostar a supprimé votre train ou annoncé un retard important avant le départ, vous pouvez échanger gratuitement votre billet sur le site d'Eurostar : le guide détaille vos options.",
    en: 'If Eurostar cancelled your train or announced a major delay before departure, you can exchange your ticket free of charge on the Eurostar website: the guide details your options.',
    it: 'Se Eurostar ha soppresso il tuo treno o annunciato un ritardo importante prima della partenza, puoi cambiare gratuitamente il biglietto sul sito di Eurostar: la guida dettaglia le tue opzioni.',
    es: 'Si Eurostar canceló tu tren o anunció un retraso importante antes de la salida, puedes cambiar tu billete gratis en la web de Eurostar: la guía detalla tus opciones.',
    de: 'Wenn Eurostar Ihren Zug gestrichen oder vor der Abfahrt eine erhebliche Verspätung angekündigt hat, können Sie Ihr Ticket kostenlos auf der Eurostar-Website umtauschen: Der Leitfaden erläutert Ihre Möglichkeiten.',
    nl: 'Als Eurostar uw trein heeft geschrapt of vóór vertrek een flinke vertraging heeft aangekondigd, kunt u uw ticket gratis omruilen op de website van Eurostar: de gids beschrijft uw opties.',
  },
  helpLostItem: {
    id: `${supportV2Scope}.helpLostItem`,
    defaultMessage:
      "Pour un objet oublié à bord ou en gare, c'est le service des objets trouvés du transporteur ou de la gare qui peut vous aider. Préparez la date, le trajet et une description de l'objet.",
    en: 'For an item left on board or in a station, the lost property service of the carrier or the station can help you. Have the date, the trip and a description of the item ready.',
    it: "Per un oggetto dimenticato a bordo o in stazione, può aiutarti il servizio oggetti smarriti del vettore o della stazione. Tieni pronti la data, il viaggio e una descrizione dell'oggetto.",
    es: 'Para un objeto olvidado a bordo o en la estación, puede ayudarte el servicio de objetos perdidos del transportista o de la estación. Ten a mano la fecha, el trayecto y una descripción del objeto.',
    de: 'Bei einem an Bord oder im Bahnhof vergessenen Gegenstand hilft Ihnen das Fundbüro des Verkehrsunternehmens oder des Bahnhofs. Halten Sie Datum, Fahrt und eine Beschreibung des Gegenstands bereit.',
    nl: 'Voor een voorwerp dat u aan boord of in een station bent vergeten, kan de dienst gevonden voorwerpen van de vervoerder of het station u helpen. Houd de datum, de rit en een beschrijving van het voorwerp bij de hand.',
  },
  helpFindStation: {
    id: `${supportV2Scope}.helpFindStation`,
    defaultMessage: 'Le nom exact de la gare figure aussi sur votre billet.',
    en: 'The exact station name is also on your ticket.',
    it: 'Il nome esatto della stazione è riportato anche sul biglietto.',
    es: 'El nombre exacto de la estación también figura en tu billete.',
    de: 'Der genaue Name des Bahnhofs steht auch auf Ihrem Ticket.',
    nl: 'De exacte naam van het station staat ook op uw ticket.',
  },
  helpFindStationBus: {
    id: `${supportV2Scope}.helpFindStationBus`,
    defaultMessage:
      "Les bus partent le plus souvent de la gare routière, près de la gare : en cas de doute, l'adresse figure sur votre billet.",
    en: 'Buses usually leave from the bus station, near the train station: if in doubt, the address is on your ticket.',
    it: "Gli autobus partono di solito dalla stazione degli autobus, vicino alla stazione ferroviaria: in caso di dubbio, l'indirizzo è sul biglietto.",
    es: 'Los autobuses suelen salir de la estación de autobuses, cerca de la estación de tren: en caso de duda, la dirección figura en tu billete.',
    de: 'Busse fahren meist vom Busbahnhof in der Nähe des Bahnhofs ab: Im Zweifel steht die Adresse auf Ihrem Ticket.',
    nl: 'Bussen vertrekken meestal vanaf het busstation, vlak bij het treinstation: bij twijfel staat het adres op uw ticket.',
  },
  helpTransfer: {
    id: `${supportV2Scope}.helpTransfer`,
    defaultMessage:
      "Si vous arrivez dans une gare et repartez d'une autre, le trajet entre les deux n'est compris dans vos billets que s'il figure dans votre commande.",
    en: "If you arrive at one station and leave from another, the journey between them is only included in your tickets if it's part of your order.",
    it: "Se arrivi in una stazione e riparti da un'altra, il tragitto tra le due è compreso nei tuoi biglietti solo se fa parte del tuo ordine.",
    es: 'Si llegas a una estación y sales de otra, el trayecto entre ambas solo está incluido en tus billetes si forma parte de tu pedido.',
    de: 'Wenn Sie an einem Bahnhof ankommen und von einem anderen abfahren, ist der Weg dazwischen nur dann in Ihren Tickets enthalten, wenn er Teil Ihrer Bestellung ist.',
    nl: 'Als u op het ene station aankomt en van een ander vertrekt, zit de verbinding daartussen alleen in uw tickets als die deel uitmaakt van uw bestelling.',
  },
  helpLuggage: {
    id: `${supportV2Scope}.helpLuggage`,
    defaultMessage:
      'Les bagages autorisés dépendent du transporteur : son guide détaille les règles et les options.',
    en: 'Allowed luggage depends on the carrier: its guide details the rules and options.',
    it: 'I bagagli consentiti dipendono dal vettore: la sua guida dettaglia regole e opzioni.',
    es: 'El equipaje permitido depende del transportista: su guía detalla las normas y las opciones.',
    de: 'Welches Gepäck erlaubt ist, hängt vom Verkehrsunternehmen ab: Sein Leitfaden erläutert Regeln und Optionen.',
    nl: 'Welke bagage is toegestaan, hangt af van de vervoerder: de gids beschrijft de regels en opties.',
  },
  helpOptionsOuigo: {
    id: `${supportV2Scope}.helpOptionsOuigo`,
    defaultMessage:
      "Chez OUIGO, bagages en plus, vélos et autres options s'ajoutent sur le site OUIGO, avec votre numéro de réservation OUIGO : {reference}.",
    en: 'With OUIGO, extra luggage, bikes and other options are added on the OUIGO website, with your OUIGO booking number: {reference}.',
    it: 'Con OUIGO, bagagli extra, bici e altre opzioni si aggiungono sul sito OUIGO, con il numero di prenotazione OUIGO: {reference}.',
    es: 'Con OUIGO, el equipaje extra, las bicicletas y otras opciones se añaden en la web de OUIGO, con tu número de reserva de OUIGO: {reference}.',
    de: 'Bei OUIGO fügen Sie zusätzliches Gepäck, Fahrräder und andere Optionen auf der OUIGO-Website hinzu, mit Ihrer OUIGO-Buchungsnummer: {reference}.',
    nl: 'Bij OUIGO voegt u extra bagage, fietsen en andere opties toe op de OUIGO-website, met uw OUIGO-boekingsnummer: {reference}.',
  },
  helpLuggageFlixbus: {
    id: `${supportV2Scope}.helpLuggageFlixbus`,
    defaultMessage:
      "Chez FlixBus, un bagage en plus s'ajoute sur le site de FlixBus, avec votre numéro de réservation FlixBus : {reference}.",
    en: 'With FlixBus, extra luggage is added on the FlixBus website, with your FlixBus booking number: {reference}.',
    it: 'Con FlixBus, un bagaglio extra si aggiunge sul sito di FlixBus, con il numero di prenotazione FlixBus: {reference}.',
    es: 'Con FlixBus, el equipaje extra se añade en la web de FlixBus, con tu número de reserva de FlixBus: {reference}.',
    de: 'Bei FlixBus fügen Sie zusätzliches Gepäck auf der FlixBus-Website hinzu, mit Ihrer FlixBus-Buchungsnummer: {reference}.',
    nl: 'Bij FlixBus voegt u extra bagage toe op de website van FlixBus, met uw FlixBus-boekingsnummer: {reference}.',
  },
  helpLuggageBlablacar: {
    id: `${supportV2Scope}.helpLuggageBlablacar`,
    defaultMessage:
      'Chez BlaBlaCar Bus, aucun bagage ne peut être ajouté à la réservation : le guide précise les bagages compris.',
    en: 'With BlaBlaCar Bus, no luggage can be added to the booking: the guide details the luggage included.',
    it: 'Con BlaBlaCar Bus non si possono aggiungere bagagli alla prenotazione: la guida precisa i bagagli compresi.',
    es: 'Con BlaBlaCar Bus no se puede añadir equipaje a la reserva: la guía detalla el equipaje incluido.',
    de: 'Bei BlaBlaCar Bus lässt sich der Buchung kein Gepäck hinzufügen: Der Leitfaden nennt das enthaltene Gepäck.',
    nl: 'Bij BlaBlaCar Bus kan geen bagage aan de boeking worden toegevoegd: de gids vermeldt de inbegrepen bagage.',
  },
  helpPets: {
    id: `${supportV2Scope}.helpPets`,
    defaultMessage:
      'Les conditions de transport des animaux varient selon la compagnie : consultez celles de votre trajet avant le voyage.',
    en: 'Pet travel conditions vary by carrier: check those for your trip before travelling.',
    it: 'Le condizioni di trasporto degli animali variano a seconda della compagnia: consulta quelle del tuo viaggio prima di partire.',
    es: 'Las condiciones de transporte de animales varían según la compañía: consulta las de tu trayecto antes del viaje.',
    de: 'Die Bedingungen für die Mitnahme von Tieren unterscheiden sich je nach Unternehmen: Prüfen Sie die für Ihre Fahrt vor der Reise.',
    nl: 'De voorwaarden voor het vervoer van dieren verschillen per vervoerder: bekijk die van uw rit vóór vertrek.',
  },
  helpPetsTrain: {
    id: `${supportV2Scope}.helpPetsTrain`,
    defaultMessage:
      "En train, certaines compagnies demandent un billet pour l'animal : les conditions varient selon la compagnie.",
    en: 'By train, some carriers require a ticket for the animal: conditions vary by carrier.',
    it: "In treno, alcune compagnie richiedono un biglietto per l'animale: le condizioni variano a seconda della compagnia.",
    es: 'En tren, algunas compañías piden un billete para el animal: las condiciones varían según la compañía.',
    de: 'Im Zug verlangen manche Unternehmen ein Ticket für das Tier: Die Bedingungen sind je nach Unternehmen unterschiedlich.',
    nl: 'In de trein vragen sommige vervoerders een ticket voor het dier: de voorwaarden verschillen per vervoerder.',
  },
  helpPetsBus: {
    id: `${supportV2Scope}.helpPetsBus`,
    defaultMessage:
      "En bus, les animaux sont le plus souvent refusés, en dehors des chiens d'assistance : vérifiez les conditions de la compagnie.",
    en: "By bus, animals are usually not allowed, apart from assistance dogs: check the carrier's conditions.",
    it: "In autobus gli animali sono spesso rifiutati, tranne i cani d'assistenza: verifica le condizioni della compagnia.",
    es: 'En autobús, los animales suelen no admitirse, salvo los perros de asistencia: consulta las condiciones de la compañía.',
    de: 'Im Bus sind Tiere meist nicht erlaubt, außer Assistenzhunden: Prüfen Sie die Bedingungen des Unternehmens.',
    nl: 'In de bus zijn dieren meestal niet toegestaan, behalve assistentiehonden: bekijk de voorwaarden van de vervoerder.',
  },
  helpPetsBlablacar: {
    id: `${supportV2Scope}.helpPetsBlablacar`,
    defaultMessage:
      "Chez BlaBlaCar Bus, les animaux ne sont pas acceptés à bord, sauf les chiens d'assistance.",
    en: 'With BlaBlaCar Bus, animals are not allowed on board, except assistance dogs.',
    it: "Con BlaBlaCar Bus gli animali non sono ammessi a bordo, tranne i cani d'assistenza.",
    es: 'Con BlaBlaCar Bus no se admiten animales a bordo, salvo los perros de asistencia.',
    de: 'Bei BlaBlaCar Bus sind Tiere an Bord nicht erlaubt, außer Assistenzhunden.',
    nl: 'Bij BlaBlaCar Bus zijn dieren niet toegestaan aan boord, behalve assistentiehonden.',
  },
  helpSeats: {
    id: `${supportV2Scope}.helpSeats`,
    defaultMessage:
      'Les places sont attribuées automatiquement, au plus près les unes des autres, et ne peuvent plus être modifiées après la réservation.',
    en: 'Seats are assigned automatically, as close together as possible, and can no longer be changed after booking.',
    it: 'I posti vengono assegnati automaticamente, il più vicino possibile tra loro, e non possono più essere modificati dopo la prenotazione.',
    es: 'Los asientos se asignan automáticamente, lo más cerca posible entre sí, y ya no se pueden cambiar tras la reserva.',
    de: 'Die Plätze werden automatisch und möglichst nah beieinander zugewiesen und lassen sich nach der Buchung nicht mehr ändern.',
    nl: 'Plaatsen worden automatisch toegewezen, zo dicht mogelijk bij elkaar, en kunnen na het boeken niet meer worden gewijzigd.',
  },
  helpSeatsTer: {
    id: `${supportV2Scope}.helpSeatsTer`,
    defaultMessage:
      'Dans les TER, le placement est en général libre : installez-vous où vous voulez.',
    en: 'On TER trains, seating is generally free: sit wherever you like.',
    it: 'Sui TER i posti sono generalmente liberi: siediti dove vuoi.',
    es: 'En los TER, los asientos suelen ser libres: siéntate donde quieras.',
    de: 'In TER-Zügen gilt meist freie Platzwahl: Setzen Sie sich, wohin Sie möchten.',
    nl: 'In TER-treinen is de plaats meestal vrij: ga zitten waar u wilt.',
  },
  helpSeatsOuigo: {
    id: `${supportV2Scope}.helpSeatsOuigo`,
    defaultMessage:
      'Chez OUIGO, vous pouvez changer de place sur le site OUIGO, avec votre numéro de réservation OUIGO : {reference}.',
    en: 'With OUIGO, you can change seats on the OUIGO website, with your OUIGO booking number: {reference}.',
    it: 'Con OUIGO puoi cambiare posto sul sito OUIGO, con il numero di prenotazione OUIGO: {reference}.',
    es: 'Con OUIGO puedes cambiar de asiento en la web de OUIGO, con tu número de reserva de OUIGO: {reference}.',
    de: 'Bei OUIGO können Sie Ihren Platz auf der OUIGO-Website ändern, mit Ihrer OUIGO-Buchungsnummer: {reference}.',
    nl: 'Bij OUIGO kunt u van plaats wisselen op de OUIGO-website, met uw OUIGO-boekingsnummer: {reference}.',
  },
  helpAskReference: {
    id: `${supportV2Scope}.helpAskReference`,
    defaultMessage: 'demandez-le-nous',
    en: 'ask us for it',
    it: 'chiedicelo',
    es: 'pídenoslo',
    de: 'Fragen Sie uns danach',
    nl: 'vraag het ons',
  },
  helpOptions: {
    id: `${supportV2Scope}.helpOptions`,
    defaultMessage:
      'Les options et le changement de classe dépendent du billet et des disponibilités. Changer de classe revient en général à échanger le billet : vérifiez ses conditions.',
    en: 'Options and class changes depend on the ticket and availability. Changing class generally means exchanging the ticket: check its conditions.',
    it: 'Le opzioni e il cambio di classe dipendono dal biglietto e dalla disponibilità. Cambiare classe di solito significa cambiare il biglietto: verificane le condizioni.',
    es: 'Las opciones y el cambio de clase dependen del billete y de la disponibilidad. Cambiar de clase suele equivaler a cambiar el billete: consulta sus condiciones.',
    de: 'Optionen und ein Klassenwechsel hängen vom Ticket und der Verfügbarkeit ab. Ein Klassenwechsel bedeutet meist einen Umtausch des Tickets: Prüfen Sie seine Bedingungen.',
    nl: 'Opties en een klassewissel hangen af van het ticket en de beschikbaarheid. Van klasse wisselen betekent meestal het ticket omruilen: bekijk de voorwaarden.',
  },
  helpOptionsBus: {
    id: `${supportV2Scope}.helpOptionsBus`,
    defaultMessage:
      'Les compagnies de bus proposent le plus souvent une seule classe.',
    en: 'Bus companies usually offer a single class.',
    it: "Le compagnie di autobus offrono di solito un'unica classe.",
    es: 'Las compañías de autobús suelen ofrecer una sola clase.',
    de: 'Busunternehmen bieten meist nur eine Klasse an.',
    nl: 'Busmaatschappijen bieden meestal maar één klasse aan.',
  },
  helpAccessibility: {
    id: `${supportV2Scope}.helpAccessibility`,
    defaultMessage:
      "L'assistance se demande auprès de chaque transporteur, selon sa procédure : son guide explique comment faire.",
    en: 'Assistance is requested from each carrier, following its own procedure: its guide explains how.',
    it: "L'assistenza si richiede a ciascun vettore, secondo la sua procedura: la sua guida spiega come fare.",
    es: 'La asistencia se solicita a cada transportista, según su procedimiento: su guía explica cómo hacerlo.',
    de: 'Hilfe beantragen Sie beim jeweiligen Verkehrsunternehmen nach dessen Verfahren: Sein Leitfaden erklärt, wie das geht.',
    nl: 'Assistentie vraagt u aan bij elke vervoerder, volgens diens procedure: de gids legt uit hoe.',
  },
  helpChildren: {
    id: `${supportV2Scope}.helpChildren`,
    defaultMessage:
      "Un billet ne comprend pas d'accompagnement : si un enfant voyage seul, vérifiez que le transporteur propose ce service et qu'il est bien réservé.",
    en: "A ticket doesn't include a chaperone service: if a child travels alone, check that the carrier offers this service and that it's booked.",
    it: "Un biglietto non comprende l'accompagnamento: se un bambino viaggia da solo, verifica che il vettore offra questo servizio e che sia prenotato.",
    es: 'Un billete no incluye acompañamiento: si un niño viaja solo, comprueba que el transportista ofrezca este servicio y que esté reservado.',
    de: 'Ein Ticket umfasst keine Begleitung: Wenn ein Kind allein reist, prüfen Sie, ob das Verkehrsunternehmen diesen Service anbietet und ob er gebucht ist.',
    nl: 'Een ticket omvat geen begeleiding: reist een kind alleen, controleer dan of de vervoerder deze dienst aanbiedt en of die geboekt is.',
  },
  helpChildrenFlixbus: {
    id: `${supportV2Scope}.helpChildrenFlixbus`,
    defaultMessage:
      'Chez FlixBus, les enfants de moins de 16 ans ne peuvent pas voyager seuls.',
    en: "With FlixBus, children under 16 can't travel alone.",
    it: 'Con FlixBus, i bambini sotto i 16 anni non possono viaggiare da soli.',
    es: 'Con FlixBus, los menores de 16 años no pueden viajar solos.',
    de: 'Bei FlixBus dürfen Kinder unter 16 Jahren nicht allein reisen.',
    nl: 'Bij FlixBus mogen kinderen onder de 16 niet alleen reizen.',
  },
  helpChildrenBlablacar: {
    id: `${supportV2Scope}.helpChildrenBlablacar`,
    defaultMessage:
      'Chez BlaBlaCar Bus, un enfant de moins de 3 ans doit voyager dans un siège enfant adapté.',
    en: 'With BlaBlaCar Bus, a child under 3 must travel in a suitable child seat.',
    it: 'Con BlaBlaCar Bus, un bambino sotto i 3 anni deve viaggiare in un seggiolino adatto.',
    es: 'Con BlaBlaCar Bus, un niño menor de 3 años debe viajar en una silla infantil adecuada.',
    de: 'Bei BlaBlaCar Bus muss ein Kind unter 3 Jahren in einem geeigneten Kindersitz reisen.',
    nl: 'Bij BlaBlaCar Bus moet een kind onder de 3 in een geschikt kinderzitje reizen.',
  },
  helpOtherSeller: {
    id: `${supportV2Scope}.helpOtherSeller`,
    defaultMessage:
      "Le vendeur de votre billet figure sur votre confirmation d'achat ou votre reçu. Si vous l'avez acheté sur un autre site ou une autre application, c'est son service client qui pourra vous aider. Un billet au nom du transporteur peut aussi avoir été vendu par Tictactrip : dans le doute, continuez ici.",
    en: "The seller of your ticket is shown on your purchase confirmation or receipt. If you bought it on another website or app, their customer service can help you. A ticket in the carrier's name may also have been sold by Tictactrip: if in doubt, continue here.",
    it: "Il venditore del tuo biglietto è indicato nella conferma d'acquisto o nella ricevuta. Se l'hai acquistato su un altro sito o un'altra app, potrà aiutarti il suo servizio clienti. Un biglietto a nome del vettore può anche essere stato venduto da Tictactrip: nel dubbio, continua qui.",
    es: 'El vendedor de tu billete figura en tu confirmación de compra o en tu recibo. Si lo compraste en otra web u otra aplicación, podrá ayudarte su servicio de atención al cliente. Un billete a nombre del transportista también puede haberlo vendido Tictactrip: en caso de duda, continúa aquí.',
    de: 'Der Verkäufer Ihres Tickets steht auf Ihrer Kaufbestätigung oder Quittung. Wenn Sie es auf einer anderen Website oder in einer anderen App gekauft haben, hilft Ihnen deren Kundenservice. Ein Ticket im Namen des Verkehrsunternehmens kann auch von Tictactrip verkauft worden sein: Fahren Sie im Zweifel hier fort.',
    nl: 'De verkoper van uw ticket staat op uw aankoopbevestiging of bon. Hebt u het op een andere website of in een andere app gekocht, dan kan hun klantenservice u helpen. Een ticket op naam van de vervoerder kan ook door Tictactrip zijn verkocht: ga bij twijfel hier verder.',
  },
  helpLogin: {
    id: `${supportV2Scope}.helpLogin`,
    defaultMessage:
      "Vérifiez vos courriers indésirables et l'adresse utilisée lors de l'achat, puis demandez un nouveau lien. Vous pouvez aussi vous connecter avec votre numéro de commande et l'adresse email de la commande. Si vous avez déjà essayé, continuez : nous vous aiderons.",
    en: "Check your spam folder and the address used for the purchase, then ask for a new link. You can also log in with your order number and the order's email address. If you've already tried, carry on: we'll help you.",
    it: "Controlla la posta indesiderata e l'indirizzo usato per l'acquisto, poi richiedi un nuovo link. Puoi anche accedere con il numero d'ordine e l'indirizzo email dell'ordine. Se hai già provato, continua: ti aiuteremo.",
    es: 'Revisa el correo no deseado y la dirección usada en la compra, y pide un nuevo enlace. También puedes conectarte con tu número de pedido y la dirección de correo del pedido. Si ya lo has intentado, continúa: te ayudaremos.',
    de: 'Prüfen Sie Ihren Spam-Ordner und die beim Kauf verwendete Adresse und fordern Sie dann einen neuen Link an. Sie können sich auch mit Ihrer Bestellnummer und der E-Mail-Adresse der Bestellung anmelden. Wenn Sie es schon versucht haben, fahren Sie fort: Wir helfen Ihnen.',
    nl: 'Kijk in uw spammap en controleer het adres dat u bij de aankoop gebruikte, en vraag dan een nieuwe link aan. U kunt ook inloggen met uw bestelnummer en het e-mailadres van de bestelling. Hebt u het al geprobeerd, ga dan verder: we helpen u.',
  },
  helpFollowup: {
    id: `${supportV2Scope}.helpFollowup`,
    defaultMessage:
      "Si vous avez reçu un email de notre support, répondez-y directement : votre demande sera complétée sans que vous ayez à tout réexpliquer. Vous ne le retrouvez pas ? Continuez ici, en indiquant sa référence si vous l'avez.",
    en: "If you received an email from our support team, reply to it directly: your request will be updated without you having to explain everything again. Can't find it? Carry on here, giving its reference if you have it.",
    it: "Se hai ricevuto un'email dal nostro servizio clienti, rispondi direttamente: la tua richiesta verrà completata senza dover rispiegare tutto. Non la ritrovi? Continua qui, indicando il riferimento se ce l'hai.",
    es: 'Si recibiste un correo de nuestro servicio de atención, respóndelo directamente: tu solicitud se completará sin que tengas que volver a explicarlo todo. ¿No lo encuentras? Continúa aquí, indicando su referencia si la tienes.',
    de: 'Wenn Sie eine E-Mail von unserem Support erhalten haben, antworten Sie direkt darauf: Ihre Anfrage wird ergänzt, ohne dass Sie alles erneut erklären müssen. Sie finden sie nicht? Fahren Sie hier fort und nennen Sie ihre Referenz, falls vorhanden.',
    nl: 'Hebt u een e-mail van onze support ontvangen, antwoord er dan direct op: uw verzoek wordt aangevuld zonder dat u alles opnieuw hoeft uit te leggen. Kunt u die niet vinden? Ga hier verder en vermeld de referentie als u die hebt.',
  },
  helpNoResults: {
    id: `${supportV2Scope}.helpNoResults`,
    defaultMessage:
      "Essayez une autre date, un autre horaire ou une gare proche. Un trajet absent peut être complet, pas encore ouvert à la vente ou non proposé sur notre site : ce n'est pas toujours visible.",
    en: "Try another date, time or a nearby station. A missing trip may be full, not yet on sale, or not offered on our site: that isn't always visible.",
    it: "Prova un'altra data, un altro orario o una stazione vicina. Un viaggio assente può essere al completo, non ancora in vendita o non proposto sul nostro sito: non è sempre visibile.",
    es: 'Prueba otra fecha, otra hora o una estación cercana. Un trayecto que no aparece puede estar completo, aún no estar a la venta o no ofrecerse en nuestra web: no siempre se ve.',
    de: 'Versuchen Sie ein anderes Datum, eine andere Uhrzeit oder einen Bahnhof in der Nähe. Eine fehlende Verbindung kann ausgebucht, noch nicht im Verkauf oder bei uns nicht im Angebot sein: Das ist nicht immer erkennbar.',
    nl: 'Probeer een andere datum, tijd of een station in de buurt. Een ontbrekende rit kan vol zijn, nog niet te koop of niet op onze site aangeboden: dat is niet altijd zichtbaar.',
  },
  helpPriceChanged: {
    id: `${supportV2Scope}.helpPriceChanged`,
    defaultMessage:
      'Certains prix, notamment SNCF, sont estimés pendant la recherche puis confirmés à la réservation : ils peuvent alors changer. Vérifiez le montant total avant de payer. Si vous avez payé un autre montant que celui validé, dites-le-nous.',
    en: 'Some prices, SNCF ones in particular, are estimated during the search and confirmed at booking: they can change then. Check the total before paying. If you paid a different amount from the one you approved, let us know.',
    it: "Alcuni prezzi, in particolare SNCF, vengono stimati durante la ricerca e confermati alla prenotazione: possono quindi cambiare. Verifica l'importo totale prima di pagare. Se hai pagato un importo diverso da quello convalidato, faccelo sapere.",
    es: 'Algunos precios, sobre todo de SNCF, se estiman durante la búsqueda y se confirman al reservar: pueden cambiar en ese momento. Comprueba el importe total antes de pagar. Si pagaste un importe distinto del que validaste, avísanos.',
    de: 'Manche Preise, vor allem von SNCF, werden bei der Suche geschätzt und bei der Buchung bestätigt: Sie können sich dann ändern. Prüfen Sie den Gesamtbetrag vor der Zahlung. Wenn Sie einen anderen Betrag als den bestätigten bezahlt haben, sagen Sie uns Bescheid.',
    nl: 'Sommige prijzen, vooral van SNCF, worden tijdens het zoeken geschat en bij het boeken bevestigd: ze kunnen dan veranderen. Controleer het totaalbedrag voordat u betaalt. Hebt u een ander bedrag betaald dan u goedkeurde, laat het ons dan weten.',
  },
  helpCards: {
    id: `${supportV2Scope}.helpCards`,
    defaultMessage:
      "Les conditions d'âge, de validité et d'utilisation dépendent de chaque carte. Pour les cartes SNCF, notre article détaille les cartes acceptées et comment les utiliser.",
    en: 'Age, validity and usage conditions depend on each card. For SNCF cards, our article details the accepted cards and how to use them.',
    it: 'Le condizioni di età, validità e utilizzo dipendono da ogni carta. Per le carte SNCF, il nostro articolo dettaglia le carte accettate e come usarle.',
    es: 'Las condiciones de edad, validez y uso dependen de cada tarjeta. Para las tarjetas SNCF, nuestro artículo detalla las tarjetas aceptadas y cómo usarlas.',
    de: 'Alters-, Gültigkeits- und Nutzungsbedingungen hängen von jeder Karte ab. Zu den SNCF-Karten erläutert unser Artikel, welche Karten akzeptiert werden und wie man sie nutzt.',
    nl: 'Leeftijds-, geldigheids- en gebruiksvoorwaarden verschillen per kaart. Voor SNCF-kaarten beschrijft ons artikel welke kaarten worden geaccepteerd en hoe u ze gebruikt.',
  },
  helpCardIssue: {
    id: `${supportV2Scope}.helpCardIssue`,
    defaultMessage:
      "Vérifiez l'adresse email utilisée lors de l'achat et vos courriers indésirables. Si votre carte reste introuvable, dites-le-nous avec la date d'achat et la référence figurant sur votre reçu.",
    en: "Check the email address used for the purchase and your spam folder. If your card still can't be found, let us know the purchase date and the reference on your receipt.",
    it: "Controlla l'indirizzo email usato per l'acquisto e la posta indesiderata. Se la carta resta introvabile, faccelo sapere indicando la data d'acquisto e il riferimento della ricevuta.",
    es: 'Comprueba la dirección de correo usada en la compra y la carpeta de correo no deseado. Si tu tarjeta sigue sin aparecer, avísanos con la fecha de compra y la referencia de tu recibo.',
    de: 'Prüfen Sie die beim Kauf verwendete E-Mail-Adresse und Ihren Spam-Ordner. Wenn Ihre Karte unauffindbar bleibt, nennen Sie uns das Kaufdatum und die Referenz auf Ihrer Quittung.',
    nl: 'Controleer het e-mailadres dat u bij de aankoop gebruikte en uw spammap. Blijft uw kaart onvindbaar, laat ons dan de aankoopdatum en de referentie op uw bon weten.',
  },
  helpVoucherUnusable: {
    id: `${supportV2Scope}.helpVoucherUnusable`,
    defaultMessage:
      "Qui a émis votre bon ? Un bon d'achat d'un transporteur (FlixBus, BlaBlaCar Bus, OUIGO…) s'utilise sur son propre site. Pour un bon offert par Tictactrip, réservez votre voyage, puis écrivez-nous avec le numéro de la nouvelle commande : nous vous remboursons le montant du bon.",
    en: "Who issued your voucher? A carrier's voucher (FlixBus, BlaBlaCar Bus, OUIGO…) is used on its own website. For a voucher from Tictactrip, book your trip, then write to us with the new order number: we'll refund you the voucher amount.",
    it: "Chi ha emesso il tuo buono? Un buono di un vettore (FlixBus, BlaBlaCar Bus, OUIGO…) si usa sul suo sito. Per un buono offerto da Tictactrip, prenota il viaggio, poi scrivici con il numero del nuovo ordine: ti rimborsiamo l'importo del buono.",
    es: '¿Quién emitió tu bono? Un bono de un transportista (FlixBus, BlaBlaCar Bus, OUIGO…) se usa en su propia web. Para un bono de Tictactrip, reserva tu viaje y escríbenos con el número del nuevo pedido: te reembolsamos el importe del bono.',
    de: 'Wer hat Ihren Gutschein ausgestellt? Ein Gutschein eines Verkehrsunternehmens (FlixBus, BlaBlaCar Bus, OUIGO…) wird auf dessen eigener Website eingelöst. Bei einem Gutschein von Tictactrip buchen Sie Ihre Reise und schreiben uns dann mit der neuen Bestellnummer: Wir erstatten Ihnen den Gutscheinbetrag.',
    nl: 'Wie heeft uw tegoedbon uitgegeven? Een tegoedbon van een vervoerder (FlixBus, BlaBlaCar Bus, OUIGO…) gebruikt u op diens eigen website. Voor een tegoedbon van Tictactrip boekt u uw reis en schrijft u ons daarna met het nieuwe bestelnummer: we betalen u het bedrag van de bon terug.',
  },
  noteNotDoneYet: {
    id: `${supportV2Scope}.noteNotDoneYet`,
    defaultMessage:
      "Envoyer cette demande n'annule et ne modifie pas encore votre billet : nous vous répondrons par email.",
    en: "Sending this request doesn't cancel or change your ticket yet: we'll reply by email.",
    it: 'Inviare questa richiesta non annulla né modifica ancora il biglietto: ti risponderemo via email.',
    es: 'Enviar esta solicitud todavía no cancela ni modifica tu billete: te responderemos por correo.',
    de: 'Das Absenden dieser Anfrage storniert oder ändert Ihr Ticket noch nicht: Wir antworten Ihnen per E-Mail.',
    nl: 'Het versturen van dit verzoek annuleert of wijzigt uw ticket nog niet: we antwoorden u per e-mail.',
  },
  noteExceptional: {
    id: `${supportV2Scope}.noteExceptional`,
    defaultMessage:
      "Expliquez votre situation : elle sera examinée, mais un geste exceptionnel n'est pas garanti. Aucun justificatif médical n'est nécessaire à cette étape.",
    en: "Explain your situation: it will be reviewed, but an exceptional gesture isn't guaranteed. No medical documents are needed at this stage.",
    it: 'Spiega la tua situazione: verrà esaminata, ma un gesto eccezionale non è garantito. In questa fase non serve alcun documento medico.',
    es: 'Explica tu situación: se estudiará, pero no se garantiza un gesto excepcional. En esta fase no hace falta ningún justificante médico.',
    de: 'Schildern Sie Ihre Situation: Sie wird geprüft, eine Kulanzlösung ist aber nicht garantiert. In diesem Schritt sind keine ärztlichen Nachweise nötig.',
    nl: 'Leg uw situatie uit: die wordt bekeken, maar een uitzonderlijk gebaar is niet gegarandeerd. In deze stap zijn geen medische documenten nodig.',
  },
  noteCosts: {
    id: `${supportV2Scope}.noteCosts`,
    defaultMessage:
      "Ces frais sont examinés séparément du remboursement du billet, et leur prise en charge n'est pas automatique. Joignez les justificatifs dont vous disposez.",
    en: "These costs are reviewed separately from the ticket refund, and they aren't automatically covered. Attach any receipts you have.",
    it: 'Queste spese vengono esaminate separatamente dal rimborso del biglietto e il loro rimborso non è automatico. Allega i giustificativi che hai.',
    es: 'Estos gastos se estudian aparte del reembolso del billete, y su cobertura no es automática. Adjunta los justificantes que tengas.',
    de: 'Diese Kosten werden getrennt von der Ticketerstattung geprüft und nicht automatisch übernommen. Fügen Sie vorhandene Belege bei.',
    nl: 'Deze kosten worden los van de terugbetaling van het ticket bekeken en worden niet automatisch vergoed. Voeg de bewijsstukken toe die u hebt.',
  },
  noteCarrierCancellation: {
    id: `${supportV2Scope}.noteCarrierCancellation`,
    defaultMessage:
      "Gardez le message de suppression envoyé par le transporteur, et joignez-le si vous l'avez.",
    en: 'Keep the cancellation notice sent by the carrier, and attach it if you have it.',
    it: "Conserva il messaggio di soppressione inviato dal vettore e allegalo se ce l'hai.",
    es: 'Guarda el aviso de cancelación enviado por el transportista y adjúntalo si lo tienes.',
    de: 'Bewahren Sie die Ausfallmitteilung des Verkehrsunternehmens auf und fügen Sie sie bei, wenn Sie sie haben.',
    nl: 'Bewaar het schrappingsbericht van de vervoerder en voeg het toe als u het hebt.',
  },
  noteBoardingRefused: {
    id: `${supportV2Scope}.noteBoardingRefused`,
    defaultMessage:
      'Indiquez la raison donnée lors du refus. Si vous avez dû racheter un billet, joignez le justificatif.',
    en: 'Tell us the reason given for the refusal. If you had to buy another ticket, attach the receipt.',
    it: 'Indica il motivo dato al momento del rifiuto. Se hai dovuto riacquistare un biglietto, allega il giustificativo.',
    es: 'Indica el motivo que te dieron al rechazarte. Si tuviste que comprar otro billete, adjunta el justificante.',
    de: 'Nennen Sie den angegebenen Grund für die Ablehnung. Wenn Sie ein neues Ticket kaufen mussten, fügen Sie den Beleg bei.',
    nl: 'Vermeld de reden die bij de weigering werd gegeven. Moest u een nieuw ticket kopen, voeg dan het bewijs toe.',
  },
  noteServiceMissing: {
    id: `${supportV2Scope}.noteServiceMissing`,
    defaultMessage:
      'Indiquez ce qui était prévu dans votre réservation et ce qui vous a été fourni.',
    en: 'Tell us what your booking included and what you actually got.',
    it: 'Indica cosa prevedeva la tua prenotazione e cosa ti è stato fornito.',
    es: 'Indica lo que incluía tu reserva y lo que te ofrecieron.',
    de: 'Nennen Sie, was Ihre Buchung vorsah und was Sie tatsächlich erhalten haben.',
    nl: 'Vermeld wat uw boeking inhield en wat u werkelijk kreeg.',
  },
  noteInconsistent: {
    id: `${supportV2Scope}.noteInconsistent`,
    defaultMessage:
      "Indiquez l'horaire ou la gare attendus, et ceux affichés sur votre billet : notre équipe vérifiera l'itinéraire.",
    en: 'Tell us the expected time or station, and those shown on your ticket: our team will check the itinerary.',
    it: "Indica l'orario o la stazione previsti e quelli riportati sul biglietto: il nostro team verificherà l'itinerario.",
    es: 'Indica la hora o la estación esperadas y las que figuran en tu billete: nuestro equipo comprobará el itinerario.',
    de: 'Nennen Sie die erwartete Uhrzeit oder den erwarteten Bahnhof und die Angaben auf Ihrem Ticket: Unser Team prüft die Verbindung.',
    nl: 'Vermeld de verwachte tijd of het verwachte station, en wat op uw ticket staat: ons team controleert de reisroute.',
  },
  noteChargedNoBooking: {
    id: `${supportV2Scope}.noteChargedNoBooking`,
    defaultMessage:
      "Indiquez la date et le montant du débit, et l'adresse email utilisée pour l'achat : nous vérifierons le paiement et la réservation.",
    en: "Tell us the date and amount of the charge, and the email address used for the purchase: we'll check the payment and the booking.",
    it: "Indica la data e l'importo dell'addebito e l'indirizzo email usato per l'acquisto: verificheremo il pagamento e la prenotazione.",
    es: 'Indica la fecha y el importe del cargo, y la dirección de correo usada en la compra: comprobaremos el pago y la reserva.',
    de: 'Nennen Sie Datum und Betrag der Abbuchung sowie die beim Kauf verwendete E-Mail-Adresse: Wir prüfen Zahlung und Buchung.',
    nl: 'Vermeld de datum en het bedrag van de afschrijving en het e-mailadres dat u bij de aankoop gebruikte: we controleren de betaling en de boeking.',
  },
  noteInvoice: {
    id: `${supportV2Scope}.noteInvoice`,
    defaultMessage:
      "Pour une facture d'entreprise, indiquez la raison sociale, le numéro SIRET, le numéro de TVA et l'adresse. La facture indique des montants nets : la TVA sur le transport de personnes n'est pas récupérable. Comptez quelques semaines pour son édition.",
    en: "For a company invoice, give the company name, SIRET number, VAT number and address. The invoice shows net amounts: VAT on passenger transport can't be reclaimed. Allow a few weeks for it to be issued.",
    it: "Per una fattura aziendale, indica la ragione sociale, il numero SIRET, la partita IVA e l'indirizzo. La fattura riporta importi netti: l'IVA sul trasporto di persone non è recuperabile. Calcola qualche settimana per l'emissione.",
    es: 'Para una factura de empresa, indica la razón social, el número SIRET, el número de IVA y la dirección. La factura muestra importes netos: el IVA del transporte de personas no es recuperable. Cuenta unas semanas para su emisión.',
    de: 'Für eine Firmenrechnung nennen Sie Firmenname, SIRET-Nummer, USt-IdNr. und Adresse. Die Rechnung weist Nettobeträge aus: Die Mehrwertsteuer auf Personenbeförderung ist nicht erstattungsfähig. Rechnen Sie mit einigen Wochen bis zur Ausstellung.',
    nl: 'Voor een bedrijfsfactuur vermeldt u de bedrijfsnaam, het SIRET-nummer, het btw-nummer en het adres. De factuur toont nettobedragen: btw op personenvervoer is niet terugvorderbaar. Reken op enkele weken voor de opmaak.',
  },
  notePersonalData: {
    id: `${supportV2Scope}.notePersonalData`,
    defaultMessage:
      "Précisez les informations concernées et ce que vous souhaitez modifier ou supprimer. N'utilisez pas les liens de connexion reçus pour le compte d'une autre personne.",
    en: "Say which information is concerned and what you want to change or delete. Don't use login links received for someone else's account.",
    it: "Indica le informazioni interessate e cosa desideri modificare o cancellare. Non usare i link di accesso ricevuti per l'account di un'altra persona.",
    es: 'Indica qué información te afecta y qué quieres modificar o eliminar. No uses los enlaces de acceso recibidos para la cuenta de otra persona.',
    de: 'Nennen Sie die betroffenen Angaben und was Sie ändern oder löschen möchten. Nutzen Sie keine Anmeldelinks, die Sie für das Konto einer anderen Person erhalten haben.',
    nl: 'Geef aan om welke gegevens het gaat en wat u wilt wijzigen of verwijderen. Gebruik geen inloglinks die u voor het account van iemand anders ontving.',
  },
  questionAccount: {
    id: `${supportV2Scope}.questionAccount`,
    defaultMessage: 'Votre demande concerne…',
    en: 'Your request is about…',
    it: 'La tua richiesta riguarda…',
    es: 'Tu solicitud se refiere a…',
    de: 'Ihre Anfrage betrifft…',
    nl: 'Uw verzoek gaat over…',
  },
  questionAssistance: {
    id: `${supportV2Scope}.questionAssistance`,
    defaultMessage: 'Plus précisément ?',
    en: 'More precisely?',
    it: 'Più precisamente?',
    es: '¿Más concretamente?',
    de: 'Genauer gesagt?',
    nl: 'Om precies te zijn?',
  },
  questionCancel: {
    id: `${supportV2Scope}.questionCancel`,
    defaultMessage: 'Où en est votre annulation ?',
    en: 'Where does your cancellation stand?',
    it: 'A che punto è il tuo annullamento?',
    es: '¿En qué punto está tu cancelación?',
    de: 'Wie ist der Stand Ihrer Stornierung?',
    nl: 'Hoe staat het met uw annulering?',
  },
  questionCancelled: {
    id: `${supportV2Scope}.questionCancelled`,
    defaultMessage:
      'Votre commande a été annulée, en tout ou partie. Votre demande concerne…',
    en: 'Your order was cancelled, in full or in part. Your request is about…',
    it: 'Il tuo ordine è stato annullato, in tutto o in parte. La tua richiesta riguarda…',
    es: 'Tu pedido se ha cancelado, total o parcialmente. Tu solicitud se refiere a…',
    de: 'Ihre Bestellung wurde ganz oder teilweise storniert. Ihre Anfrage betrifft…',
    nl: 'Uw bestelling is geheel of gedeeltelijk geannuleerd. Uw verzoek gaat over…',
  },
  questionCannotBook: {
    id: `${supportV2Scope}.questionCannotBook`,
    defaultMessage: 'À quel moment cela bloque-t-il ?',
    en: 'Where does it fail?',
    it: 'In quale momento si blocca?',
    es: '¿En qué momento falla?',
    de: 'Woran scheitert es?',
    nl: 'Waar loopt het mis?',
  },
  questionCannotFindTrip: {
    id: `${supportV2Scope}.questionCannotFindTrip`,
    defaultMessage: 'Plus précisément ?',
    en: 'More precisely?',
    it: 'Più precisamente?',
    es: '¿Más concretamente?',
    de: 'Genauer gesagt?',
    nl: 'Om precies te zijn?',
  },
  questionCards: {
    id: `${supportV2Scope}.questionCards`,
    defaultMessage: 'Que se passe-t-il avec votre carte ou votre bon ?',
    en: 'What is happening with your card or voucher?',
    it: 'Cosa succede con la tua carta o il tuo buono?',
    es: '¿Qué pasa con tu tarjeta o tu bono?',
    de: 'Was ist mit Ihrer Karte oder Ihrem Gutschein?',
    nl: 'Wat is er met uw kaart of tegoedbon?',
  },
  questionChange: {
    id: `${supportV2Scope}.questionChange`,
    defaultMessage: 'Que souhaitez-vous modifier ?',
    en: 'What would you like to change?',
    it: 'Cosa desideri modificare?',
    es: '¿Qué quieres modificar?',
    de: 'Was möchten Sie ändern?',
    nl: 'Wat wilt u wijzigen?',
  },
  questionChangeTrip: {
    id: `${supportV2Scope}.questionChangeTrip`,
    defaultMessage: 'Que voulez-vous changer dans votre trajet ?',
    en: 'What do you want to change in your trip?',
    it: 'Cosa vuoi cambiare nel tuo viaggio?',
    es: '¿Qué quieres cambiar de tu trayecto?',
    de: 'Was möchten Sie an Ihrer Fahrt ändern?',
    nl: 'Wat wilt u aan uw rit veranderen?',
  },
  questionCompensation: {
    id: `${supportV2Scope}.questionCompensation`,
    defaultMessage: 'Quelle est votre demande ?',
    en: 'What is your request?',
    it: 'Qual è la tua richiesta?',
    es: '¿Cuál es tu solicitud?',
    de: 'Was ist Ihr Anliegen?',
    nl: 'Wat is uw verzoek?',
  },
  questionDisruption: {
    id: `${supportV2Scope}.questionDisruption`,
    defaultMessage: "Qu'est-il arrivé à votre trajet ?",
    en: 'What happened to your trip?',
    it: 'Cosa è successo al tuo viaggio?',
    es: '¿Qué le pasó a tu trayecto?',
    de: 'Was ist mit Ihrer Fahrt passiert?',
    nl: 'Wat is er met uw rit gebeurd?',
  },
  questionDuringTrip: {
    id: `${supportV2Scope}.questionDuringTrip`,
    defaultMessage: "Que s'est-il passé pendant le voyage ?",
    en: 'What happened during the trip?',
    it: 'Cosa è successo durante il viaggio?',
    es: '¿Qué pasó durante el viaje?',
    de: 'Was ist während der Reise passiert?',
    nl: 'Wat is er tijdens de reis gebeurd?',
  },
  questionFailed: {
    id: `${supportV2Scope}.questionFailed`,
    defaultMessage:
      "Votre commande n'a pas pu être finalisée. Votre demande concerne…",
    en: 'Your order could not be completed. Your request is about…',
    it: 'Non è stato possibile completare il tuo ordine. La tua richiesta riguarda…',
    es: 'No se ha podido completar tu pedido. Tu solicitud se refiere a…',
    de: 'Ihre Bestellung konnte nicht abgeschlossen werden. Ihre Anfrage betrifft…',
    nl: 'Uw bestelling kon niet worden afgerond. Uw verzoek gaat over…',
  },
  questionImminent: {
    id: `${supportV2Scope}.questionImminent`,
    defaultMessage: 'Que se passe-t-il ?',
    en: 'What is happening?',
    it: 'Cosa succede?',
    es: '¿Qué ocurre?',
    de: 'Was ist los?',
    nl: 'Wat is er aan de hand?',
  },
  questionMismatch: {
    id: `${supportV2Scope}.questionMismatch`,
    defaultMessage: "Qu'est-ce qui ne correspond pas ?",
    en: "What doesn't match?",
    it: 'Cosa non corrisponde?',
    es: '¿Qué no coincide?',
    de: 'Was stimmt nicht überein?',
    nl: 'Wat komt niet overeen?',
  },
  questionMissed: {
    id: `${supportV2Scope}.questionMissed`,
    defaultMessage: "Qu'avez-vous manqué ?",
    en: 'What did you miss?',
    it: 'Cosa hai perso?',
    es: '¿Qué perdiste?',
    de: 'Was haben Sie verpasst?',
    nl: 'Wat heeft u gemist?',
  },
  questionMoney: {
    id: `${supportV2Scope}.questionMoney`,
    defaultMessage: 'Votre question porte sur…',
    en: 'Your question is about…',
    it: 'La tua domanda riguarda…',
    es: 'Tu pregunta se refiere a…',
    de: 'Ihre Frage betrifft…',
    nl: 'Uw vraag gaat over…',
  },
  questionNoOrder: {
    id: `${supportV2Scope}.questionNoOrder`,
    defaultMessage: 'Votre demande concerne…',
    en: 'Your request is about…',
    it: 'La tua richiesta riguarda…',
    es: 'Tu solicitud se refiere a…',
    de: 'Ihre Anfrage betrifft…',
    nl: 'Uw verzoek gaat over…',
  },
  questionNotReceived: {
    id: `${supportV2Scope}.questionNotReceived`,
    defaultMessage: "Qu'avez-vous reçu par email après votre achat ?",
    en: 'What did you receive by email after your purchase?',
    it: "Cosa hai ricevuto via email dopo l'acquisto?",
    es: '¿Qué recibiste por correo tras tu compra?',
    de: 'Was haben Sie nach dem Kauf per E-Mail erhalten?',
    nl: 'Wat heeft u na uw aankoop per e-mail ontvangen?',
  },
  questionNothingReceived: {
    id: `${supportV2Scope}.questionNothingReceived`,
    defaultMessage: "Que pensez-vous qu'il s'est passé ?",
    en: 'What do you think happened?',
    it: 'Cosa pensi sia successo?',
    es: '¿Qué crees que ha pasado?',
    de: 'Was ist Ihrer Meinung nach passiert?',
    nl: 'Wat is er volgens u gebeurd?',
  },
  questionOnboard: {
    id: `${supportV2Scope}.questionOnboard`,
    defaultMessage: "Que s'est-il passé ?",
    en: 'What happened?',
    it: 'Cosa è successo?',
    es: '¿Qué pasó?',
    de: 'Was ist passiert?',
    nl: 'Wat is er gebeurd?',
  },
  questionPast: {
    id: `${supportV2Scope}.questionPast`,
    defaultMessage: 'Votre voyage est terminé. Votre demande concerne…',
    en: 'Your trip is over. Your request is about…',
    it: 'Il tuo viaggio è terminato. La tua richiesta riguarda…',
    es: 'Tu viaje ha terminado. Tu solicitud se refiere a…',
    de: 'Ihre Reise ist beendet. Ihre Anfrage betrifft…',
    nl: 'Uw reis is voorbij. Uw verzoek gaat over…',
  },
  questionPaymentIssue: {
    id: `${supportV2Scope}.questionPaymentIssue`,
    defaultMessage: "Que s'est-il passé avec le paiement ?",
    en: 'What happened with the payment?',
    it: 'Cosa è successo con il pagamento?',
    es: '¿Qué pasó con el pago?',
    de: 'Was ist mit der Zahlung passiert?',
    nl: 'Wat is er met de betaling gebeurd?',
  },
  questionPrepare: {
    id: `${supportV2Scope}.questionPrepare`,
    defaultMessage: 'Sur quoi porte votre question ?',
    en: 'What is your question about?',
    it: 'Su cosa verte la tua domanda?',
    es: '¿Sobre qué es tu pregunta?',
    de: 'Worum geht es bei Ihrer Frage?',
    nl: 'Waar gaat uw vraag over?',
  },
  questionPurchase: {
    id: `${supportV2Scope}.questionPurchase`,
    defaultMessage: 'Que se passe-t-il ?',
    en: 'What is happening?',
    it: 'Cosa succede?',
    es: '¿Qué ocurre?',
    de: 'Was ist los?',
    nl: 'Wat is er aan de hand?',
  },
  questionRefund: {
    id: `${supportV2Scope}.questionRefund`,
    defaultMessage: 'Quelle est votre question sur le remboursement ?',
    en: 'What is your question about the refund?',
    it: 'Qual è la tua domanda sul rimborso?',
    es: '¿Cuál es tu pregunta sobre el reembolso?',
    de: 'Welche Frage haben Sie zur Erstattung?',
    nl: 'Wat is uw vraag over de terugbetaling?',
  },
  questionRefundCompensationInvoice: {
    id: `${supportV2Scope}.questionRefundCompensationInvoice`,
    defaultMessage: 'Votre question porte sur…',
    en: 'Your question is about…',
    it: 'La tua domanda riguarda…',
    es: 'Tu pregunta se refiere a…',
    de: 'Ihre Frage betrifft…',
    nl: 'Uw vraag gaat over…',
  },
  questionSeatsAndOptions: {
    id: `${supportV2Scope}.questionSeatsAndOptions`,
    defaultMessage: 'Plus précisément ?',
    en: 'More precisely?',
    it: 'Più precisamente?',
    es: '¿Más concretamente?',
    de: 'Genauer gesagt?',
    nl: 'Om precies te zijn?',
  },
  questionStations: {
    id: `${supportV2Scope}.questionStations`,
    defaultMessage: 'Plus précisément ?',
    en: 'More precisely?',
    it: 'Più precisamente?',
    es: '¿Más concretamente?',
    de: 'Genauer gesagt?',
    nl: 'Om precies te zijn?',
  },
  questionTicketProblem: {
    id: `${supportV2Scope}.questionTicketProblem`,
    defaultMessage: 'Quel est le problème avec vos billets ?',
    en: 'What is the problem with your tickets?',
    it: 'Qual è il problema con i tuoi biglietti?',
    es: '¿Qué problema tienes con tus billetes?',
    de: 'Welches Problem gibt es mit Ihren Tickets?',
    nl: 'Wat is het probleem met uw tickets?',
  },
  questionTickets: {
    id: `${supportV2Scope}.questionTickets`,
    defaultMessage: 'Quel est le problème avec vos billets ?',
    en: 'What is the problem with your tickets?',
    it: 'Qual è il problema con i tuoi biglietti?',
    es: '¿Qué problema tienes con tus billetes?',
    de: 'Welches Problem gibt es mit Ihren Tickets?',
    nl: 'Wat is het probleem met uw tickets?',
  },
  questionTravellers: {
    id: `${supportV2Scope}.questionTravellers`,
    defaultMessage: 'Quelle modification pour les voyageurs ?',
    en: 'What change for the travellers?',
    it: 'Quale modifica per i viaggiatori?',
    es: '¿Qué cambio para los viajeros?',
    de: 'Welche Änderung bei den Reisenden?',
    nl: 'Welke wijziging voor de reizigers?',
  },
  questionTripWithoutNumber: {
    id: `${supportV2Scope}.questionTripWithoutNumber`,
    defaultMessage: 'Que souhaitez-vous faire ?',
    en: 'What would you like to do?',
    it: 'Cosa desideri fare?',
    es: '¿Qué quieres hacer?',
    de: 'Was möchten Sie tun?',
    nl: 'Wat wilt u doen?',
  },
  questionUnpaid: {
    id: `${supportV2Scope}.questionUnpaid`,
    defaultMessage:
      "Le paiement de cette commande n'a pas abouti. Que s'est-il passé ?",
    en: 'The payment for this order did not go through. What happened?',
    it: 'Il pagamento di questo ordine non è andato a buon fine. Cosa è successo?',
    es: 'El pago de este pedido no se completó. ¿Qué ha pasado?',
    de: 'Die Zahlung für diese Bestellung ist nicht durchgegangen. Was ist passiert?',
    nl: 'De betaling voor deze bestelling is niet gelukt. Wat is er gebeurd?',
  },
  questionUpcoming: {
    id: `${supportV2Scope}.questionUpcoming`,
    defaultMessage: 'Que souhaitez-vous faire ?',
    en: 'What would you like to do?',
    it: 'Cosa desideri fare?',
    es: '¿Qué quieres hacer?',
    de: 'Was möchten Sie tun?',
    nl: 'Wat wilt u doen?',
  },
  optionAPayment: {
    id: `${supportV2Scope}.optionAPayment`,
    defaultMessage: 'Un paiement',
    en: 'A payment',
    it: 'Un pagamento',
    es: 'Un pago',
    de: 'Eine Zahlung',
    nl: 'Een betaling',
  },
  optionAPurchase: {
    id: `${supportV2Scope}.optionAPurchase`,
    defaultMessage: "Un achat que je prépare ou n'arrive pas à faire",
    en: "A purchase I'm planning or can't complete",
    it: 'Un acquisto che sto preparando o che non riesco a fare',
    es: 'Una compra que preparo o no consigo hacer',
    de: 'Einen geplanten Kauf oder einen, der nicht klappt',
    nl: 'Een aankoop die ik voorbereid of die niet lukt',
  },
  optionARefund: {
    id: `${supportV2Scope}.optionARefund`,
    defaultMessage: 'Un remboursement',
    en: 'A refund',
    it: 'Un rimborso',
    es: 'Un reembolso',
    de: 'Eine Erstattung',
    nl: 'Een terugbetaling',
  },
  optionAccessibility: {
    id: `${supportV2Scope}.optionAccessibility`,
    defaultMessage: 'Accessibilité et assistance',
    en: 'Accessibility and assistance',
    it: 'Accessibilità e assistenza',
    es: 'Accesibilidad y asistencia',
    de: 'Barrierefreiheit und Hilfe',
    nl: 'Toegankelijkheid en assistentie',
  },
  optionAddRemoveTraveller: {
    id: `${supportV2Scope}.optionAddRemoveTraveller`,
    defaultMessage: 'Ajouter ou retirer un voyageur',
    en: 'Add or remove a traveller',
    it: 'Aggiungere o rimuovere un viaggiatore',
    es: 'Añadir o quitar un viajero',
    de: 'Einen Reisenden hinzufügen oder entfernen',
    nl: 'Een reiziger toevoegen of verwijderen',
  },
  optionAddTrip: {
    id: `${supportV2Scope}.optionAddTrip`,
    defaultMessage: 'Ajouter un trajet (un retour par exemple)',
    en: 'Add a trip (a return, for example)',
    it: 'Aggiungere una tratta (ad esempio un ritorno)',
    es: 'Añadir un trayecto (una vuelta, por ejemplo)',
    de: 'Eine Fahrt hinzufügen (z. B. eine Rückfahrt)',
    nl: 'Een rit toevoegen (bijvoorbeeld een terugreis)',
  },
  optionAdvancedCosts: {
    id: `${supportV2Scope}.optionAdvancedCosts`,
    defaultMessage: 'Me faire rembourser des frais avancés',
    en: 'Get back expenses I paid',
    it: 'Farmi rimborsare spese anticipate',
    es: 'Recuperar gastos que adelanté',
    de: 'Ausgelegte Kosten erstattet bekommen',
    nl: 'Voorgeschoten kosten terugkrijgen',
  },
  optionAssistance: {
    id: `${supportV2Scope}.optionAssistance`,
    defaultMessage: 'Enfants, accessibilité ou assistance',
    en: 'Children, accessibility or assistance',
    it: 'Bambini, accessibilità o assistenza',
    es: 'Niños, accesibilidad o asistencia',
    de: 'Kinder, Barrierefreiheit oder Hilfe',
    nl: 'Kinderen, toegankelijkheid of assistentie',
  },
  optionBigGroup: {
    id: `${supportV2Scope}.optionBigGroup`,
    defaultMessage: 'Voyager à plus de 9 personnes',
    en: 'Travel as a group of more than 9',
    it: 'Viaggiare in più di 9 persone',
    es: 'Viajar más de 9 personas',
    de: 'Mit mehr als 9 Personen reisen',
    nl: 'Met meer dan 9 personen reizen',
  },
  optionBirthdate: {
    id: `${supportV2Scope}.optionBirthdate`,
    defaultMessage: 'Corriger une date de naissance ou un âge',
    en: 'Fix a date of birth or an age',
    it: "Correggere una data di nascita o un'età",
    es: 'Corregir una fecha de nacimiento o una edad',
    de: 'Ein Geburtsdatum oder Alter korrigieren',
    nl: 'Een geboortedatum of leeftijd corrigeren',
  },
  optionBoardingRefused: {
    id: `${supportV2Scope}.optionBoardingRefused`,
    defaultMessage: "On m'a refusé l'accès ou j'ai eu un problème au contrôle",
    en: 'I was refused boarding or had an issue at the ticket check',
    it: "Mi è stato negato l'accesso o ho avuto un problema al controllo",
    es: 'Me negaron el acceso o tuve un problema en el control',
    de: 'Mir wurde der Zutritt verweigert oder es gab ein Problem bei der Kontrolle',
    nl: 'Ik werd geweigerd of had een probleem bij de controle',
  },
  optionBookingFailed: {
    id: `${supportV2Scope}.optionBookingFailed`,
    defaultMessage: 'La réservation échoue avant le paiement',
    en: 'The booking fails before payment',
    it: 'La prenotazione non va a buon fine prima del pagamento',
    es: 'La reserva falla antes del pago',
    de: 'Die Buchung scheitert vor der Zahlung',
    nl: 'De boeking mislukt vóór de betaling',
  },
  optionBookingUnsure: {
    id: `${supportV2Scope}.optionBookingUnsure`,
    defaultMessage: 'Je ne sais pas si ma réservation a abouti',
    en: "I don't know whether my booking went through",
    it: 'Non so se la mia prenotazione è andata a buon fine',
    es: 'No sé si mi reserva se completó',
    de: 'Ich weiß nicht, ob meine Buchung geklappt hat',
    nl: 'Ik weet niet of mijn boeking gelukt is',
  },
  optionBusiness: {
    id: `${supportV2Scope}.optionBusiness`,
    defaultMessage: 'Demande professionnelle ou partenariat',
    en: 'Business request or partnership',
    it: 'Richiesta professionale o partnership',
    es: 'Solicitud profesional o colaboración',
    de: 'Geschäftliche Anfrage oder Partnerschaft',
    nl: 'Zakelijk verzoek of samenwerking',
  },
  optionCancelTrip: {
    id: `${supportV2Scope}.optionCancelTrip`,
    defaultMessage: 'Annuler tout ou partie du voyage',
    en: 'Cancel all or part of the trip',
    it: 'Annullare tutto o parte del viaggio',
    es: 'Cancelar todo o parte del viaje',
    de: 'Die Reise ganz oder teilweise stornieren',
    nl: 'De reis geheel of gedeeltelijk annuleren',
  },
  optionCancelUnconfirmed: {
    id: `${supportV2Scope}.optionCancelUnconfirmed`,
    defaultMessage: "Mon annulation n'apparaît pas confirmée",
    en: "My cancellation doesn't show as confirmed",
    it: 'Il mio annullamento non risulta confermato',
    es: 'Mi cancelación no aparece confirmada',
    de: 'Meine Stornierung wird nicht als bestätigt angezeigt',
    nl: 'Mijn annulering lijkt niet bevestigd',
  },
  optionCancelWithCfar: {
    id: `${supportV2Scope}.optionCancelWithCfar`,
    defaultMessage: 'Annuler avec mon option remboursement',
    en: 'Cancel with my refund option',
    it: 'Annullare con la mia opzione rimborso',
    es: 'Cancelar con mi opción de reembolso',
    de: 'Mit meiner Erstattungsoption stornieren',
    nl: 'Annuleren met mijn terugbetalingsoptie',
  },
  optionCannotBook: {
    id: `${supportV2Scope}.optionCannotBook`,
    defaultMessage: "Je n'arrive pas à réserver ou à payer",
    en: "I can't book or pay",
    it: 'Non riesco a prenotare o pagare',
    es: 'No consigo reservar ni pagar',
    de: 'Ich kann nicht buchen oder bezahlen',
    nl: 'Ik kan niet boeken of betalen',
  },
  optionCannotDownload: {
    id: `${supportV2Scope}.optionCannotDownload`,
    defaultMessage: "Je n'arrive pas à télécharger ou afficher mon billet",
    en: "I can't download or open my ticket",
    it: 'Non riesco a scaricare o aprire il biglietto',
    es: 'No consigo descargar ni abrir mi billete',
    de: 'Ich kann mein Ticket nicht herunterladen oder öffnen',
    nl: 'Ik kan mijn ticket niet downloaden of openen',
  },
  optionCannotFindTrip: {
    id: `${supportV2Scope}.optionCannotFindTrip`,
    defaultMessage: 'Je ne trouve pas mon trajet',
    en: "I can't find my trip",
    it: 'Non trovo il mio viaggio',
    es: 'No encuentro mi trayecto',
    de: 'Ich finde meine Verbindung nicht',
    nl: 'Ik vind mijn rit niet',
  },
  optionCardIssue: {
    id: `${supportV2Scope}.optionCardIssue`,
    defaultMessage: "Ma carte n'est pas arrivée, est erronée ou à annuler",
    en: "My card hasn't arrived, is wrong or needs cancelling",
    it: 'La mia carta non è arrivata, è errata o da annullare',
    es: 'Mi tarjeta no ha llegado, es errónea o quiero cancelarla',
    de: 'Meine Karte ist nicht angekommen, fehlerhaft oder soll storniert werden',
    nl: 'Mijn kaart is niet aangekomen, klopt niet of moet geannuleerd worden',
  },
  optionCardOrVoucher: {
    id: `${supportV2Scope}.optionCardOrVoucher`,
    defaultMessage: 'Une carte de réduction ou un bon',
    en: 'A discount card or a voucher',
    it: 'Una carta sconto o un buono',
    es: 'Una tarjeta de descuento o un bono',
    de: 'Eine Rabattkarte oder einen Gutschein',
    nl: 'Een kortingskaart of een tegoedbon',
  },
  optionCardPurchase: {
    id: `${supportV2Scope}.optionCardPurchase`,
    defaultMessage: 'Acheter ou utiliser une carte de réduction',
    en: 'Buy or use a discount card',
    it: 'Acquistare o usare una carta sconto',
    es: 'Comprar o usar una tarjeta de descuento',
    de: 'Eine Rabattkarte kaufen oder nutzen',
    nl: 'Een kortingskaart kopen of gebruiken',
  },
  optionCarrierCancellation: {
    id: `${supportV2Scope}.optionCarrierCancellation`,
    defaultMessage: 'Une suppression',
    en: 'A cancellation',
    it: 'Una soppressione',
    es: 'Una cancelación',
    de: 'Ein Ausfall',
    nl: 'Een schrapping',
  },
  optionChangeBlocked: {
    id: `${supportV2Scope}.optionChangeBlocked`,
    defaultMessage: "Le site m'empêche de modifier ou d'annuler",
    en: "The website won't let me change or cancel",
    it: 'Il sito non mi permette di modificare o annullare',
    es: 'La web no me deja modificar ni cancelar',
    de: 'Die Website lässt mich nicht ändern oder stornieren',
    nl: 'De website laat me niet wijzigen of annuleren',
  },
  optionChangeDateTime: {
    id: `${supportV2Scope}.optionChangeDateTime`,
    defaultMessage: "La date ou l'heure",
    en: 'The date or time',
    it: "La data o l'orario",
    es: 'La fecha o la hora',
    de: 'Datum oder Uhrzeit',
    nl: 'De datum of tijd',
  },
  optionChangeOrCancel: {
    id: `${supportV2Scope}.optionChangeOrCancel`,
    defaultMessage: 'Modifier ou annuler mon voyage',
    en: 'Change or cancel my trip',
    it: 'Modificare o annullare il viaggio',
    es: 'Modificar o cancelar mi viaje',
    de: 'Meine Reise ändern oder stornieren',
    nl: 'Mijn reis wijzigen of annuleren',
  },
  optionChangeStations: {
    id: `${supportV2Scope}.optionChangeStations`,
    defaultMessage: "La gare de départ ou d'arrivée",
    en: 'The departure or arrival station',
    it: 'La stazione di partenza o di arrivo',
    es: 'La estación de salida o de llegada',
    de: 'Den Abfahrts- oder Ankunftsbahnhof',
    nl: 'Het vertrek- of aankomststation',
  },
  optionChangeTravellers: {
    id: `${supportV2Scope}.optionChangeTravellers`,
    defaultMessage: 'Modifier les voyageurs',
    en: 'Change the travellers',
    it: 'Modificare i viaggiatori',
    es: 'Modificar los viajeros',
    de: 'Die Reisenden ändern',
    nl: 'De reizigers wijzigen',
  },
  optionChangeTrip: {
    id: `${supportV2Scope}.optionChangeTrip`,
    defaultMessage: "Changer la date, l'heure ou le trajet",
    en: 'Change the date, time or route',
    it: 'Cambiare data, orario o tratta',
    es: 'Cambiar la fecha, la hora o el trayecto',
    de: 'Datum, Uhrzeit oder Strecke ändern',
    nl: 'De datum, tijd of route wijzigen',
  },
  optionChargedNoBooking: {
    id: `${supportV2Scope}.optionChargedNoBooking`,
    defaultMessage: "J'ai été débité mais je n'ai aucune confirmation",
    en: 'I was charged but have no confirmation',
    it: "Mi è stato addebitato l'importo ma non ho nessuna conferma",
    es: 'Me han cobrado pero no tengo ninguna confirmación',
    de: 'Mir wurde Geld abgebucht, aber ich habe keine Bestätigung',
    nl: 'Er is geld afgeschreven maar ik heb geen bevestiging',
  },
  optionCheckRemaining: {
    id: `${supportV2Scope}.optionCheckRemaining`,
    defaultMessage: "Vérifier les trajets qu'il me reste",
    en: 'Check the trips I still have',
    it: 'Verificare le tratte che mi restano',
    es: 'Comprobar los trayectos que me quedan',
    de: 'Meine verbleibenden Fahrten prüfen',
    nl: 'De ritten die ik nog heb controleren',
  },
  optionChildren: {
    id: `${supportV2Scope}.optionChildren`,
    defaultMessage: 'Voyager avec des enfants',
    en: 'Travelling with children',
    it: 'Viaggiare con bambini',
    es: 'Viajar con niños',
    de: 'Mit Kindern reisen',
    nl: 'Reizen met kinderen',
  },
  optionClaimCompensation: {
    id: `${supportV2Scope}.optionClaimCompensation`,
    defaultMessage: 'Demander une indemnisation',
    en: 'Claim compensation',
    it: 'Chiedere un indennizzo',
    es: 'Solicitar una indemnización',
    de: 'Eine Entschädigung beantragen',
    nl: 'Een schadevergoeding aanvragen',
  },
  optionClaimFollowup: {
    id: `${supportV2Scope}.optionClaimFollowup`,
    defaultMessage: 'Suivre une réclamation auprès du transporteur',
    en: 'Follow up a claim with the carrier',
    it: 'Seguire un reclamo presso il vettore',
    es: 'Seguir una reclamación ante el transportista',
    de: 'Eine Reklamation beim Verkehrsunternehmen verfolgen',
    nl: 'Een klacht bij de vervoerder opvolgen',
  },
  optionCompensationOrCosts: {
    id: `${supportV2Scope}.optionCompensationOrCosts`,
    defaultMessage: 'Une indemnisation ou des frais engagés',
    en: 'Compensation or expenses I incurred',
    it: 'Un indennizzo o spese sostenute',
    es: 'Una indemnización o gastos realizados',
    de: 'Eine Entschädigung oder angefallene Kosten',
    nl: 'Een schadevergoeding of gemaakte kosten',
  },
  optionConfirmationOnly: {
    id: `${supportV2Scope}.optionConfirmationOnly`,
    defaultMessage: 'Une confirmation, mais pas de billet',
    en: 'A confirmation, but no ticket',
    it: 'Una conferma, ma nessun biglietto',
    es: 'Una confirmación, pero ningún billete',
    de: 'Eine Bestätigung, aber kein Ticket',
    nl: 'Een bevestiging, maar geen ticket',
  },
  optionContentReport: {
    id: `${supportV2Scope}.optionContentReport`,
    defaultMessage: 'Signaler une information erronée sur le site',
    en: 'Report wrong information on the website',
    it: "Segnalare un'informazione errata sul sito",
    es: 'Informar de un dato erróneo en la web',
    de: 'Falsche Informationen auf der Website melden',
    nl: 'Onjuiste informatie op de website melden',
  },
  optionDelay: {
    id: `${supportV2Scope}.optionDelay`,
    defaultMessage: 'Un retard',
    en: 'A delay',
    it: 'Un ritardo',
    es: 'Un retraso',
    de: 'Eine Verspätung',
    nl: 'Een vertraging',
  },
  optionDelayOrCancellation: {
    id: `${supportV2Scope}.optionDelayOrCancellation`,
    defaultMessage: 'Un train ou un bus en retard ou supprimé',
    en: 'A delayed or cancelled train or bus',
    it: 'Un treno o autobus in ritardo o soppresso',
    es: 'Un tren o autobús con retraso o cancelado',
    de: 'Ein verspäteter oder ausgefallener Zug oder Bus',
    nl: 'Een vertraagde of geschrapte trein of bus',
  },
  optionDiscountNotApplied: {
    id: `${supportV2Scope}.optionDiscountNotApplied`,
    defaultMessage: "Ma réduction n'a pas été appliquée",
    en: "My discount wasn't applied",
    it: 'Lo sconto non è stato applicato',
    es: 'No se aplicó mi descuento',
    de: 'Meine Ermäßigung wurde nicht angewendet',
    nl: 'Mijn korting is niet toegepast',
  },
  optionDuringTrip: {
    id: `${supportV2Scope}.optionDuringTrip`,
    defaultMessage: 'Un problème pendant le voyage',
    en: 'A problem during the trip',
    it: 'Un problema durante il viaggio',
    es: 'Un problema durante el viaje',
    de: 'Ein Problem während der Reise',
    nl: 'Een probleem tijdens de reis',
  },
  optionExchangeTicket: {
    id: `${supportV2Scope}.optionExchangeTicket`,
    defaultMessage: 'Échanger contre un autre billet',
    en: 'Exchange it for another ticket',
    it: 'Cambiarlo con un altro biglietto',
    es: 'Cambiarlo por otro billete',
    de: 'Gegen ein anderes Ticket umtauschen',
    nl: 'Omruilen voor een ander ticket',
  },
  optionExtraCosts: {
    id: `${supportV2Scope}.optionExtraCosts`,
    defaultMessage: "J'ai dû payer des frais (hôtel, taxi, nouveau billet)",
    en: 'I had to pay extra costs (hotel, taxi, new ticket)',
    it: 'Ho dovuto pagare delle spese (hotel, taxi, nuovo biglietto)',
    es: 'Tuve que pagar gastos (hotel, taxi, billete nuevo)',
    de: 'Ich musste Kosten tragen (Hotel, Taxi, neues Ticket)',
    nl: 'Ik moest kosten maken (hotel, taxi, nieuw ticket)',
  },
  optionExtraOptions: {
    id: `${supportV2Scope}.optionExtraOptions`,
    defaultMessage: 'Options disponibles pour mon voyage',
    en: 'Options available for my trip',
    it: 'Opzioni disponibili per il viaggio',
    es: 'Opciones disponibles para mi viaje',
    de: 'Verfügbare Optionen für meine Reise',
    nl: 'Beschikbare opties voor mijn reis',
  },
  optionFindStation: {
    id: `${supportV2Scope}.optionFindStation`,
    defaultMessage: "Trouver ma gare, mon arrêt ou l'adresse de départ",
    en: 'Find my station, stop or departure address',
    it: "Trovare la stazione, la fermata o l'indirizzo di partenza",
    es: 'Encontrar mi estación, parada o dirección de salida',
    de: 'Meinen Bahnhof, meine Haltestelle oder die Abfahrtsadresse finden',
    nl: 'Mijn station, halte of vertrekadres vinden',
  },
  optionInvoice: {
    id: `${supportV2Scope}.optionInvoice`,
    defaultMessage: 'Une facture ou un justificatif',
    en: 'An invoice or a receipt',
    it: 'Una fattura o una ricevuta',
    es: 'Una factura o un justificante',
    de: 'Eine Rechnung oder ein Beleg',
    nl: 'Een factuur of bewijs',
  },
  optionLogin: {
    id: `${supportV2Scope}.optionLogin`,
    defaultMessage: "Je n'arrive pas à me connecter",
    en: "I can't log in",
    it: 'Non riesco ad accedere',
    es: 'No consigo iniciar sesión',
    de: 'Ich kann mich nicht anmelden',
    nl: 'Ik kan niet inloggen',
  },
  optionLostItem: {
    id: `${supportV2Scope}.optionLostItem`,
    defaultMessage: 'Un objet perdu',
    en: 'A lost item',
    it: 'Un oggetto smarrito',
    es: 'Un objeto perdido',
    de: 'Ein verlorener Gegenstand',
    nl: 'Een verloren voorwerp',
  },
  optionLuggage: {
    id: `${supportV2Scope}.optionLuggage`,
    defaultMessage: 'Bagages, skis, vélos ou trottinettes',
    en: 'Luggage, skis, bikes or scooters',
    it: 'Bagagli, sci, bici o monopattini',
    es: 'Equipaje, esquís, bicicletas o patinetes',
    de: 'Gepäck, Ski, Fahrräder oder Roller',
    nl: "Bagage, ski's, fietsen of steps",
  },
  optionMissedConnection: {
    id: `${supportV2Scope}.optionMissedConnection`,
    defaultMessage: 'Une correspondance',
    en: 'A connection',
    it: 'Una coincidenza',
    es: 'Una conexión',
    de: 'Einen Anschluss',
    nl: 'Een overstap',
  },
  optionMissedConnectionOrDeparture: {
    id: `${supportV2Scope}.optionMissedConnectionOrDeparture`,
    defaultMessage: 'Un départ ou une correspondance manqués',
    en: 'A missed departure or connection',
    it: 'Una partenza o una coincidenza persa',
    es: 'Una salida o conexión perdida',
    de: 'Eine verpasste Abfahrt oder ein verpasster Anschluss',
    nl: 'Een gemist vertrek of gemiste overstap',
  },
  optionMissedDeparture: {
    id: `${supportV2Scope}.optionMissedDeparture`,
    defaultMessage: 'Mon départ',
    en: 'My departure',
    it: 'La mia partenza',
    es: 'Mi salida',
    de: 'Meine Abfahrt',
    nl: 'Mijn vertrek',
  },
  optionMissingPart: {
    id: `${supportV2Scope}.optionMissingPart`,
    defaultMessage: "Il me manque le billet d'un trajet",
    en: 'A ticket is missing for part of my trip',
    it: 'Manca il biglietto di una tratta',
    es: 'Me falta el billete de un trayecto',
    de: 'Mir fehlt das Ticket für einen Teil der Reise',
    nl: 'Ik mis het ticket voor een deel van de reis',
  },
  optionMoneyOrInvoice: {
    id: `${supportV2Scope}.optionMoneyOrInvoice`,
    defaultMessage: 'Paiement, remboursement ou facture',
    en: 'Payment, refund or invoice',
    it: 'Pagamento, rimborso o fattura',
    es: 'Pago, reembolso o factura',
    de: 'Zahlung, Erstattung oder Rechnung',
    nl: 'Betaling, terugbetaling of factuur',
  },
  optionMultipleCharges: {
    id: `${supportV2Scope}.optionMultipleCharges`,
    defaultMessage: "J'ai été débité plusieurs fois",
    en: 'I was charged several times',
    it: 'Mi è stato addebitato più volte',
    es: 'Me han cobrado varias veces',
    de: 'Mir wurde mehrfach abgebucht',
    nl: 'Er is meerdere keren geld afgeschreven',
  },
  optionMyAccount: {
    id: `${supportV2Scope}.optionMyAccount`,
    defaultMessage: 'Mon compte ou autre chose',
    en: 'My account or something else',
    it: 'Il mio account o altro',
    es: 'Mi cuenta u otra cosa',
    de: 'Mein Konto oder etwas anderes',
    nl: 'Mijn account of iets anders',
  },
  optionMyTickets: {
    id: `${supportV2Scope}.optionMyTickets`,
    defaultMessage: 'Mes billets',
    en: 'My tickets',
    it: 'I miei biglietti',
    es: 'Mis billetes',
    de: 'Meine Tickets',
    nl: 'Mijn tickets',
  },
  optionNameTypo: {
    id: `${supportV2Scope}.optionNameTypo`,
    defaultMessage: 'Corriger une faute dans un nom',
    en: 'Fix a typo in a name',
    it: 'Correggere un errore in un nome',
    es: 'Corregir un error en un nombre',
    de: 'Einen Tippfehler im Namen korrigieren',
    nl: 'Een tikfout in een naam verbeteren',
  },
  optionNoResults: {
    id: `${supportV2Scope}.optionNoResults`,
    defaultMessage: 'Ma recherche ne donne aucun résultat',
    en: 'My search returns no results',
    it: 'La mia ricerca non dà risultati',
    es: 'Mi búsqueda no da resultados',
    de: 'Meine Suche ergibt keine Treffer',
    nl: 'Mijn zoekopdracht geeft geen resultaten',
  },
  optionNothingAtAll: {
    id: `${supportV2Scope}.optionNothingAtAll`,
    defaultMessage: 'Rien du tout',
    en: 'Nothing at all',
    it: 'Niente di niente',
    es: 'Nada de nada',
    de: 'Gar nichts',
    nl: 'Helemaal niets',
  },
  optionOnboardIssue: {
    id: `${supportV2Scope}.optionOnboardIssue`,
    defaultMessage: 'Un problème à bord ou au contrôle',
    en: 'A problem on board or at the ticket check',
    it: 'Un problema a bordo o al controllo',
    es: 'Un problema a bordo o en el control',
    de: 'Ein Problem an Bord oder bei der Kontrolle',
    nl: 'Een probleem aan boord of bij de controle',
  },
  optionPaymentDeclined: {
    id: `${supportV2Scope}.optionPaymentDeclined`,
    defaultMessage: 'Mon paiement a été refusé',
    en: 'My payment was declined',
    it: 'Il mio pagamento è stato rifiutato',
    es: 'Mi pago fue rechazado',
    de: 'Meine Zahlung wurde abgelehnt',
    nl: 'Mijn betaling is geweigerd',
  },
  optionPersonalData: {
    id: `${supportV2Scope}.optionPersonalData`,
    defaultMessage:
      "Mon email est utilisé par quelqu'un d'autre, ou question sur mes données",
    en: 'My email is used by someone else, or a question about my data',
    it: "La mia email è usata da un'altra persona, o domanda sui miei dati",
    es: 'Otra persona usa mi correo, o tengo una pregunta sobre mis datos',
    de: 'Meine E-Mail wird von jemand anderem genutzt, oder Frage zu meinen Daten',
    nl: 'Mijn e-mail wordt door iemand anders gebruikt, of vraag over mijn gegevens',
  },
  optionPets: {
    id: `${supportV2Scope}.optionPets`,
    defaultMessage: 'Voyager avec un animal',
    en: 'Travel with a pet',
    it: 'Viaggiare con un animale',
    es: 'Viajar con un animal',
    de: 'Mit einem Tier reisen',
    nl: 'Reizen met een huisdier',
  },
  optionPrepareTrip: {
    id: `${supportV2Scope}.optionPrepareTrip`,
    defaultMessage: 'Préparer mon voyage (bagages, animaux, gares…)',
    en: 'Preparing my trip (luggage, pets, stations…)',
    it: 'Preparare il viaggio (bagagli, animali, stazioni…)',
    es: 'Preparar mi viaje (equipaje, animales, estaciones…)',
    de: 'Meine Reise vorbereiten (Gepäck, Tiere, Bahnhöfe…)',
    nl: 'Mijn reis voorbereiden (bagage, huisdieren, stations…)',
  },
  optionPresoldNotIssued: {
    id: `${supportV2Scope}.optionPresoldNotIssued`,
    defaultMessage: "Mon billet n'est pas encore émis (prévente)",
    en: "My ticket isn't issued yet (pre-sale)",
    it: 'Il mio biglietto non è ancora emesso (prevendita)',
    es: 'Mi billete aún no se ha emitido (preventa)',
    de: 'Mein Ticket ist noch nicht ausgestellt (Vorverkauf)',
    nl: 'Mijn ticket is nog niet uitgegeven (voorverkoop)',
  },
  optionPriceChanged: {
    id: `${supportV2Scope}.optionPriceChanged`,
    defaultMessage: 'Le prix a changé',
    en: 'The price changed',
    it: 'Il prezzo è cambiato',
    es: 'El precio ha cambiado',
    de: 'Der Preis hat sich geändert',
    nl: 'De prijs is veranderd',
  },
  optionPriceDifference: {
    id: `${supportV2Scope}.optionPriceDifference`,
    defaultMessage: 'Le prix payé ne correspond pas au billet',
    en: "The price I paid doesn't match the ticket",
    it: 'Il prezzo pagato non corrisponde al biglietto',
    es: 'El precio pagado no coincide con el billete',
    de: 'Der gezahlte Preis stimmt nicht mit dem Ticket überein',
    nl: 'De betaalde prijs komt niet overeen met het ticket',
  },
  optionReceiptOnly: {
    id: `${supportV2Scope}.optionReceiptOnly`,
    defaultMessage: 'Un reçu de paiement seulement',
    en: 'Only a payment receipt',
    it: 'Solo una ricevuta di pagamento',
    es: 'Solo un recibo de pago',
    de: 'Nur eine Zahlungsbestätigung',
    nl: 'Alleen een betalingsbewijs',
  },
  optionRefundCompensationInvoice: {
    id: `${supportV2Scope}.optionRefundCompensationInvoice`,
    defaultMessage: 'Un remboursement, une indemnisation ou une facture',
    en: 'A refund, compensation or invoice',
    it: 'Un rimborso, un indennizzo o una fattura',
    es: 'Un reembolso, una indemnización o una factura',
    de: 'Eine Erstattung, Entschädigung oder Rechnung',
    nl: 'Een terugbetaling, schadevergoeding of factuur',
  },
  optionRefundDisputed: {
    id: `${supportV2Scope}.optionRefundDisputed`,
    defaultMessage: 'Le montant remboursé ne me convient pas',
    en: 'I disagree with the refunded amount',
    it: "L'importo rimborsato non mi convince",
    es: 'No estoy de acuerdo con el importe reembolsado',
    de: 'Ich bin mit dem erstatteten Betrag nicht einverstanden',
    nl: 'Ik ben het niet eens met het terugbetaalde bedrag',
  },
  optionRefundMethod: {
    id: `${supportV2Scope}.optionRefundMethod`,
    defaultMessage: 'Question sur le moyen de remboursement ou un avoir',
    en: 'Question about the refund method or a credit note',
    it: 'Domanda sul metodo di rimborso o un buono',
    es: 'Pregunta sobre el método de reembolso o un vale',
    de: 'Frage zur Erstattungsart oder zu einer Gutschrift',
    nl: 'Vraag over de terugbetaalmethode of een tegoed',
  },
  optionRefundPending: {
    id: `${supportV2Scope}.optionRefundPending`,
    defaultMessage: "Je n'ai pas encore été remboursé",
    en: "I haven't been refunded yet",
    it: 'Non sono ancora stato rimborsato',
    es: 'Aún no me han reembolsado',
    de: 'Ich habe noch keine Erstattung erhalten',
    nl: 'Ik ben nog niet terugbetaald',
  },
  optionRequestFollowup: {
    id: `${supportV2Scope}.optionRequestFollowup`,
    defaultMessage: 'Suivre une demande déjà envoyée',
    en: 'Follow up a request I already sent',
    it: 'Seguire una richiesta già inviata',
    es: 'Seguir una solicitud ya enviada',
    de: 'Eine bereits gesendete Anfrage verfolgen',
    nl: 'Een eerder verstuurd verzoek opvolgen',
  },
  optionRouteMissing: {
    id: `${supportV2Scope}.optionRouteMissing`,
    defaultMessage: "Un trajet ou un transporteur n'apparaît pas",
    en: "A route or carrier doesn't show up",
    it: 'Una tratta o un vettore non compare',
    es: 'No aparece un trayecto o un transportista',
    de: 'Eine Strecke oder ein Verkehrsunternehmen wird nicht angezeigt',
    nl: 'Een traject of vervoerder verschijnt niet',
  },
  optionScheduleChanged: {
    id: `${supportV2Scope}.optionScheduleChanged`,
    defaultMessage: "L'horaire a changé mais pas mon billet",
    en: "The schedule changed but my ticket didn't",
    it: "L'orario è cambiato ma il biglietto no",
    es: 'El horario cambió pero mi billete no',
    de: 'Der Fahrplan hat sich geändert, mein Ticket aber nicht',
    nl: 'De dienstregeling is gewijzigd, maar mijn ticket niet',
  },
  optionSeats: {
    id: `${supportV2Scope}.optionSeats`,
    defaultMessage: 'Places, classe ou sièges côte à côte',
    en: 'Seats, class or sitting together',
    it: 'Posti, classe o posti vicini',
    es: 'Plazas, clase o asientos juntos',
    de: 'Plätze, Klasse oder nebeneinander sitzen',
    nl: 'Plaatsen, klasse of naast elkaar zitten',
  },
  optionSeatsAndOptions: {
    id: `${supportV2Scope}.optionSeatsAndOptions`,
    defaultMessage: 'Places, classe et options',
    en: 'Seats, class and options',
    it: 'Posti, classe e opzioni',
    es: 'Plazas, clase y opciones',
    de: 'Plätze, Klasse und Optionen',
    nl: 'Plaatsen, klasse en opties',
  },
  optionServiceMissing: {
    id: `${supportV2Scope}.optionServiceMissing`,
    defaultMessage: "Une prestation payée n'a pas été fournie",
    en: "A service I paid for wasn't provided",
    it: 'Un servizio pagato non è stato fornito',
    es: 'No se prestó un servicio que pagué',
    de: 'Eine bezahlte Leistung wurde nicht erbracht',
    nl: 'Een betaalde dienst is niet geleverd',
  },
  optionSoldOut: {
    id: `${supportV2Scope}.optionSoldOut`,
    defaultMessage: 'Le trajet est complet',
    en: 'The trip is sold out',
    it: 'La tratta è al completo',
    es: 'El trayecto está completo',
    de: 'Die Fahrt ist ausgebucht',
    nl: 'De rit is volgeboekt',
  },
  optionStationTransfer: {
    id: `${supportV2Scope}.optionStationTransfer`,
    defaultMessage: "Me rendre d'une gare à l'autre",
    en: 'Get from one station to another',
    it: "Spostarmi da una stazione all'altra",
    es: 'Ir de una estación a otra',
    de: 'Von einem Bahnhof zum anderen gelangen',
    nl: 'Van het ene station naar het andere gaan',
  },
  optionStations: {
    id: `${supportV2Scope}.optionStations`,
    defaultMessage: 'Gares, arrêts et correspondances',
    en: 'Stations, stops and connections',
    it: 'Stazioni, fermate e coincidenze',
    es: 'Estaciones, paradas y conexiones',
    de: 'Bahnhöfe, Haltestellen und Anschlüsse',
    nl: 'Stations, haltes en overstappen',
  },
  optionSwapTraveller: {
    id: `${supportV2Scope}.optionSwapTraveller`,
    defaultMessage: 'Remplacer un voyageur par un autre',
    en: 'Replace one traveller with another',
    it: 'Sostituire un viaggiatore con un altro',
    es: 'Sustituir a un viajero por otro',
    de: 'Einen Reisenden durch einen anderen ersetzen',
    nl: 'Een reiziger door een ander vervangen',
  },
  optionTicketMismatch: {
    id: `${supportV2Scope}.optionTicketMismatch`,
    defaultMessage: 'Mon billet ne correspond pas à ma réservation',
    en: "My ticket doesn't match my booking",
    it: 'Il biglietto non corrisponde alla mia prenotazione',
    es: 'Mi billete no coincide con mi reserva',
    de: 'Mein Ticket passt nicht zu meiner Buchung',
    nl: 'Mijn ticket komt niet overeen met mijn boeking',
  },
  optionTicketProblem: {
    id: `${supportV2Scope}.optionTicketProblem`,
    defaultMessage: 'Mon billet est introuvable ou refusé',
    en: "I can't find my ticket, or it was refused",
    it: 'Non trovo il biglietto, o è stato rifiutato',
    es: 'No encuentro mi billete, o fue rechazado',
    de: 'Ich finde mein Ticket nicht, oder es wurde abgelehnt',
    nl: 'Ik vind mijn ticket niet, of het werd geweigerd',
  },
  optionTicketRefused: {
    id: `${supportV2Scope}.optionTicketRefused`,
    defaultMessage: 'Mon billet a été refusé au contrôle',
    en: 'My ticket was refused at the ticket check',
    it: 'Il biglietto è stato rifiutato al controllo',
    es: 'Mi billete fue rechazado en el control',
    de: 'Mein Ticket wurde bei der Kontrolle abgelehnt',
    nl: 'Mijn ticket werd geweigerd bij de controle',
  },
  optionTicketsNotReceived: {
    id: `${supportV2Scope}.optionTicketsNotReceived`,
    defaultMessage: "Je n'ai reçu aucun billet",
    en: "I haven't received any ticket",
    it: 'Non ho ricevuto nessun biglietto',
    es: 'No he recibido ningún billete',
    de: 'Ich habe kein Ticket erhalten',
    nl: 'Ik heb geen enkel ticket ontvangen',
  },
  optionTravellerDetailsWrong: {
    id: `${supportV2Scope}.optionTravellerDetailsWrong`,
    defaultMessage: "Le nom ou la date de naissance d'un voyageur",
    en: "A traveller's name or date of birth",
    it: 'Il nome o la data di nascita di un viaggiatore',
    es: 'El nombre o la fecha de nacimiento de un viajero',
    de: 'Name oder Geburtsdatum eines Reisenden',
    nl: 'De naam of geboortedatum van een reiziger',
  },
  optionTripDetailsWrong: {
    id: `${supportV2Scope}.optionTripDetailsWrong`,
    defaultMessage: "Le trajet, la gare, la classe ou l'horaire",
    en: 'The route, station, class or time',
    it: "La tratta, la stazione, la classe o l'orario",
    es: 'El trayecto, la estación, la clase o el horario',
    de: 'Strecke, Bahnhof, Klasse oder Uhrzeit',
    nl: 'Het traject, station, de klasse of tijd',
  },
  optionTripWithoutNumber: {
    id: `${supportV2Scope}.optionTripWithoutNumber`,
    defaultMessage: "Un voyage réservé, mais je n'ai pas le numéro de commande",
    en: "A booked trip, but I don't have the order number",
    it: "Un viaggio prenotato, ma non ho il numero d'ordine",
    es: 'Un viaje reservado, pero no tengo el número de pedido',
    de: 'Eine gebuchte Reise, aber ich habe die Bestellnummer nicht',
    nl: 'Een geboekte reis, maar ik heb het bestelnummer niet',
  },
  optionVoucherQuestion: {
    id: `${supportV2Scope}.optionVoucherQuestion`,
    defaultMessage: "Une question sur le bon ou l'avoir reçu",
    en: 'A question about the voucher or credit I received',
    it: 'Una domanda sul buono ricevuto',
    es: 'Una pregunta sobre el bono o vale recibido',
    de: 'Eine Frage zum erhaltenen Gutschein',
    nl: 'Een vraag over de ontvangen tegoedbon',
  },
  optionVoucherUnusable: {
    id: `${supportV2Scope}.optionVoucherUnusable`,
    defaultMessage: 'Je ne peux pas utiliser un bon ou une compensation',
    en: "I can't use a voucher or compensation",
    it: 'Non riesco a usare un buono o una compensazione',
    es: 'No puedo usar un bono o una compensación',
    de: 'Ich kann einen Gutschein oder eine Entschädigung nicht einlösen',
    nl: 'Ik kan een tegoedbon of compensatie niet gebruiken',
  },
  optionWantToCancel: {
    id: `${supportV2Scope}.optionWantToCancel`,
    defaultMessage: 'Je veux annuler',
    en: 'I want to cancel',
    it: 'Voglio annullare',
    es: 'Quiero cancelar',
    de: 'Ich möchte stornieren',
    nl: 'Ik wil annuleren',
  },
  optionWrongEmail: {
    id: `${supportV2Scope}.optionWrongEmail`,
    defaultMessage: "J'ai peut-être fait une erreur dans mon email",
    en: 'I may have mistyped my email',
    it: 'Forse ho sbagliato la mia email',
    es: 'Puede que me equivocara en mi correo',
    de: 'Ich habe mich vielleicht bei meiner E-Mail vertippt',
    nl: 'Ik heb mijn e-mail misschien verkeerd getypt',
  },
  answerAttemptedAction: {
    id: `${supportV2Scope}.answerAttemptedAction`,
    defaultMessage: 'Ce que vous avez essayé de faire',
    en: 'What you tried to do',
    it: 'Cosa hai provato a fare',
    es: 'Lo que intentaste hacer',
    de: 'Was Sie versucht haben',
    nl: 'Wat u probeerde te doen',
  },
  answerStep: {
    id: `${supportV2Scope}.answerStep`,
    defaultMessage: 'Étape où cela bloque',
    en: 'Step where it fails',
    it: 'Passaggio in cui si blocca',
    es: 'Paso en el que se bloquea',
    de: 'Schritt, bei dem es hakt',
    nl: 'Stap waar het misgaat',
  },
  answerErrorMessage: {
    id: `${supportV2Scope}.answerErrorMessage`,
    defaultMessage: "Message d'erreur affiché",
    en: 'Error message shown',
    it: 'Messaggio di errore visualizzato',
    es: 'Mensaje de error mostrado',
    de: 'Angezeigte Fehlermeldung',
    nl: 'Getoonde foutmelding',
  },
  answerChargesKind: {
    id: `${supportV2Scope}.answerChargesKind`,
    defaultMessage:
      'Plusieurs réservations du même voyage, ou plusieurs débits pour une seule réservation ?',
    en: 'Several bookings of the same trip, or several charges for one booking?',
    it: 'Più prenotazioni dello stesso viaggio o più addebiti per una sola prenotazione?',
    es: '¿Varias reservas del mismo viaje o varios cobros por una sola reserva?',
    de: 'Mehrere Buchungen derselben Reise oder mehrere Abbuchungen für eine Buchung?',
    nl: 'Meerdere boekingen van dezelfde reis, of meerdere afschrijvingen voor één boeking?',
  },
  answerReferences: {
    id: `${supportV2Scope}.answerReferences`,
    defaultMessage: 'Références dont vous disposez',
    en: 'References you have',
    it: 'Riferimenti di cui disponi',
    es: 'Referencias de las que dispones',
    de: 'Ihnen vorliegende Referenzen',
    nl: 'Referenties die u heeft',
  },
  answerAmounts: {
    id: `${supportV2Scope}.answerAmounts`,
    defaultMessage: 'Montants concernés',
    en: 'Amounts involved',
    it: 'Importi interessati',
    es: 'Importes afectados',
    de: 'Betroffene Beträge',
    nl: 'Betrokken bedragen',
  },
  answerChargeDates: {
    id: `${supportV2Scope}.answerChargeDates`,
    defaultMessage: 'Dates des débits',
    en: 'Dates of the charges',
    it: 'Date degli addebiti',
    es: 'Fechas de los cobros',
    de: 'Daten der Abbuchungen',
    nl: 'Data van de afschrijvingen',
  },
  answerCostKind: {
    id: `${supportV2Scope}.answerCostKind`,
    defaultMessage: 'Nature des frais (hôtel, taxi, nouveau billet…)',
    en: 'Type of expense (hotel, taxi, new ticket…)',
    it: 'Tipo di spesa (hotel, taxi, nuovo biglietto…)',
    es: 'Tipo de gasto (hotel, taxi, billete nuevo…)',
    de: 'Art der Kosten (Hotel, Taxi, neues Ticket…)',
    nl: 'Soort kosten (hotel, taxi, nieuw ticket…)',
  },
  answerCostAmount: {
    id: `${supportV2Scope}.answerCostAmount`,
    defaultMessage: 'Montant des frais',
    en: 'Amount of the expenses',
    it: 'Importo delle spese',
    es: 'Importe de los gastos',
    de: 'Höhe der Kosten',
    nl: 'Bedrag van de kosten',
  },
  answerInvoiceType: {
    id: `${supportV2Scope}.answerInvoiceType`,
    defaultMessage:
      'Document recherché (facture, justificatif de paiement ou de remboursement)',
    en: 'Document needed (invoice, proof of payment or of refund)',
    it: 'Documento richiesto (fattura, ricevuta di pagamento o di rimborso)',
    es: 'Documento que necesitas (factura, justificante de pago o de reembolso)',
    de: 'Gewünschtes Dokument (Rechnung, Zahlungs- oder Erstattungsbeleg)',
    nl: 'Gewenst document (factuur, betalings- of terugbetalingsbewijs)',
  },
  answerBillingIdentity: {
    id: `${supportV2Scope}.answerBillingIdentity`,
    defaultMessage: 'Nom à faire figurer sur le document',
    en: 'Name to show on the document',
    it: 'Nome da riportare sul documento',
    es: 'Nombre que debe figurar en el documento',
    de: 'Name auf dem Dokument',
    nl: 'Naam op het document',
  },
  answerCompanyName: {
    id: `${supportV2Scope}.answerCompanyName`,
    defaultMessage: 'Raison sociale (entreprise)',
    en: 'Company name',
    it: 'Ragione sociale (azienda)',
    es: 'Razón social (empresa)',
    de: 'Firmenname',
    nl: 'Bedrijfsnaam',
  },
  answerCompanyId: {
    id: `${supportV2Scope}.answerCompanyId`,
    defaultMessage: 'SIREN ou numéro de TVA (entreprise)',
    en: 'Company or VAT number',
    it: 'Partita IVA (azienda)',
    es: 'NIF o número de IVA (empresa)',
    de: 'Handelsregister- oder USt-IdNr. (Unternehmen)',
    nl: 'KvK- of btw-nummer (bedrijf)',
  },
  answerCompanyAddress: {
    id: `${supportV2Scope}.answerCompanyAddress`,
    defaultMessage: 'Adresse de facturation',
    en: 'Billing address',
    it: 'Indirizzo di fatturazione',
    es: 'Dirección de facturación',
    de: 'Rechnungsadresse',
    nl: 'Factuuradres',
  },
  answerCardIssuer: {
    id: `${supportV2Scope}.answerCardIssuer`,
    defaultMessage: 'Émetteur (SNCF, Trenitalia…)',
    en: 'Issuer (SNCF, Trenitalia…)',
    it: 'Emittente (SNCF, Trenitalia…)',
    es: 'Emisor (SNCF, Trenitalia…)',
    de: 'Aussteller (SNCF, Trenitalia…)',
    nl: 'Uitgever (SNCF, Trenitalia…)',
  },
  answerCardType: {
    id: `${supportV2Scope}.answerCardType`,
    defaultMessage: 'Type de carte ou de bon',
    en: 'Type of card or voucher',
    it: 'Tipo di carta o di buono',
    es: 'Tipo de tarjeta o bono',
    de: 'Art der Karte oder des Gutscheins',
    nl: 'Soort kaart of tegoedbon',
  },
  answerCardPurchaseDate: {
    id: `${supportV2Scope}.answerCardPurchaseDate`,
    defaultMessage: "Date d'achat",
    en: 'Purchase date',
    it: 'Data di acquisto',
    es: 'Fecha de compra',
    de: 'Kaufdatum',
    nl: 'Aankoopdatum',
  },
  answerCardReference: {
    id: `${supportV2Scope}.answerCardReference`,
    defaultMessage: 'Référence de la carte ou du bon',
    en: 'Card or voucher reference',
    it: 'Riferimento della carta o del buono',
    es: 'Referencia de la tarjeta o del bono',
    de: 'Referenz der Karte oder des Gutscheins',
    nl: 'Referentie van de kaart of tegoedbon',
  },
  answerOtherSegmentsState: {
    id: `${supportV2Scope}.answerOtherSegmentsState`,
    defaultMessage: 'Avez-vous reçu les billets des autres trajets ?',
    en: 'Did you receive the tickets for the other parts of the trip?',
    it: 'Hai ricevuto i biglietti delle altre tratte?',
    es: '¿Has recibido los billetes de los otros trayectos?',
    de: 'Haben Sie die Tickets für die anderen Fahrten erhalten?',
    nl: 'Heeft u de tickets voor de andere ritten ontvangen?',
  },
  answerDepartureTime: {
    id: `${supportV2Scope}.answerDepartureTime`,
    defaultMessage: 'Trajet et heure concernés',
    en: 'Trip and time concerned',
    it: 'Tratta e orario interessati',
    es: 'Trayecto y hora afectados',
    de: 'Betroffene Fahrt und Uhrzeit',
    nl: 'Betrokken rit en tijd',
  },
  answerDesiredChange: {
    id: `${supportV2Scope}.answerDesiredChange`,
    defaultMessage: 'Ce que vous souhaitez changer',
    en: 'What you would like to change',
    it: 'Cosa vorresti cambiare',
    es: 'Qué te gustaría cambiar',
    de: 'Was Sie ändern möchten',
    nl: 'Wat u wilt wijzigen',
  },
  answerCorrectValue: {
    id: `${supportV2Scope}.answerCorrectValue`,
    defaultMessage: 'Information correcte',
    en: 'Correct information',
    it: 'Informazione corretta',
    es: 'Información correcta',
    de: 'Richtige Angabe',
    nl: 'Juiste gegevens',
  },
  answerHonorStatement: {
    id: `${supportV2Scope}.answerHonorStatement`,
    defaultMessage:
      'J’atteste sur l’honneur ne pas avoir utilisé ce billet et ne pas l’utiliser. Si le billet est utilisé, Tictactrip pourra reprendre le remboursement.',
    en: 'I declare on my honour that I have not used this ticket and will not use it. If the ticket is used, Tictactrip may take the refund back.',
    it: 'Dichiaro sul mio onore di non aver utilizzato questo biglietto e di non utilizzarlo. Se il biglietto viene utilizzato, Tictactrip potrà riprendere il rimborso.',
    es: 'Declaro bajo mi honor que no he utilizado este billete y que no lo utilizaré. Si el billete se utiliza, Tictactrip podrá recuperar el reembolso.',
    de: 'Ich versichere ehrenwörtlich, dieses Ticket nicht benutzt zu haben und nicht zu benutzen. Wird das Ticket benutzt, kann Tictactrip die Erstattung zurückfordern.',
    nl: 'Ik verklaar op erewoord dat ik dit ticket niet heb gebruikt en niet zal gebruiken. Als het ticket wordt gebruikt, kan Tictactrip de terugbetaling terugvorderen.',
  },
  honorStatementRequired: {
    id: `${supportV2Scope}.honorStatementRequired`,
    defaultMessage: 'Cochez l’attestation pour envoyer votre demande',
    en: 'Tick the statement to send your request',
    it: 'Spunta la dichiarazione per inviare la tua richiesta',
    es: 'Marca la declaración para enviar tu solicitud',
    de: 'Kreuzen Sie die Erklärung an, um Ihre Anfrage zu senden',
    nl: 'Vink de verklaring aan om uw verzoek te versturen',
  },
  descriptionOptional: {
    id: `${supportV2Scope}.descriptionOptional`,
    defaultMessage: 'Votre message (facultatif)',
    en: 'Your message (optional)',
    it: 'Il tuo messaggio (facoltativo)',
    es: 'Tu mensaje (opcional)',
    de: 'Ihre Nachricht (optional)',
    nl: 'Uw bericht (optioneel)',
  },
};

export default defineMessages(supportV2Messages);
